
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2m4WS", function(module, exports) {

var $3hHGU = parcelRequire("3hHGU");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $jMyy4 = parcelRequire("jMyy4");


var $jpSPX = parcelRequire("jpSPX");


var $eiWUW = parcelRequire("eiWUW");

/* SmartSpaceOverview.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $cO1el = parcelRequire("cO1el");


var $dcJ7R = parcelRequire("dcJ7R");


var $lQS7C = parcelRequire("lQS7C");


var $e6lna = parcelRequire("e6lna");


var $ep3mz = parcelRequire("ep3mz");


var $8rneB = parcelRequire("8rneB");


var $ixL26 = parcelRequire("ixL26");





var $dhfse = parcelRequire("dhfse");

/**
 * @generated SignedSource<<3be6c7d8adc4820cbeac8c3df1b8d055>>
 * @relayHash ec77e57f60aaa31511bd727f2f353f97
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd67ab74ba5b62e13ff5bd07bf1e02e64d32c6fffd623189814a572eb7d29d3f
const $74b7cbd9cf0b5f49$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SmartSpaceOverviewCoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SmartSpaceOverviewCoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "ec77e57f60aaa31511bd727f2f353f97",
            "id": "fd67ab74ba5b62e13ff5bd07bf1e02e64d32c6fffd623189814a572eb7d29d3f",
            "metadata": {},
            "name": "SmartSpaceOverviewCoverPictureQuery",
            "operationKind": "query",
            "text": "query SmartSpaceOverviewCoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$74b7cbd9cf0b5f49$var$node.hash = "890c0d7ea56280006fd23fc1dd1199b3";
var $74b7cbd9cf0b5f49$export$2e2bcd8739ae039 = $74b7cbd9cf0b5f49$var$node;









var $jPACe = parcelRequire("jPACe");


var $3WPGR = parcelRequire("3WPGR");


var $bKd7w = parcelRequire("bKd7w");


var $3oWMY = parcelRequire("3oWMY");




const $b9c2fb682b28c513$var$SmartSpaceOverviewCoverPictureQuery = (0, $74b7cbd9cf0b5f49$export$2e2bcd8739ae039);
const $b9c2fb682b28c513$var$SMART_SPACE_OVERVIEW_COVER_IMAGE_HEIGHT = 200;
const $b9c2fb682b28c513$export$4c3aaf664391b8c5 = ({ contentId: contentId, isAdmin: isAdmin, hasEmoji: hasEmoji })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { data: data } = (0, $jMyy4.useQueryInterop)($b9c2fb682b28c513$var$SmartSpaceOverviewCoverPictureQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        __callerPackage__: "@confluence/space-overview"
    });
    const { coverPicture: coverPicture, contentAppearance: contentAppearance, hasCoverPicture: hasPublishedCoverPicture } = (0, $3WPGR.getRendererCoverPictureInfo)(data, false);
    const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
    const draftCoverPicture = (0, $3WPGR.propertyToId)(properties.find((property)=>property?.key === (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT));
    const hasDraftCoverPicture = !!draftCoverPicture?.value?.id;
    const hasCoverPicture = hasDraftCoverPicture || hasPublishedCoverPicture;
    const hasRenderableCoverPicture = isAdmin ? hasCoverPicture : hasPublishedCoverPicture;
    const content = isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jPACe.EditorPageCoverPictureEntry), {
        key: `${contentId}-${hasCoverPicture ? 'filled' : 'empty'}`,
        contentId: contentId,
        isPublishingContent: false,
        contentType: "page",
        userOffline: false,
        hasCoverPicture: hasCoverPicture,
        contentPropertyKey: hasDraftCoverPicture ? (0, $bKd7w.CoverPictureIdPropertyKey).DRAFT : (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED,
        isSmartSpaceOverview: true,
        isUnpublishedDraft: false,
        isReadOnly: false,
        dynamicCoverImageHeight: $b9c2fb682b28c513$var$SMART_SPACE_OVERVIEW_COVER_IMAGE_HEIGHT
    }) : hasPublishedCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3oWMY.RendererPageCoverPicture), {
        contentId: contentId,
        isPagePreview: false,
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        isSmartSpaceOverview: true,
        hasEmoji: hasEmoji
    }) : null;
    if (!hasRenderableCoverPicture) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>setIsHovered(true),
        onBlur: ()=>setIsHovered(false),
        className: (0, $gMc0m.default)([
            $b9c2fb682b28c513$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "space-overview-cover-placeholder",
        className: (0, $gMc0m.default)([
            $b9c2fb682b28c513$var$styles.placeholder
        ])
    }, content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b9c2fb682b28c513$var$styles.placeholderContent,
            isHovered && $b9c2fb682b28c513$var$styles.placeholderContentVisible
        ])
    }, content)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        className: (0, $gMc0m.default)([
            $b9c2fb682b28c513$var$styles.root
        ])
    }, content);
};
const $b9c2fb682b28c513$var$styles = {
    root: "_kqswh2mm _7cca15wb _4t3iuuw1",
    placeholder: "_1r04idpf _2rkopb1k _kqswstnw _1e0c1txw _1bah1h6o _4cvr1h6o _1itk1tbc",
    placeholderContent: "_v564m7ou _tzy4idpf",
    placeholderContentVisible: "_tzy4kb7n"
};


/**
 * @generated SignedSource<<058c0132e1b45dda98946cbb681be723>>
 * @relayHash 7ed1e317e90fc777adf227a379521cab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6dff29da4655f295cb5e263cd8e3e356822a1c949d5f9a9a278f3dd4f2922eb7
const $97dc1b18f616085f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
            "kind": "LinkedField",
            "name": "confluence_updateSmartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverview",
                    "kind": "LinkedField",
                    "name": "overview",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewSummary",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "body"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartSpaceOverviewSummaryUpdateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartSpaceOverviewSummaryUpdateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7ed1e317e90fc777adf227a379521cab",
            "id": "6dff29da4655f295cb5e263cd8e3e356822a1c949d5f9a9a278f3dd4f2922eb7",
            "metadata": {},
            "name": "SmartSpaceOverviewSummaryUpdateMutation",
            "operationKind": "mutation",
            "text": "mutation SmartSpaceOverviewSummaryUpdateMutation($cloudId:ID!,$input:ConfluenceUpdateSmartSpaceOverviewInput!){confluence_updateSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{summary{body}}}}"
        }
    };
}();
$97dc1b18f616085f$var$node.hash = "c07da228d9ec183b11eb802e583c9e4e";
var $97dc1b18f616085f$export$2e2bcd8739ae039 = $97dc1b18f616085f$var$node;









var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $cvXh8 = parcelRequire("cvXh8");


var $hmuev = parcelRequire("hmuev");


var $1Zr9M = parcelRequire("1Zr9M");


var $d8ohW = parcelRequire("d8ohW");


var $9FnLD = parcelRequire("9FnLD");


var $9zIwY = parcelRequire("9zIwY");


var $3sFtD = parcelRequire("3sFtD");


var $9EtP6 = parcelRequire("9EtP6");


var $3gadb = parcelRequire("3gadb");


var $dpPtd = parcelRequire("dpPtd");





var $9wGTI = parcelRequire("9wGTI");


var $308Wd = parcelRequire("308Wd");


var $86okN = parcelRequire("86okN");





var $2m4WS = parcelRequire("2m4WS");




function $75b7ce46cf4dcbf4$export$95779ae96ff09d4a({ durationMs: durationMs = 2000 } = {}) {
    const timeoutRef = (0, $42omo.useRef)(null);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        return function cleanup() {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    function startLoading() {
        setIsLoading(true);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            setIsLoading(false);
        }, durationMs);
    }
    return [
        startLoading,
        isLoading
    ];
}


const $d3f4a8c5a2c21120$var$SmartSpaceOverviewSummaryViewInner = ({ body: body, spaceKey: spaceKey, isPinned: isPinned, onSave: onSave })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isEditing, setIsEditing] = (0, $42omo.useState)(false);
    const [editText, setEditText] = (0, $42omo.useState)(body);
    const [vote, setVote] = (0, $42omo.useState)(null);
    const [startRefresh, isRefreshing] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const handleMouseEnter = (0, $42omo.useCallback)(()=>setIsHovered(true), []);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>setIsHovered(false), []);
    const showFeedbackFlag = (0, $42omo.useCallback)(()=>{
        showFlag({
            title: formatMessage($d3f4a8c5a2c21120$var$i18n.feedbackFlagTitle),
            description: formatMessage($d3f4a8c5a2c21120$var$i18n.feedbackFlagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    }, [
        showFlag,
        formatMessage
    ]);
    const fireFeedbackEvent = (0, $42omo.useCallback)((wasHelpful)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'submitted',
                actionSubject: 'feedback',
                actionSubjectId: 'summary',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'summary',
                    spaceKey: spaceKey,
                    wasHelpful: wasHelpful,
                    isPinned: isPinned
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey,
        isPinned
    ]);
    const fireEditedEvent = (0, $42omo.useCallback)((previousBody, newBody)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'edited',
                actionSubject: 'text',
                actionSubjectId: 'summary',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'summary',
                    spaceKey: spaceKey,
                    previousSummaryLength: previousBody.length,
                    newSummaryLength: newBody.length,
                    isPinned: isPinned
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey,
        isPinned
    ]);
    const handleThumbsUp = (0, $42omo.useCallback)(()=>{
        setVote('up');
        showFeedbackFlag();
        fireFeedbackEvent(true);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleThumbsDown = (0, $42omo.useCallback)(()=>{
        setVote('down');
        showFeedbackFlag();
        fireFeedbackEvent(false);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleRefresh = (0, $42omo.useCallback)(()=>{
        setVote(null);
        startRefresh();
    }, [
        startRefresh
    ]);
    const onEdit = (0, $42omo.useCallback)(()=>{
        setEditText(body);
        setIsEditing(true);
    }, [
        body
    ]);
    const onConfirm = (0, $42omo.useCallback)(()=>{
        if (body !== editText) {
            fireEditedEvent(body, editText);
            onSave(editText);
        }
        setIsEditing(false);
    }, [
        body,
        editText,
        fireEditedEvent,
        onSave
    ]);
    const onCancel = (0, $42omo.useCallback)(()=>{
        setEditText(body);
        setIsEditing(false);
    }, [
        body
    ]);
    const onKeyDown = (0, $42omo.useCallback)((e)=>{
        if (e.key === 'Escape') onCancel();
    }, [
        onCancel
    ]);
    if (isEditing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "smart-space-overview-summary-edit",
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.editContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EtP6.default), {
        value: editText,
        onChange: (e)=>setEditText(e.target.value),
        onKeyDown: onKeyDown,
        minimumRows: 3,
        resize: "vertical",
        testId: "smart-space-overview-summary-edit-input"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.editActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.confirm)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.confirm),
        appearance: "default",
        onClick: onConfirm,
        testId: "smart-space-overview-summary-confirm-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.cancel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.cancel),
        appearance: "default",
        onClick: onCancel,
        testId: "smart-space-overview-summary-cancel-button"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "smart-space-overview-summary",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.summaryContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.summaryBody,
            "_vwz4qslr",
            isRefreshing && $d3f4a8c5a2c21120$var$styles.contentBlurred
        ])
    }, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            opacity: isHovered ? 1 : 0,
            pointerEvents: isHovered ? 'auto' : 'none'
        },
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.actionsContainer,
            "_v564m7ou"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $d3f4a8c5a2c21120$var$styles.actionsContent
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.edit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.edit),
        appearance: "subtle",
        spacing: "compact",
        onClick: onEdit,
        testId: "smart-space-overview-summary-edit-button"
    })), (0, $9wGTI.fg)('smart-space-overview-refresh') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage($d3f4a8c5a2c21120$var$i18n.refresh)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.refresh),
        appearance: "subtle",
        spacing: "compact",
        isLoading: isRefreshing,
        onClick: handleRefresh,
        testId: "smart-space-overview-summary-refresh-button"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                label: "",
                color: vote === 'up' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.thumbsUp),
        appearance: "subtle",
        spacing: "compact",
        isSelected: vote === 'up',
        isTooltipDisabled: false,
        onClick: ()=>{
            if (vote !== 'up') handleThumbsUp();
        },
        testId: "smart-space-overview-summary-thumbs-up-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
                label: "",
                color: vote === 'down' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage($d3f4a8c5a2c21120$var$i18n.thumbsDown),
        appearance: "subtle",
        spacing: "compact",
        isSelected: vote === 'down',
        isTooltipDisabled: false,
        onClick: ()=>{
            if (vote !== 'down') handleThumbsDown();
        },
        testId: "smart-space-overview-summary-thumbs-down-button"
    }))));
};
const $d3f4a8c5a2c21120$export$cb21a8674ed8fd22 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d3f4a8c5a2c21120$var$SmartSpaceOverviewSummaryViewInner, props));
const $d3f4a8c5a2c21120$export$54ca75a6425bb521 = ({ summaryData: summaryData, spaceKey: spaceKey })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const queryDocumentNode = (0, $86okN.toDocumentNode)((0, $2m4WS.SpaceOverviewSwitcherQuery));
    const [updateSummary] = (0, $308Wd.useMutationInterop)($d3f4a8c5a2c21120$var$UpdateSmartSpaceOverviewSummaryMutation, {
        __callerPackage__: "@confluence/space-overview"
    });
    const onSave = (0, $42omo.useCallback)((newBody)=>{
        updateSummary({
            variables: {
                cloudId: cloudId,
                input: {
                    spaceKey: spaceKey,
                    summary: {
                        body: newBody
                    }
                }
            },
            optimisticResponse: {
                confluence_updateSmartSpaceOverview: {
                    success: true,
                    errors: null,
                    overview: {
                        summary: {
                            body: newBody
                        }
                    }
                }
            },
            update: (cache, { data: mutationData })=>{
                const updatedBody = mutationData?.confluence_updateSmartSpaceOverview?.overview?.summary?.body;
                if (updatedBody == null) return;
                cache.writeQuery({
                    query: queryDocumentNode,
                    variables: {
                        cloudId: cloudId,
                        spaceKey: spaceKey
                    },
                    data: {
                        confluence_smartSpaceOverview: {
                            __typename: 'ConfluenceSmartSpaceOverview',
                            summary: {
                                __typename: 'ConfluenceSmartSpaceOverviewSummary',
                                body: updatedBody
                            }
                        }
                    }
                });
            }
        });
    }, [
        cloudId,
        spaceKey,
        updateSummary,
        queryDocumentNode
    ]);
    const body = summaryData?.body;
    if (!body) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d3f4a8c5a2c21120$export$cb21a8674ed8fd22, {
        body: body,
        spaceKey: spaceKey,
        isPinned: summaryData?.isPinned ?? false,
        onSave: onSave
    });
};
const $d3f4a8c5a2c21120$var$UpdateSmartSpaceOverviewSummaryMutation = (0, $97dc1b18f616085f$export$2e2bcd8739ae039);
const $d3f4a8c5a2c21120$var$i18n = (0, $aXWIB.defineMessages)({
    edit: {
        id: "space-overview.smart-space-overview.summary.edit",
        defaultMessage: "Edit"
    },
    confirm: {
        id: "space-overview.smart-space-overview.summary.confirm",
        defaultMessage: "Confirm"
    },
    cancel: {
        id: "space-overview.smart-space-overview.summary.cancel",
        defaultMessage: "Cancel"
    },
    refresh: {
        id: "space-overview.smart-space-overview.summary.refresh",
        defaultMessage: "Refresh"
    },
    thumbsUp: {
        id: "space-overview.smart-space-overview.summary.thumbs-up",
        defaultMessage: "Good summary"
    },
    thumbsDown: {
        id: "space-overview.smart-space-overview.summary.thumbs-down",
        defaultMessage: "Bad summary"
    },
    feedbackFlagTitle: {
        id: "space-overview.smart-space-overview.summary.feedback-flag-title",
        defaultMessage: "Thanks!"
    },
    feedbackFlagDescription: {
        id: "space-overview.smart-space-overview.summary.feedback-flag-description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    }
}); // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
const $d3f4a8c5a2c21120$var$summaryBodyLineHeightStyle = null;
const $d3f4a8c5a2c21120$var$actionsContainerTransitionStyle = null;
const $d3f4a8c5a2c21120$var$styles = {
    summaryContainer: "_kqswh2mm",
    summaryBody: "_11c8fhey _syazi7uo _o5721jtm",
    actionsContainer: "_1e0c1txw _kqswstnw _154iidpf _rjxpidpf _bozg1ejb _1itk13yu",
    actionsContent: "_1e0c1txw _4cvr1h6o _1n261q9c _1o9zidpf",
    editContainer: "_zulp1b66 _2rko1qi0 _1yt41b66 _1e0c1txw _2lx21bp4 _bfhksm61",
    editActions: "_zulp1b66 _1e0c1txw _1bahesu3 _4cvr1h6o",
    contentBlurred: "_v5641bup _tzy42wxo _lcxvglyw"
};


/* PopularQuestions.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $eyWa4 = parcelRequire("eyWa4");


var $i25hX = parcelRequire("i25hX");


var $jlIaF = parcelRequire("jlIaF");


var $1NBp8 = parcelRequire("1NBp8");





/* QuestionItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");








var $cOQz3 = parcelRequire("cOQz3");











var $fVUfS = parcelRequire("fVUfS");



var $iXCQx = parcelRequire("iXCQx");











/* FollowUpQuestions.tsx generated by @compiled/babel-plugin v0.36.1 */ 













const $b8b7b04208de7a0b$var$FollowUpButton = ({ followUp: followUp, followUpPosition: followUpPosition, onFollowUp: onFollowUp })=>{
    const handleClick = (0, $42omo.useCallback)(()=>{
        onFollowUp(followUp, followUpPosition);
    }, [
        onFollowUp,
        followUp,
        followUpPosition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $b8b7b04208de7a0b$var$styles.followUpButton,
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium",
        color: "color.text.subtle"
    }, followUp));
};
const $b8b7b04208de7a0b$export$9d9f2e3275d0d624 = ({ questions: questions, onFollowUp: onFollowUp })=>{
    if (questions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b8b7b04208de7a0b$var$styles.followUpContainer
        ])
    }, questions.map((followUp, index)=>followUp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b8b7b04208de7a0b$var$FollowUpButton, {
            key: followUp,
            followUp: followUp,
            followUpPosition: index,
            onFollowUp: onFollowUp
        }) : null));
};
const $b8b7b04208de7a0b$var$styles = {
    followUpContainer: "_zulpu2gc _1e0c1txw _1n261g80 _4cvrv2br",
    followUpButton: "_zulpu2gc _2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c116y _4cvr1h6o _1q51u2gc _85i5u2gc _bozgutpp _y4tiutpp _bfhk1j28 _80omtlke _y3gnv2br _irr31dpa"
};


/* RovoInput.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $lAFHW = parcelRequire("lAFHW");


var $euUgw = parcelRequire("euUgw");

const $bb5f5999bd84aada$export$995e9427a9b39595 = ({ onSend: onSend })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [value, setValue] = (0, $42omo.useState)('');
    const handleSend = (0, $42omo.useCallback)(()=>{
        if (value.trim()) {
            onSend(value.trim());
            setValue('');
        }
    }, [
        value,
        onSend
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSend();
        }
    }, [
        handleSend
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $bb5f5999bd84aada$var$styles.rovoInputContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $bb5f5999bd84aada$var$styles.rovoIcon
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
        size: "xsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        type: "text",
        placeholder: formatMessage($bb5f5999bd84aada$var$i18n.askRovoPlaceholder),
        value: value,
        onChange: (e)=>setValue(e.target.value),
        onKeyDown: handleKeyDown,
        className: (0, $gMc0m.default)([
            $bb5f5999bd84aada$var$styles.rovoInput
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
        label: formatMessage($bb5f5999bd84aada$var$i18n.sendQuestion),
        appearance: "primary",
        shape: "circle",
        isDisabled: !value.trim(),
        onClick: handleSend
    }));
};
const $bb5f5999bd84aada$var$i18n = (0, $aXWIB.defineMessages)({
    askRovoPlaceholder: {
        id: "space-overview.smart-space-overview.popular-questions.ask-rovo-placeholder",
        defaultMessage: "Ask Rovo anything"
    },
    sendQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.send-question",
        defaultMessage: "Send question"
    }
});
const $bb5f5999bd84aada$var$styles = {
    rovoInputContainer: "_zulpu2gc _2rkopb1k _1rjcutpp _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _bozgpxbi _y4tipxbi _bfhkvuon",
    rovoIcon: "_1o9zidpf _1e0c1txw _4cvr1h6o",
    rovoInput: "_16jlkb7n _1o9zkb7n _i0dlf1ug _12ji1r31 _1qu2glyw _12y31o36 _11c8fhey _189eidpf _bfhk1j28 _syazi7uo _1idr1rpy"
};


/* SourcesSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1Whri = parcelRequire("1Whri");








var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");








var $hpUsb = parcelRequire("hpUsb");

var $8zS2j = parcelRequire("8zS2j");

var $5znEc = parcelRequire("5znEc");





var $lsxnT = parcelRequire("lsxnT");





var $6M71K = parcelRequire("6M71K");


var $5d01x = parcelRequire("5d01x");

/* SourceItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $auNCB = parcelRequire("auNCB");











var $4Nwes = parcelRequire("4Nwes");



const $7781dafab97bcef1$var$iconOverrides = {
    Confluence: (0, $lAFHW.ConfluenceIcon),
    Jira: (0, $lAFHW.JiraIcon),
    Loom: (0, $lAFHW.LoomIcon),
    Bitbucket: (0, $lAFHW.BitbucketIcon),
    Goals: (0, $lAFHW.GoalsIcon),
    Projects: (0, $lAFHW.ProjectsIcon),
    Teams: (0, $lAFHW.TeamsIcon),
    Home: (0, $lAFHW.HomeIcon)
};
const $7781dafab97bcef1$export$aa172d33ca929727 = ({ url: url, completeKey: completeKey })=>{
    if (completeKey) {
        const IconOverride = $7781dafab97bcef1$var$iconOverrides[completeKey];
        if (IconOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconOverride, {
            size: "xxsmall",
            shouldUseNewLogoDesign: true
        });
    }
    if (!url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
        appearance: "neutral",
        label: "",
        size: "xxsmall"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 16 16",
        width: "16",
        height: "16",
        "aria-hidden": "true",
        "data-testid": "app-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
        id: "changeFillColor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0.02, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0.07, 0, 0, 0, 0, 0, 1, 0"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("image", {
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xlinkHref: url,
        width: "16",
        height: "16",
        x: "0",
        y: "0",
        filter: $7781dafab97bcef1$var$isSvg(url) ? 'url(#changeFillColor)' : ''
    }));
};
const $7781dafab97bcef1$var$isSvg = (url)=>{
    const fileType = url.split(/\#|\?/)[0].split('.').pop();
    return !!fileType && fileType.trim() === 'svg';
};


const $d05f38054d846c18$export$64eb96c340cb75b = ({ source: source })=>{
    const { title: title, links: links, embeddedProduct: embeddedProduct, excerpt: excerpt } = source.content ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.100"
    }, (0, $7781dafab97bcef1$export$aa172d33ca929727)({
        url: links?.webui,
        completeKey: embeddedProduct
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        weight: "regular",
        maxLines: 1
    }, title)), excerpt && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 2
    }, excerpt));
};
const $d05f38054d846c18$export$7432640a758da4b1 = ({ source: source })=>{
    const webui = source.content?.links?.webui;
    if (!webui) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d05f38054d846c18$export$64eb96c340cb75b, {
        source: source
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: webui,
        rel: "noopener noreferrer",
        xcss: $d05f38054d846c18$var$styles.noUnderline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d05f38054d846c18$export$64eb96c340cb75b, {
        source: source
    }));
};
const $d05f38054d846c18$var$styles = {
    noUnderline: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};


const $1f92641a13bcc754$export$99bd007203d2166e = ({ sources: sources, spaceKey: spaceKey, questionPosition: questionPosition })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const validSources = (0, $42omo.useMemo)(()=>sources.filter((source)=>source.content != null), [
        sources
    ]);
    const sourceUrls = (0, $42omo.useMemo)(()=>validSources.flatMap((source)=>{
            const webui = source.content?.links?.webui;
            return webui ? [
                `${window.location.origin}${(0, $jlIaF.CONTEXT_PATH)}${webui}`
            ] : [];
        }), [
        validSources
    ]);
    const fireSourcesEvent = (0, $42omo.useCallback)((action)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'popup',
                actionSubjectId: 'sources',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    sourceCount: validSources.length
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey,
        questionPosition,
        validSources
    ]);
    const handleToggle = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        setIsOpen((prev)=>{
            fireSourcesEvent(prev ? 'collapsed' : 'expanded');
            return !prev;
        });
    }, [
        fireSourcesEvent
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        fireSourcesEvent('collapsed');
    }, [
        fireSourcesEvent
    ]);
    if (validSources.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $1f92641a13bcc754$var$styles.triggerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Popup, {
        placement: "bottom-end",
        isOpen: isOpen,
        onClose: handleClose,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
                authFlow: "disabled"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $1f92641a13bcc754$var$styles.popupContent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                space: "space.0",
                spread: "space-between",
                alignBlock: "center",
                xcss: $1f92641a13bcc754$var$styles.popupHeader
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                xcss: $1f92641a13bcc754$var$styles.popupHeaderText
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "medium",
                weight: "medium"
            }, formatMessage($1f92641a13bcc754$var$i18n.sourcesCount, {
                count: validSources.length
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage($1f92641a13bcc754$var$i18n.closeSources),
                shape: "circle",
                onClick: handleClose
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
                as: "ul",
                xcss: $1f92641a13bcc754$var$styles.sourcesList,
                space: "space.050"
            }, validSources.map((source, index)=>{
                const webui = source.content?.links?.webui;
                const absoluteUrl = webui ? `${window.location.origin}${0, $jlIaF.CONTEXT_PATH}${webui}` : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
                    key: source.content?.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                    xcss: $1f92641a13bcc754$var$styles.sourceListItem,
                    onClick: (e)=>{
                        e.stopPropagation();
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'link',
                                actionSubjectId: 'sourceLink',
                                source: 'smartSpaceOverview',
                                attributes: {
                                    moduleType: 'faq',
                                    spaceKey: spaceKey,
                                    questionPosition: questionPosition,
                                    sourceIndex: index,
                                    sourceProduct: source.content?.embeddedProduct ?? null
                                }
                            }
                        }).fire();
                        if (absoluteUrl) window.open(absoluteUrl, '_blank', 'noopener,noreferrer');
                    }
                }, absoluteUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
                    appearance: "block",
                    url: absoluteUrl,
                    showHoverPreview: false,
                    fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d05f38054d846c18$export$64eb96c340cb75b), {
                            source: source
                        }),
                    ui: {
                        hideBackground: true,
                        hideElevation: true,
                        hidePadding: true
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
                    maxLines: 1
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zS2j.default), {
                    maxLines: 2
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d05f38054d846c18$export$64eb96c340cb75b), {
                    source: source
                })));
            })))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                ...triggerProps,
                onClick: handleToggle,
                xcss: (0, $1Whri.cx)($1f92641a13bcc754$var$styles.sourcesButton, isOpen && $1f92641a13bcc754$var$styles.sourcesButtonSelected)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5d01x.SourceLogoStack), {
                sources: sourceUrls
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "medium",
                weight: "medium",
                color: isOpen ? 'color.text.selected' : 'color.text.subtle'
            }, formatMessage($1f92641a13bcc754$var$i18n.sourcesCount, {
                count: validSources.length
            }))))
    }));
};
const $1f92641a13bcc754$var$i18n = (0, $aXWIB.defineMessages)({
    sourcesCount: {
        id: "space-overview.smart-space-overview.popular-questions.sources-count",
        defaultMessage: "{count, plural, one {# Source} other {# Sources}}"
    },
    closeSources: {
        id: "space-overview.smart-space-overview.popular-questions.close-sources",
        defaultMessage: "Close sources"
    }
});
const $1f92641a13bcc754$var$styles = {
    sourcesButton: "_2rko1mok _zulp1b66 _1h6d1l7x _189ee4h9 _1dqonqa1 _19bvu2gc _u5f3u2gc _ca0qze3t _n3tdze3t _4t3i1ul9 _bfhksm61 _syazazsu _k48p1wq8 _ect4ttxp _80omtlke _1e0c1txw _4cvr1h6o _irr31dpa",
    sourcesButtonSelected: "_1h6dq98m _bfhk15s3 _syaz6x5g _irr3ufnl",
    triggerWrapper: "_1e0c1o8l _1o9zidpf",
    popupContent: "_2rkopb1k _ca0qu2gc _u5f3utpp _n3tdpxbi _19bvutpp _1bsbp2n4 _c71l1kdj _18m91wug",
    popupHeader: "_otyrv77o",
    popupHeaderText: "_19bvu2gc",
    sourcesList: "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19bvze3t",
    sourceCard: "_19itglyw _1reo15vq _18m915vq _y3gn1e5h _1bsb1osq",
    sourceListItem: "_2rko1qi0 _1reo15vq _18m915vq _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _80omtlke _bfhk1j28 _1bsb1osq _y3gn1e5h _irr31dpa"
};


/**
 * Tracks how long a user dwells on an expanded FAQ question.
 *
 * Measures two durations per expansion:
 *  - `dwellTimeMs`     — time the expanded content was visible in the viewport.
 *  - `expandDurationMs` — wall-clock time from expand to collapse.
 *
 * Both are capped at MAX_DWELL_DURATION_MS. A "dwelled" analytics event is
 * fired automatically when the expansion ends, tagged with an end reason:
 *  - `manualCollapse` — user clicked to close.
 *  - `switchQuestion` — another question was expanded.
 *  - `navigated`      — the component unmounted (e.g. page navigation).
 */ 





// Filter out stale expansions (e.g. user expanded a question and walked away).
const $20b6fea54848571f$var$MAX_DWELL_DURATION_MS = 300000;
const $20b6fea54848571f$export$d5c16baac6dcf544 = ({ isExpanded: isExpanded, expandedContentRef: expandedContentRef, spaceKey: spaceKey, questionPosition: questionPosition })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sessionRef = (0, $42omo.useRef)(null);
    const isMountedRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>()=>{
            isMountedRef.current = false;
        }, []);
    (0, $42omo.useEffect)(()=>{
        if (!isExpanded) return;
        const expandStart = Date.now();
        let accumulatedDwellMs = 0;
        let viewportEnteredAt = null;
        const computeMetrics = ()=>{
            let dwellTimeMs = accumulatedDwellMs;
            if (viewportEnteredAt != null) dwellTimeMs += Date.now() - viewportEnteredAt;
            return {
                dwellTimeMs: Math.min(dwellTimeMs, $20b6fea54848571f$var$MAX_DWELL_DURATION_MS),
                expandDurationMs: Math.min(Date.now() - expandStart, $20b6fea54848571f$var$MAX_DWELL_DURATION_MS)
            };
        };
        sessionRef.current = {
            manualCollapse: false,
            computeMetrics: computeMetrics
        };
        const node = expandedContentRef.current;
        let observer;
        let isInViewport = false;
        const pauseDwell = ()=>{
            if (viewportEnteredAt != null) accumulatedDwellMs += Date.now() - viewportEnteredAt;
            viewportEnteredAt = null;
        };
        const resumeDwell = ()=>{
            viewportEnteredAt = Date.now();
        };
        if (node) {
            observer = new IntersectionObserver(([entry])=>{
                isInViewport = entry.isIntersecting;
                if (entry.isIntersecting) // Only resume if the tab is currently visible
                {
                    if (document.visibilityState === 'visible') resumeDwell();
                } else pauseDwell();
            });
            observer.observe(node);
        }
        const handleVisibilityChange = ()=>{
            if (document.visibilityState === 'hidden') pauseDwell();
            else if (isInViewport) resumeDwell();
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            observer?.disconnect();
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            const session = sessionRef.current;
            sessionRef.current = null;
            let endReason;
            if (!isMountedRef.current) endReason = 'navigated';
            else if (session?.manualCollapse) endReason = 'manualCollapse';
            else endReason = 'switchQuestion';
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'section',
                    actionSubjectId: 'expandedQuestion',
                    source: 'smartSpaceOverview',
                    attributes: {
                        moduleType: 'faq',
                        spaceKey: spaceKey,
                        questionPosition: questionPosition,
                        dwellEndReason: endReason,
                        ...computeMetrics()
                    }
                }
            }).fire();
        };
    }, [
        isExpanded,
        expandedContentRef,
        spaceKey,
        questionPosition,
        createAnalyticsEvent
    ]);
    return {
        markManualCollapse: ()=>{
            if (!sessionRef.current) return null;
            sessionRef.current.manualCollapse = true;
            return sessionRef.current.computeMetrics();
        }
    };
};


const $01328549e0c14588$var$FeedbackButtons = ({ vote: vote, onVoteUp: onVoteUp, onVoteDown: onVoteDown, upLabel: upLabel, downLabel: downLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
                label: "",
                color: vote === 'up' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: upLabel,
        appearance: "subtle",
        spacing: "compact",
        shape: "default",
        onClick: (e)=>{
            e.stopPropagation();
            if (vote !== 'up') onVoteUp();
        },
        isTooltipDisabled: false,
        isSelected: vote === 'up'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
                label: "",
                color: vote === 'down' ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: downLabel,
        appearance: "subtle",
        spacing: "compact",
        shape: "default",
        onClick: (e)=>{
            e.stopPropagation();
            if (vote !== 'down') onVoteDown();
        },
        isTooltipDisabled: false,
        isSelected: vote === 'down'
    }));
const $01328549e0c14588$var$RefreshButton = ({ label: label, isLoading: isLoading, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
        label: label,
        appearance: "subtle",
        spacing: "compact",
        isLoading: isLoading,
        onClick: onClick,
        isTooltipDisabled: false
    });
const $01328549e0c14588$var$QuestionHeader = ({ questionText: questionText, isExpanded: isExpanded, onToggle: onToggle, isRefreshing: isRefreshing, onRefresh: onRefresh, questionVote: questionVote, onVoteUp: onVoteUp, onVoteDown: onVoteDown })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleQuestionRefresh = (e)=>{
        e.stopPropagation();
        onRefresh(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.questionRow,
            isExpanded ? $01328549e0c14588$var$styles.questionRowExpanded : $01328549e0c14588$var$styles.questionRowCollapsed
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $01328549e0c14588$var$styles.questionTrigger,
        onClick: onToggle,
        "aria-expanded": isExpanded,
        "aria-label": formatMessage(isExpanded ? $01328549e0c14588$var$i18n.collapseQuestion : $01328549e0c14588$var$i18n.expandQuestion, {
            question: questionText
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.questionIcon
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.questionText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium",
        color: "color.text.subtle"
    }, questionText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.questionFeedbackButtons,
            !(0, $9wGTI.fg)('smart-space-overview-faq-always-show-feedback') && $01328549e0c14588$var$styles.hideQuestionActions
        ])
    }, (0, $9wGTI.fg)('smart-space-overview-individual-faq-regeneration') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$RefreshButton, {
        label: formatMessage($01328549e0c14588$var$i18n.refreshQuestion),
        isLoading: isRefreshing,
        onClick: handleQuestionRefresh
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$FeedbackButtons, {
        vote: questionVote,
        onVoteUp: onVoteUp,
        onVoteDown: onVoteDown,
        upLabel: formatMessage($01328549e0c14588$var$i18n.thumbsUpQuestion),
        downLabel: formatMessage($01328549e0c14588$var$i18n.thumbsDownQuestion)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.chevron
        ])
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
        label: formatMessage($01328549e0c14588$var$i18n.collapseQuestion, {
            question: questionText
        }),
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: formatMessage($01328549e0c14588$var$i18n.expandQuestion, {
            question: questionText
        }),
        color: "var(--ds-icon-subtle, #505258)"
    })));
};
const $01328549e0c14588$var$QuestionItemInner = ({ question: question, questionPosition: questionPosition, spaceKey: spaceKey, isExpanded: isExpanded, onToggle: onToggle, onFollowUp: onFollowUp, onAskRovo: onAskRovo })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const [questionVote, setQuestionVote] = (0, $42omo.useState)(null);
    const [answerVote, setAnswerVote] = (0, $42omo.useState)(null);
    const [startQuestionRefresh, isQuestionRefreshing] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const [startAnswerRefresh, isAnswerRefreshing] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const expandedContentRef = (0, $42omo.useRef)(null);
    const answerTextRef = (0, $42omo.useRef)(null);
    const { markManualCollapse: markManualCollapse } = (0, $20b6fea54848571f$export$d5c16baac6dcf544)({
        isExpanded: isExpanded,
        expandedContentRef: answerTextRef,
        spaceKey: spaceKey,
        questionPosition: questionPosition
    });
    const showFeedbackFlag = (0, $42omo.useCallback)(()=>{
        showFlag({
            title: formatMessage($01328549e0c14588$var$i18n.feedbackFlagTitle),
            description: formatMessage($01328549e0c14588$var$i18n.feedbackFlagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    }, [
        showFlag,
        formatMessage
    ]);
    const handleToggle = (0, $42omo.useCallback)(()=>{
        const dwellMetrics = markManualCollapse();
        onToggle(question.question);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: isExpanded ? 'questionCollapse' : 'questionExpand',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    ...dwellMetrics ?? {}
                }
            }
        }).fire();
    }, [
        onToggle,
        question.question,
        isExpanded,
        createAnalyticsEvent,
        questionPosition,
        spaceKey,
        markManualCollapse
    ]);
    const handleFollowUp = (0, $42omo.useCallback)((followUpQuestion, followUpPosition)=>{
        onFollowUp?.(followUpQuestion, question);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'followUpQuestion',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    followUpPosition: followUpPosition
                }
            }
        }).fire();
    }, [
        onFollowUp,
        question,
        createAnalyticsEvent,
        questionPosition,
        spaceKey
    ]);
    const handleAskRovo = (0, $42omo.useCallback)((message)=>{
        onAskRovo?.(message, question);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'askRovoSubmit',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    queryLength: message.length
                }
            }
        }).fire();
    }, [
        onAskRovo,
        question,
        createAnalyticsEvent,
        questionPosition,
        spaceKey
    ]);
    const fireFeedbackEvent = (0, $42omo.useCallback)((actionSubjectId, wasHelpful)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'submitted',
                actionSubject: 'feedback',
                actionSubjectId: actionSubjectId,
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'faq',
                    spaceKey: spaceKey,
                    questionPosition: questionPosition,
                    wasHelpful: wasHelpful
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        questionPosition,
        spaceKey
    ]);
    const handleQuestionThumbsUp = (0, $42omo.useCallback)(()=>{
        setQuestionVote('up');
        showFeedbackFlag();
        fireFeedbackEvent('question', true);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleQuestionThumbsDown = (0, $42omo.useCallback)(()=>{
        setQuestionVote('down');
        showFeedbackFlag();
        fireFeedbackEvent('question', false);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleAnswerThumbsUp = (0, $42omo.useCallback)(()=>{
        setAnswerVote('up');
        showFeedbackFlag();
        fireFeedbackEvent('answer', true);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleAnswerThumbsDown = (0, $42omo.useCallback)(()=>{
        setAnswerVote('down');
        showFeedbackFlag();
        fireFeedbackEvent('answer', false);
    }, [
        showFeedbackFlag,
        fireFeedbackEvent
    ]);
    const handleQuestionRefresh = (e)=>{
        e.stopPropagation();
        setQuestionVote(null);
        setAnswerVote(null);
        startQuestionRefresh();
    };
    const handleAnswerRefresh = (_e)=>{
        setAnswerVote(null);
        startAnswerRefresh();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.cardWrapper,
            isQuestionRefreshing && $01328549e0c14588$var$styles.contentBlurred
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$QuestionHeader, {
        questionText: question.question,
        isExpanded: isExpanded,
        onToggle: handleToggle,
        isRefreshing: isQuestionRefreshing,
        onRefresh: handleQuestionRefresh,
        questionVote: questionVote,
        onVoteUp: handleQuestionThumbsUp,
        onVoteDown: handleQuestionThumbsDown
    }), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: expandedContentRef,
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.expandedContent,
            isAnswerRefreshing && $01328549e0c14588$var$styles.contentBlurred
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.sectionLabel
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage($01328549e0c14588$var$i18n.answerLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.answerActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $01328549e0c14588$var$styles.answerFeedbackButtons,
            !(0, $9wGTI.fg)('smart-space-overview-faq-always-show-feedback') && $01328549e0c14588$var$styles.hideAnswerActions
        ])
    }, (0, $9wGTI.fg)('smart-space-overview-individual-faq-regeneration') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$RefreshButton, {
        label: formatMessage($01328549e0c14588$var$i18n.refreshAnswer),
        isLoading: isAnswerRefreshing,
        onClick: handleAnswerRefresh
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$FeedbackButtons, {
        vote: answerVote,
        onVoteUp: handleAnswerThumbsUp,
        onVoteDown: handleAnswerThumbsDown,
        upLabel: formatMessage($01328549e0c14588$var$i18n.thumbsUpAnswer),
        downLabel: formatMessage($01328549e0c14588$var$i18n.thumbsDownAnswer)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1f92641a13bcc754$export$99bd007203d2166e), {
        sources: question.sources,
        spaceKey: spaceKey,
        questionPosition: questionPosition
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: answerTextRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium",
        color: "color.text.subtle"
    }, question.answer))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8b7b04208de7a0b$export$9d9f2e3275d0d624), {
        questions: question.followUpQuestions,
        onFollowUp: handleFollowUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bb5f5999bd84aada$export$995e9427a9b39595), {
        onSend: handleAskRovo
    }))));
};
const $01328549e0c14588$export$2f31fc0a7a44451 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($01328549e0c14588$var$QuestionItemInner, props));
const $01328549e0c14588$var$i18n = (0, $aXWIB.defineMessages)({
    expandQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.expand",
        defaultMessage: "Expand question: {question}"
    },
    collapseQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.collapse",
        defaultMessage: "Collapse question: {question}"
    },
    answerLabel: {
        id: "space-overview.smart-space-overview.popular-questions.answer-label",
        defaultMessage: "Answer"
    },
    thumbsUpQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-up",
        defaultMessage: "Good question"
    },
    thumbsDownQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-down",
        defaultMessage: "Bad question"
    },
    thumbsUpAnswer: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-up-answer",
        defaultMessage: "Good answer"
    },
    thumbsDownAnswer: {
        id: "space-overview.smart-space-overview.popular-questions.thumbs-down-answer",
        defaultMessage: "Bad answer"
    },
    refreshQuestion: {
        id: "space-overview.smart-space-overview.popular-questions.refresh-question",
        defaultMessage: "Refresh question"
    },
    refreshAnswer: {
        id: "space-overview.smart-space-overview.popular-questions.refresh-answer",
        defaultMessage: "Refresh answer"
    },
    feedbackFlagTitle: {
        id: "space-overview.smart-space-overview.popular-questions.feedback-flag-title",
        defaultMessage: "Thanks!"
    },
    feedbackFlagDescription: {
        id: "space-overview.smart-space-overview.popular-questions.feedback-flag-description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    }
});
const $01328549e0c14588$var$styles = {
    cardWrapper: "_2rkopb1k _1reo15vq _18m915vq _bfhkhfxm",
    questionRow: "_11c8fhey _189eidpf _kqswh2mm _1e0c11p5 _yv0e1bke _1lmc1ye3 _4cvr1h6o _gy1pv77o _80omtlke _bfhkhfxm _1bsb1osq _syazi7uo _y3gnv2br _gsm2idpf _irr31dpa _rmwnkb7n",
    questionRowExpanded: "_2rkoidpf",
    questionRowCollapsed: "_2rkopb1k",
    questionTrigger: "_1r04ze3t _kqswstnw _bfhk1j28",
    questionIcon: "_nd5l2ec4 _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _bozgv47k _lcxvglyw",
    questionText: "_nd5l1kdv _18zru2gc _1rjcpxbi _kqswh2mm _1ul9idpf _lcxvglyw",
    questionFeedbackButtons: "_nd5l1v4b _kqswh2mm _1e0c1txw _4cvr1h6o _1n261q9c _1o9zidpf",
    chevron: "_nd5ludx4 _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _y4tiv47k _lcxvglyw",
    expandedContent: "_1rjcpxbi _18zrv47k _bfhkhfxm _uwhke4h9 _15a5nqa1 _1i531l7x _1u0nidpf _t79pkb7n",
    sectionLabel: "_85i51b66 _1e0c1txw _4cvr1h6o _1bah1yb4",
    answerActions: "_1e0c1txw _4cvr1h6o _1bahesu3 _1n261q9c _gy1p1b66 _1o9zidpf",
    answerFeedbackButtons: "_1e0c1txw _4cvr1h6o _1n261q9c _1o9zidpf",
    hideQuestionActions: "_v5641bup _tzy41vth",
    hideAnswerActions: "_v5641bup _tzy4g3vr",
    contentBlurred: "_v5641bup _tzy42wxo _lcxvglyw"
};








const $747111b28549b837$var$THRESHOLDS = [
    0,
    0.5,
    1.0
];
const $747111b28549b837$var$getThresholdLabel = (ratio)=>{
    if (ratio >= 1.0) return 'full';
    if (ratio >= 0.5) return 'half';
    return 'partial';
};
const $747111b28549b837$export$7fe9c12e9689f54b = ({ spaceKey: spaceKey, questionCount: questionCount })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sectionRef = (0, $42omo.useRef)(null);
    const firedThresholdsRef = (0, $42omo.useRef)(new Set());
    // questionCount may change when refetching data, but we only need the latest value
    // when the intersection fires — not as a trigger to re-observe.
    const questionCountRef = (0, $42omo.useRef)(questionCount);
    questionCountRef.current = questionCount;
    (0, $42omo.useEffect)(()=>{
        const node = sectionRef.current;
        if (!node) return;
        const observer = new IntersectionObserver(([entry])=>{
            if (!entry.isIntersecting) return;
            const label = $747111b28549b837$var$getThresholdLabel(entry.intersectionRatio);
            const thresholdLabels = [
                'partial',
                'half',
                'full'
            ];
            const currentIndex = thresholdLabels.indexOf(label);
            for(let i = 0; i <= currentIndex; i++){
                const threshold = thresholdLabels[i];
                if (!firedThresholdsRef.current.has(threshold)) {
                    firedThresholdsRef.current.add(threshold);
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'viewed',
                            actionSubject: 'module',
                            actionSubjectId: 'faq',
                            source: 'smartSpaceOverview',
                            attributes: {
                                moduleType: 'faq',
                                spaceKey: spaceKey,
                                questionCount: questionCountRef.current,
                                threshold: threshold
                            }
                        }
                    }).fire();
                }
            }
            if (firedThresholdsRef.current.size === thresholdLabels.length) observer.disconnect();
        }, {
            threshold: [
                ...$747111b28549b837$var$THRESHOLDS
            ]
        });
        observer.observe(node);
        return ()=>{
            observer.disconnect();
        };
    }, [
        spaceKey,
        createAnalyticsEvent
    ]);
    return {
        sectionRef: sectionRef
    };
};


const $b940e14642ad4976$export$5f1dbecc17d9b4ee = ({ faqData: faqData, spaceKey: spaceKey })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [expandedId, setExpandedId] = (0, $42omo.useState)(null);
    const [startRefreshAll, isRefreshingAll] = (0, $75b7ce46cf4dcbf4$export$95779ae96ff09d4a)();
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const questionCount = faqData?.entries?.length ?? 0;
    const { sectionRef: sectionRef } = (0, $747111b28549b837$export$7fe9c12e9689f54b)({
        spaceKey: spaceKey,
        questionCount: questionCount
    });
    const handleToggle = (0, $42omo.useCallback)((id)=>{
        setExpandedId((prev)=>prev === id ? null : id);
    }, []);
    const formatSourcesContext = (0, $42omo.useCallback)((sources)=>{
        if (sources.length === 0) return '';
        const sourceLines = sources.map((source)=>`- [${source?.content?.title}](${window.location.origin}${0, $jlIaF.CONTEXT_PATH}${source?.content?.links?.webui})`);
        return `\n\n${formatMessage($b940e14642ad4976$var$i18n.sourcesLabel)}\n${sourceLines.join('\n')}`;
    }, [
        formatMessage
    ]);
    const createSpaceContext = (0, $42omo.useCallback)((parentQuestion)=>{
        const spaceOverviewUrl = `${window.location.origin}${(0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        })}`;
        const humanMessageContent = formatMessage($b940e14642ad4976$var$i18n.humanMessagePrompt, {
            link: spaceOverviewUrl,
            question: parentQuestion.question
        });
        const agentMessageContent = `${parentQuestion.answer}${formatSourcesContext(parentQuestion.sources)}`;
        return {
            human_message: {
                content: humanMessageContent
            },
            agent_message: {
                content: agentMessageContent
            }
        };
    }, [
        spaceKey,
        formatSourcesContext,
        formatMessage
    ]);
    const publishRovoChat = (0, $42omo.useCallback)((questionText, parentQuestion)=>{
        const context = createSpaceContext(parentQuestion);
        publish({
            type: 'chat-new',
            source: 'space-overview-popular-questions',
            data: {
                name: questionText.substring(0, 30),
                dialogues: [
                    context
                ],
                prompt: questionText
            }
        });
    }, [
        publish,
        createSpaceContext
    ]);
    const handleFollowUp = (0, $42omo.useCallback)((followUpQuestion, parentQuestion)=>publishRovoChat(followUpQuestion, parentQuestion), [
        publishRovoChat
    ]);
    const handleAskRovo = (0, $42omo.useCallback)((customQuestion, parentQuestion)=>publishRovoChat(customQuestion, parentQuestion), [
        publishRovoChat
    ]);
    const handleRefreshAll = (0, $42omo.useCallback)(()=>{
        // TODO: Implement refresh all questions
        setExpandedId(null);
        startRefreshAll();
    }, [
        startRefreshAll
    ]);
    if ((faqData?.entries?.length ?? 0) > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("section", {
        ref: sectionRef,
        "aria-label": formatMessage($b940e14642ad4976$var$i18n.heading)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b940e14642ad4976$var$styles.headingRow
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "small",
        as: "h2"
    }, formatMessage($b940e14642ad4976$var$i18n.heading)), (0, $9wGTI.fg)('smart-space-overview-refresh') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $b940e14642ad4976$var$styles.refreshAllButton,
            isRefreshingAll && $b940e14642ad4976$var$styles.refreshAllButtonVisible
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
        label: formatMessage($b940e14642ad4976$var$i18n.refreshAll),
        appearance: "subtle",
        spacing: "compact",
        isLoading: isRefreshingAll,
        onClick: handleRefreshAll,
        isTooltipDisabled: false
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            isRefreshingAll && $b940e14642ad4976$var$styles.contentBlurred
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, faqData?.entries?.map((question, index)=>{
        const questionKey = question.question;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $01328549e0c14588$export$2f31fc0a7a44451), {
            key: questionKey,
            question: question,
            isExpanded: expandedId === questionKey,
            onToggle: handleToggle,
            onFollowUp: handleFollowUp,
            onAskRovo: handleAskRovo,
            spaceKey: spaceKey,
            questionPosition: index
        });
    })))));
    return null;
};
const $b940e14642ad4976$var$i18n = (0, $aXWIB.defineMessages)({
    heading: {
        id: "space-overview.smart-space-overview.popular-questions.heading",
        defaultMessage: "Popular questions"
    },
    humanMessagePrompt: {
        id: "space-overview.smart-space-overview.popular-questions.human-message-prompt",
        defaultMessage: "Question about space {link}: {question}"
    },
    sourcesLabel: {
        id: "space-overview.smart-space-overview.popular-questions.sources-label",
        defaultMessage: "Sources:"
    },
    refreshAll: {
        id: "space-overview.smart-space-overview.popular-questions.refresh-all",
        defaultMessage: "Refresh all questions"
    }
});
const $b940e14642ad4976$var$styles = {
    headingRow: "_1e0c1txw _4cvr1h6o _1bah1yb4 _19ejidpf _5ekskb7n",
    refreshAllButton: "_v5641bup _tzy4nkvk",
    refreshAllButtonVisible: "_tzy4kb7n",
    contentBlurred: "_v5641bup _tzy42wxo _lcxvglyw"
};


/* SmartSpaceOverviewHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $biiXa = parcelRequire("biiXa");


var $7yOcR = parcelRequire("7yOcR");








var $ccHMk = parcelRequire("ccHMk");







var $lGgRw = parcelRequire("lGgRw");


var $jNtYE = parcelRequire("jNtYE");


var $6mKj3 = parcelRequire("6mKj3");





var $17wUi = parcelRequire("17wUi");

const $e1b54ae933da37d5$var$i18n = (0, $aXWIB.defineMessages)({
    feedbackButtonLabel: {
        id: "space-overview.smart-space-overview.feedback-button-label",
        defaultMessage: "Give feedback"
    },
    feedbackTitle: {
        id: "space-overview.smart-space-overview.feedback-title",
        defaultMessage: "What do you think of the new Spaces overview?"
    },
    feedbackPreamble: {
        id: "space-overview.smart-space-overview.feedback-preamble",
        defaultMessage: "Help make it even better with your feedback."
    },
    organizedByRovo: {
        id: "space-overview.smart-space-overview.organized-by-rovo",
        defaultMessage: "Organized by Rovo"
    },
    popupDismissLabel: {
        id: "space-overview.smart-space-overview.popup-dismiss-label",
        defaultMessage: "Dismiss"
    },
    popupDescription: {
        id: "space-overview.smart-space-overview.popup-description",
        defaultMessage: "This is where your team's work comes together."
    },
    popupBullet1: {
        id: "space-overview.smart-space-overview.popup-bullet-1",
        defaultMessage: "See the summary of the space"
    },
    popupBullet2: {
        id: "space-overview.smart-space-overview.popup-bullet-2",
        defaultMessage: "Pin key documents"
    },
    popupBullet3: {
        id: "space-overview.smart-space-overview.popup-bullet-3",
        defaultMessage: "Get answers to your team's most important questions"
    }
});
const $e1b54ae933da37d5$var$FEEDBACK_OPENED_STORAGE_KEY = 'smart-space-overview-feedback-opened';
const $e1b54ae933da37d5$var$FEEDBACK_CONTEXT_FIELD_ID = 'customfield_10047';
const $e1b54ae933da37d5$var$FEEDBACK_ENTRYPOINT_ID = '6b7a459d-eab0-4b18-b825-481b90b7a262';
const $e1b54ae933da37d5$var$FEEDBACK_SOURCE = 'smartSpaceOverviewHeader';
const $e1b54ae933da37d5$var$hasFeedbackCollectorBeenOpened = ()=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance).getItem($e1b54ae933da37d5$var$FEEDBACK_OPENED_STORAGE_KEY) === 'true';
    } catch  {
        return false;
    }
};
const $e1b54ae933da37d5$var$persistFeedbackCollectorOpened = ()=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($e1b54ae933da37d5$var$FEEDBACK_OPENED_STORAGE_KEY, 'true');
    } catch  {}
};
const $e1b54ae933da37d5$export$2359131f9fa9ca50 = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $aXWIB.useIntl)();
    const { displayName: displayName, userId: userId } = (0, $bQm3c.useSessionData)();
    const autoOpenTimeoutRef = (0, $42omo.useRef)(null);
    const [isFeedbackCollectorOpen, setIsFeedbackCollectorOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const togglePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen((prev)=>!prev);
    }, []);
    const closePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(false);
    }, []);
    const openFeedbackCollector = (0, $42omo.useCallback)(()=>{
        $e1b54ae933da37d5$var$persistFeedbackCollectorOpened();
        if (autoOpenTimeoutRef.current !== null) {
            window.clearTimeout(autoOpenTimeoutRef.current);
            autoOpenTimeoutRef.current = null;
        }
        setIsFeedbackCollectorOpen(true);
    }, []);
    const closeFeedbackCollector = (0, $42omo.useCallback)(()=>{
        setIsFeedbackCollectorOpen(false);
    }, []);
    (0, $42omo.useEffect)(()=>{
        if ((0, $6mKj3.expVal)('confluence_space_overview_feedback_auto_open_delay', 'value', 0) <= 0) return;
        autoOpenTimeoutRef.current = window.setTimeout(()=>{
            autoOpenTimeoutRef.current = null;
            if (!$e1b54ae933da37d5$var$hasFeedbackCollectorBeenOpened()) openFeedbackCollector();
        }, (0, $6mKj3.expVal)('confluence_space_overview_feedback_auto_open_delay', 'value', 0));
        return ()=>{
            if (autoOpenTimeoutRef.current !== null) {
                window.clearTimeout(autoOpenTimeoutRef.current);
                autoOpenTimeoutRef.current = null;
            }
        };
    }, [
        openFeedbackCollector
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $e1b54ae933da37d5$var$styles.overviewHeaderActions
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isPopupOpen,
        onClose: closePopup,
        placement: "bottom-start",
        offset: [
            0,
            -32
        ],
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
                ...triggerProps,
                type: "button",
                onClick: togglePopup,
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false),
                onFocus: ()=>setIsHovered(true),
                onBlur: ()=>setIsHovered(false),
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.organizedByRovo
                ])
            }, isHovered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jNtYE.LazyAnimatedRovoIcon), {
                width: "20",
                height: "20"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                size: "xsmall",
                appearance: "brand",
                shouldUseNewLogoDesign: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.preload
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jNtYE.LazyAnimatedRovoIcon), {
                width: "20",
                height: "20"
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.organizedByRovo)),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupContent
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupHeader
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupHeaderLeft
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
                size: "xsmall",
                appearance: "brand",
                shouldUseNewLogoDesign: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.organizedByRovo)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
                label: formatMessage($e1b54ae933da37d5$var$i18n.popupDismissLabel),
                onClick: closePopup
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupBody
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtle"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
                className: (0, $gMc0m.default)([
                    $e1b54ae933da37d5$var$styles.popupList
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupBullet1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupBullet2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.popupBullet3))))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: openFeedbackCollector,
        testId: "smart-space-overview-feedback-button",
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
                ...iconProps,
                spacing: "spacious",
                label: ""
            }),
        className: (0, $gMc0m.default)([
            $e1b54ae933da37d5$var$styles.feedbackButton
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e1b54ae933da37d5$var$i18n.feedbackButtonLabel))), isFeedbackCollectorOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $biiXa.default), {
        locale: locale,
        onClose: closeFeedbackCollector,
        onSubmit: closeFeedbackCollector,
        atlassianAccountId: userId || '',
        name: displayName || '',
        entrypointId: $e1b54ae933da37d5$var$FEEDBACK_ENTRYPOINT_ID,
        feedbackTitle: formatMessage($e1b54ae933da37d5$var$i18n.feedbackTitle),
        feedbackTitleDetails: formatMessage($e1b54ae933da37d5$var$i18n.feedbackPreamble),
        additionalFields: [
            {
                id: $e1b54ae933da37d5$var$FEEDBACK_CONTEXT_FIELD_ID,
                value: $e1b54ae933da37d5$var$FEEDBACK_SOURCE
            }
        ]
    }));
};
const $e1b54ae933da37d5$var$styles = {
    overviewHeaderActions: "_zulpv47k _1rjc1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _1tkeoahv",
    organizedByRovo: "_zulp1b66 _11c8fhey _11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c116y _4cvr1h6o _syaz1rpy _80omtlke _9oik1r31 _1bnx8stv _jf4cnqa1",
    preload: "_1reo15vq _18m915vq _kqswstnw _1bsbt94y _4t3it94y _tzy4idpf _lcxvglyw",
    feedbackButton: "_2rko1qi0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1rjc1b66 _18zru2gc _1e0c116y _4cvr1h6o _1bah1h6o _bfhkvuon _syazi7uo _80omtlke",
    popupContent: "_1yt4pxbi _p12fnklw",
    popupHeader: "_1e0c1txw _4cvr1h6o _1bah1yb4 _6rthu2gc",
    popupHeaderLeft: "_zulp1b66 _11c8wadc _1e0c116y _4cvr1h6o _k48p1wq8 _syazi7uo",
    popupBody: "_6rth1b66",
    popupList: "_11c8wadc _19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazazsu _bozgv47k"
};


/* SmartSpaceOverviewLogo.tsx generated by @compiled/babel-plugin v0.36.1 */ 





















var $di8q4 = parcelRequire("di8q4");


var $Qlykt = parcelRequire("Qlykt");


var $eWwvy = parcelRequire("eWwvy");

const $c0f874fe2d27e0c7$var$i18n = (0, $aXWIB.defineMessages)({
    editSpaceLogoTooltip: {
        id: "space-overview.smart-space-overview.logo.edit-space-logo-tooltip",
        defaultMessage: "Edit space logo"
    }
});
const $c0f874fe2d27e0c7$export$36f67a5ef9dc0044 = ({ spaceKey: spaceKey, spaceId: spaceId, isAdmin: isAdmin, isPersonalSpace: isPersonalSpace, emoji: emoji, spaceIconPath: spaceIconPath })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [shouldRenderEditSpaceLogoDialog, setShouldRenderEditSpaceLogoDialog] = (0, $42omo.useState)(false);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const onOpen = (0, $42omo.useCallback)(()=>setIsOpen(true), []);
    const onClose = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const handleIconClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'editSpaceDetails',
                source: 'smartSpaceOverview',
                containerType: 'space',
                containerId: spaceId,
                attributes: {
                    entryPoint: 'smartSpaceOverview',
                    spaceKey: spaceKey
                }
            }
        }).fire();
        setShouldRenderEditSpaceLogoDialog(true);
        onOpen();
    }, [
        createAnalyticsEvent,
        onOpen,
        spaceId,
        spaceKey
    ]);
    const renderEditSpaceLogoDialog = (0, $42omo.useCallback)(()=>{
        setShouldRenderEditSpaceLogoDialog(true);
    }, []);
    const hasEmoji = Boolean(emoji);
    const hasIcon = hasEmoji || Boolean(spaceIconPath);
    if (!hasIcon) return null;
    const iconContent = hasEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji,
        context: "spaceHeader",
        height: (0, $Qlykt.EMOJI_SIZE_LARGE),
        renderResourcedEmoji: true,
        isPageTitleComponent: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        width: (0, $Qlykt.EMOJI_SIZE_LARGE),
        height: (0, $Qlykt.EMOJI_SIZE_LARGE),
        src: `${(0, $jlIaF.CONTEXT_PATH)}${spaceIconPath}`,
        alt: "",
        "data-testid": "smart-space-overview-logo-icon",
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.spaceIcon
        ])
    });
    if (!isAdmin || isPersonalSpace) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "smart-space-overview-logo",
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.logoRoot
        ])
    }, iconContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "smart-space-overview-logo",
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.logoRoot
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($c0f874fe2d27e0c7$var$i18n.editSpaceLogoTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("button", {
        onClick: handleIconClick,
        onMouseEnter: ()=>{
            setIsHovered(true);
            renderEditSpaceLogoDialog();
        },
        onMouseLeave: ()=>setIsHovered(false),
        onFocus: ()=>{
            setIsHovered(true);
            renderEditSpaceLogoDialog();
        },
        onBlur: ()=>setIsHovered(false),
        "aria-label": intl.formatMessage($c0f874fe2d27e0c7$var$i18n.editSpaceLogoTooltip),
        "data-testid": "smart-space-overview-logo-edit-button",
        type: "button",
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.spaceIconContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.iconWrapper
        ])
    }, iconContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $c0f874fe2d27e0c7$var$styles.editIconOverlay,
            isHovered && $c0f874fe2d27e0c7$var$styles.editIconOverlayVisible
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    }))))), shouldRenderEditSpaceLogoDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
        spaceKey: spaceKey,
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        showSpaceNameField: false,
        entryPoint: "smartSpaceOverview"
    }));
};
const $c0f874fe2d27e0c7$var$styles = {
    spaceIcon: "_2rko1crf _1e0c1ule",
    editIconOverlay: "_v5641hrg _2rko1crf _kqswstnw _4t3i1osq _1bsb1osq _154ize3t _1ltvze3t _tzy4idpf _bfhk1i5c _1e0c1txw _4cvr1h6o _1bah1h6o",
    editIconOverlayVisible: "_tzy4kb7n",
    spaceIconContainer: "_1yt4ze3t _19itglyw _11q7glyw _80omtlke _1e0c116y _4cvr1h6o _1bah1h6o",
    iconWrapper: "_kqswh2mm _1e0c116y",
    logoRoot: "_19it1ebf _2rkof6fq _1e0c116y"
};


/**
 * @generated SignedSource<<be6ba3a4d7488b5ecbbd64db4ea41b37>>
 * @relayHash 028bc8cd44ccfe555825b862cac7175f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ce20ec099abc7671f8f67b49755cda9c9a35f69466c5cc3cf77aada23721aa9
const $096db6ea15398f90$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
            "kind": "LinkedField",
            "name": "confluence_refreshSmartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverview",
                    "kind": "LinkedField",
                    "name": "overview",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                            "kind": "LinkedField",
                            "name": "topLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "contentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastRefreshed"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPinned"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TopLinksCardRefreshTopLinksMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TopLinksCardRefreshTopLinksMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "028bc8cd44ccfe555825b862cac7175f",
            "id": "2ce20ec099abc7671f8f67b49755cda9c9a35f69466c5cc3cf77aada23721aa9",
            "metadata": {},
            "name": "TopLinksCardRefreshTopLinksMutation",
            "operationKind": "mutation",
            "text": "mutation TopLinksCardRefreshTopLinksMutation($cloudId:ID!,$input:ConfluenceRefreshSmartSpaceOverviewInput!){confluence_refreshSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}}"
        }
    };
}();
$096db6ea15398f90$var$node.hash = "8e825f319472bd53e49e1decd81de040";
var $096db6ea15398f90$export$2e2bcd8739ae039 = $096db6ea15398f90$var$node;


/**
 * @generated SignedSource<<5581ffdfae89d89b284d733c0c173d44>>
 * @relayHash c2729e34ecfb9542d89cbc2054efd8fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 92a99b2c1c8dd2c8f53891a1479eba53324c36973488f79bda3ef7677b9d3850
const $71c53debaf0f9345$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
            "kind": "LinkedField",
            "name": "confluence_updateSmartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverview",
                    "kind": "LinkedField",
                    "name": "overview",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                            "kind": "LinkedField",
                            "name": "topLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "contentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastRefreshed"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isPinned"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TopLinksCardUpdateTopLinksMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TopLinksCardUpdateTopLinksMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c2729e34ecfb9542d89cbc2054efd8fb",
            "id": "92a99b2c1c8dd2c8f53891a1479eba53324c36973488f79bda3ef7677b9d3850",
            "metadata": {},
            "name": "TopLinksCardUpdateTopLinksMutation",
            "operationKind": "mutation",
            "text": "mutation TopLinksCardUpdateTopLinksMutation($cloudId:ID!,$input:ConfluenceUpdateSmartSpaceOverviewInput!){confluence_updateSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}}"
        }
    };
}();
$71c53debaf0f9345$var$node.hash = "7c3c5220e6a36be3e1b0a3a57c4f0e9b";
var $71c53debaf0f9345$export$2e2bcd8739ae039 = $71c53debaf0f9345$var$node;















var $eIleF = parcelRequire("eIleF");





var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");







/* Card.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $g5gZt = parcelRequire("g5gZt");




const $fe608f906a4fdf3e$var$i18n = (0, $aXWIB.defineMessages)({
    add: {
        id: "space-overview.smart-space-overview.card.add",
        defaultMessage: "Add"
    }
});
const $fe608f906a4fdf3e$var$styles = {
    card: "_2rkopb1k _1yt4v47k _bfhkhfxm",
    header: "_1e0c1txw _4cvr1h6o _otyrutpp",
    titleGroup: "_zulp12x7 _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o",
    itemsRow: "_zulpu2gc _1e0c1txw _2lx2vrvc _1n261g80",
    itemWrapper: "_1ul9idpf _1e0c1txw _2lx21bp4"
};
const $fe608f906a4fdf3e$export$60332b2344f7fe41 = ({ title: title, count: count, maxCount: maxCount, onAdd: onAdd, actionButton: actionButton, children: children, renderItemWrapper: renderItemWrapper })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isAtCapacity = maxCount !== undefined && count !== undefined && count >= maxCount; // Use actionButton if provided, otherwise fall back to onAdd for backward compatibility
    const renderActionButton = ()=>{
        if (actionButton) return actionButton;
        if (onAdd) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
            label: formatMessage($fe608f906a4fdf3e$var$i18n.add),
            appearance: "subtle",
            spacing: "compact",
            isDisabled: isAtCapacity,
            onClick: onAdd
        });
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $fe608f906a4fdf3e$var$styles.card
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $fe608f906a4fdf3e$var$styles.header
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $fe608f906a4fdf3e$var$styles.titleGroup
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h2",
        size: "small"
    }, formatMessage(title))), renderActionButton()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $fe608f906a4fdf3e$var$styles.itemsRow
        ])
    }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(child)) return child;
        if (renderItemWrapper) return renderItemWrapper(child, index);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: child.key ?? index,
            className: (0, $gMc0m.default)([
                $fe608f906a4fdf3e$var$styles.itemWrapper
            ])
        }, child);
    })));
};


function $708b3e73f2b8fa2a$export$c42d680a28a18ad7(links, linkId) {
    const idx = links.findIndex((l)=>l.id === linkId);
    if (idx === -1) return {
        nextLinks: links,
        didReorder: false
    };
    const link = links[idx];
    // When unpinning the last pinned item (nothing pinned after it), toggle in place.
    if (link.isPinned && !links.slice(idx + 1).some((l)=>l.isPinned)) return {
        nextLinks: links.map((l, i)=>i === idx ? {
                ...l,
                isPinned: false
            } : l),
        didReorder: false
    };
    // Both pin and unpin place the link right after the last pinned item.
    const newPinned = !link.isPinned;
    const without = links.filter((_, i)=>i !== idx);
    let insertAt = 0;
    for(let i = without.length - 1; i >= 0; i--)if (without[i].isPinned) {
        insertAt = i + 1;
        break;
    }
    const updatedLink = {
        ...link,
        isPinned: newPinned
    };
    const nextLinks = [
        ...without.slice(0, insertAt),
        updatedLink,
        ...without.slice(insertAt)
    ];
    return {
        nextLinks: nextLinks,
        didReorder: insertAt !== idx
    };
}
function $708b3e73f2b8fa2a$export$9b320488069db95e(links, newLink, maxCount) {
    let insertAt = 0;
    for(let i = links.length - 1; i >= 0; i--)if (links[i].isPinned) {
        insertAt = i + 1;
        break;
    }
    return [
        ...links.slice(0, insertAt),
        newLink,
        ...links.slice(insertAt)
    ].slice(0, maxCount);
}









var $4iPjq = parcelRequire("4iPjq");

















var $8fW0f = parcelRequire("8fW0f");


var $3W9OD = parcelRequire("3W9OD");

const $2d6c8d1397947730$var$i18n = (0, $aXWIB.defineMessages)({
    add: {
        id: "space-overview.smart-space-overview.link-picker.add",
        defaultMessage: "Add link"
    },
    disabledTooltip: {
        id: "space-overview.smart-space-overview.link-picker.disabled-tooltip",
        defaultMessage: "Max of 4 links. Remove one to add another."
    }
});
const $2d6c8d1397947730$var$POPUP_OFFSET = [
    0,
    8
];
const $2d6c8d1397947730$export$b665e181ecd1797 = ({ showPicker: showPicker = false, disabled: disabled = false, onLinkSubmit: onLinkSubmit, existingLinks: existingLinks = [], ...props })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isPickerOpen, setIsPickerOpen] = (0, $42omo.useState)(showPicker);
    const searchProvider = (0, $3W9OD.useSearchProvider)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const plugins = (0, $42omo.useMemo)(()=>[
            new (0, $8fW0f.default)({
                searchProvider: searchProvider,
                activityClientEndpoint: `${window.location.origin}/gateway/api/graphql`
            })
        ], [
        searchProvider
    ]);
    const handleAddClick = (0, $42omo.useCallback)(()=>{
        if (disabled) return;
        setIsPickerOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'openLinkPicker',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        disabled
    ]);
    const handlePickerClose = (0, $42omo.useCallback)(()=>{
        setIsPickerOpen(false);
        props.onCancel?.();
    }, [
        props
    ]);
    const handleSubmit = (0, $42omo.useCallback)((payload)=>{
        const isDuplicate = existingLinks.some((link)=>link.url === payload.url);
        if (isDuplicate) {
            setIsPickerOpen(false);
            return;
        }
        let inputMethod = 'manual';
        if (payload.meta.inputMethod === 'manual') inputMethod = 'manual';
        else if (payload.data?.prefetch === true) inputMethod = 'suggestion';
        else inputMethod = 'search';
        onLinkSubmit?.({
            url: payload.url,
            title: payload.title ?? payload.displayText ?? payload.url,
            inputMethod: inputMethod
        });
        setIsPickerOpen(false);
        props.onSubmit?.(payload);
    }, [
        existingLinks,
        onLinkSubmit,
        props
    ]);
    const renderContent = (0, $42omo.useCallback)(({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iPjq.default), {
            ...props,
            plugins: plugins,
            onCancel: handlePickerClose,
            onSubmit: handleSubmit,
            onContentResize: update
        }), [
        props,
        plugins,
        handlePickerClose,
        handleSubmit
    ]);
    const renderTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
            label: formatMessage($2d6c8d1397947730$var$i18n.add),
            appearance: "subtle",
            spacing: "compact",
            isDisabled: disabled,
            onClick: handleAddClick
        });
        if (disabled && formatMessage($2d6c8d1397947730$var$i18n.disabledTooltip)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage($2d6c8d1397947730$var$i18n.disabledTooltip)
        }, button);
        return button;
    }, [
        formatMessage,
        disabled,
        handleAddClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isPickerOpen,
        onClose: handlePickerClose,
        content: renderContent,
        trigger: renderTrigger,
        placement: "bottom-start",
        offset: $2d6c8d1397947730$var$POPUP_OFFSET,
        autoFocus: false
    });
};


/* LinkItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 











var $5TXU5 = parcelRequire("5TXU5");






var $1s5hv = parcelRequire("1s5hv");





var $7642E = parcelRequire("7642E");


var $2Nwuj = parcelRequire("2Nwuj");


var $90Y9A = parcelRequire("90Y9A");


var $6V1ly = parcelRequire("6V1ly");


var $brxEJ = parcelRequire("brxEJ");





var $bYRk6 = parcelRequire("bYRk6");






const $2a4c4438bdd7c14c$var$i18n = (0, $aXWIB.defineMessages)({
    pin: {
        id: "space-overview.smart-space-overview.link-item.pin",
        defaultMessage: "Pin"
    },
    unpin: {
        id: "space-overview.smart-space-overview.link-item.unpin",
        defaultMessage: "Unpin"
    },
    remove: {
        id: "space-overview.smart-space-overview.link-item.remove",
        defaultMessage: "Remove"
    }
});
/* Compiled css for the SmartCard wrapper — allows child selectors for internal element overrides */ const $2a4c4438bdd7c14c$var$smartCardWrapperStyle = null; /* Variant used when an IconTile is provided — hides SmartCard's own icon element */ 
const $2a4c4438bdd7c14c$var$smartCardWrapperStyleWithTile = null; /* Icon column: Smart Card’s layered link only covers the Card; DS Link opens the URL in a new tab */ 
const $2a4c4438bdd7c14c$var$iconColumnWrapperStyles = null;
const $2a4c4438bdd7c14c$var$hoverCardContainerStyles = null;
const $2a4c4438bdd7c14c$var$hoverCardTriggerStyles = null;
const $2a4c4438bdd7c14c$var$itemStyles = {
    outerWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
    row: "_2rko1mok _16jlkb7n _1o9zkb7n _i0dlf1ug _1rjc12x7 _18zru2gc _80omtlke _10j71dpa _irr31dpa",
    actions: "_zulpv77o _v564cklq _1o9zidpf _1e0cglyw _4cvr1h6o _tzy4idpf",
    actionsVisible: "_zulpv77o _v564cklq _1o9zidpf _1e0c1txw _4cvr1h6o _tzy4kb7n"
};
const $2a4c4438bdd7c14c$var$cardUiProps = {
    hideBackground: true,
    hideElevation: true,
    hidePadding: true,
    /* TitleBlock anchorTarget is applied to the full-area LayeredLink <a> when this is true */ clickableContainer: true,
    size: (0, $5TXU5.SmartLinkSize).Medium,
    hideActions: true
};
const $2a4c4438bdd7c14c$var$titleBlockSubtitle = [
    {
        name: (0, $5TXU5.ElementName).CreatedBy
    }
];
const $2a4c4438bdd7c14c$var$hoverCardActionOptions = {
    hide: false,
    exclude: [
        (0, $5TXU5.CardAction).AutomationAction,
        (0, $5TXU5.CardAction).ChangeStatusAction,
        (0, $5TXU5.CardAction).CopyLinkAction,
        (0, $5TXU5.CardAction).DownloadAction,
        (0, $5TXU5.CardAction).FollowAction,
        (0, $5TXU5.CardAction).PreviewAction,
        (0, $5TXU5.CardAction).RovoChatAction,
        (0, $5TXU5.CardAction).ViewAction
    ]
};
const $2a4c4438bdd7c14c$export$532cb6865ebe8946 = ({ link: link, onRemove: onRemove, onPin: onPin, isPinned: isPinned = false, docPosition: docPosition, spaceKey: spaceKey, spaceId: spaceId })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const pinnedAtRef = (0, $42omo.useRef)(null); // Provide Top Docs attribution context to analytics events fired inside the
    // HoverCard popup (e.g. `smartLink clicked titleGoToLink`). Events fired
    // inside will carry this data in their context array, making hover preview
    // clicks attributable to the SmartSpaceOverview Top Docs module.
    const hoverCardAnalyticsContext = (0, $42omo.useMemo)(()=>({
            attributes: {
                originSpaceKey: spaceKey,
                originSpaceId: spaceId,
                spaceOverviewTopDocsPosition: docPosition
            }
        }), [
        docPosition,
        spaceKey,
        spaceId
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>setIsHovered(true), []);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>setIsHovered(false), []);
    const handleFocus = (0, $42omo.useCallback)(()=>setIsHovered(true), []);
    const handleBlur = (0, $42omo.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) setIsHovered(false);
    }, []);
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const getContentType = (0, $42omo.useCallback)(()=>{
        const cardState = store.getState()[link.url];
        const data = cardState?.details?.data;
        const generator = data && 'generator' in data ? data.generator : undefined;
        const platform = generator && typeof generator === 'object' && '@type' in generator && generator['@type'] !== 'Link' ? generator.name : undefined;
        return {
            platform: platform,
            contentType: cardState?.details?.meta?.resourceType
        };
    }, [
        store,
        link.url
    ]);
    const handlePin = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (isPinned) {
            const pinnedDurationMs = pinnedAtRef.current !== null ? Date.now() - pinnedAtRef.current : undefined;
            pinnedAtRef.current = null;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'unpinButton',
                    source: 'smartSpaceOverview',
                    attributes: {
                        moduleType: 'topDocs',
                        docId: link.id,
                        contentType: getContentType(),
                        pinnedDurationMs: pinnedDurationMs,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        } else {
            pinnedAtRef.current = Date.now();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pinButton',
                    source: 'smartSpaceOverview',
                    attributes: {
                        moduleType: 'topDocs',
                        docId: link.id,
                        contentType: getContentType(),
                        previousPosition: docPosition,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        }
        onPin?.(link.id);
    }, [
        createAnalyticsEvent,
        getContentType,
        onPin,
        isPinned,
        link.id,
        docPosition,
        spaceKey
    ]);
    const handleRemove = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        onRemove?.(link.id);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'removeDocButton',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    docId: link.id,
                    contentType: getContentType(),
                    docPosition: docPosition,
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        getContentType,
        onRemove,
        link.id,
        docPosition,
        spaceKey
    ]);
    const handleLinkClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'card',
                actionSubjectId: 'topDoc',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    docId: link.id,
                    contentType: getContentType(),
                    docPosition: docPosition,
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        getContentType,
        link.id,
        docPosition,
        spaceKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: "link-item",
        xcss: $2a4c4438bdd7c14c$var$itemStyles.outerWrapper,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $2a4c4438bdd7c14c$var$itemStyles.row,
        justifyContent: "space-between",
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: hoverCardAnalyticsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.StandaloneHoverCard), {
        url: link.url,
        actionOptions: $2a4c4438bdd7c14c$var$hoverCardActionOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bsb1osq _1ul9idpf"
        ])
    }, link.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: link.url,
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
        icon: link.icon,
        label: link.title,
        appearance: link.iconAppearance ?? 'gray',
        size: "large"
    }))), link.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _fj13idpf _k1o1idpf _1rgbidpf _mto2idpf _1h2bu2gc _quenidpf _h5wdfhey _1jfl1r31 _cqjfglyw _wo36nqa1 _iv9li7uo _1eqa1wq8 _cphqglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        appearance: "inline",
        url: link.url,
        placeholder: link.title,
        disablePreviewPanel: true,
        ui: $2a4c4438bdd7c14c$var$cardUiProps,
        onClick: handleLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        maxLines: 1,
        position: (0, $5TXU5.SmartLinkPosition).Center,
        text: link.title,
        anchorTarget: "_blank",
        hideTitleTooltip: true,
        subtitle: $2a4c4438bdd7c14c$var$titleBlockSubtitle
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _fj13idpf _k1o1idpf _1rgbidpf _mto2idpf _1h2bu2gc _quenidpf _10as1mok _1c3d15vq _vwcq15vq _1h5mi8nm _13bx1ylp _1bqq1ylp _cphq1txw _1wdi1h6o _19s11h6o _gjdeidpf _h5wdfhey _1jfl1r31 _cqjfglyw _wo36nqa1 _iv9li7uo _1eqa1wq8"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hpUsb.Card), {
        appearance: "inline",
        url: link.url,
        placeholder: link.title,
        disablePreviewPanel: true,
        ui: $2a4c4438bdd7c14c$var$cardUiProps,
        onClick: handleLinkClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5znEc.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        maxLines: 1,
        position: (0, $5TXU5.SmartLinkPosition).Center,
        text: link.title,
        anchorTarget: "_blank",
        hideTitleTooltip: true,
        subtitle: $2a4c4438bdd7c14c$var$titleBlockSubtitle
    }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: isPinned || isHovered ? $2a4c4438bdd7c14c$var$itemStyles.actionsVisible : $2a4c4438bdd7c14c$var$itemStyles.actions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: isPinned ? (0, (/*@__PURE__*/$parcel$interopDefault($brxEJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($6V1ly))),
        label: isPinned ? formatMessage($2a4c4438bdd7c14c$var$i18n.unpin) : formatMessage($2a4c4438bdd7c14c$var$i18n.pin),
        appearance: "subtle",
        spacing: "compact",
        onClick: handlePin
    }), !isPinned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: formatMessage($2a4c4438bdd7c14c$var$i18n.remove),
        appearance: "subtle",
        spacing: "compact",
        onClick: handleRemove
    }))));
};


/* TopLinksEmptyState.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $e2ZTm = parcelRequire("e2ZTm");




const $b5b2252444058be7$export$d16cbb23892d5ea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "58",
        height: "60",
        viewBox: "0 0 58 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M5.37109 50.0781C5.37109 50.0781 30.9568 53.1209 44.1256 49.9399V3.60754C44.1256 3.60754 23.2435 8.72303 5.37109 3.33118C5.37109 3.33118 5.65298 50.2881 5.37109 50.0809V50.0781Z",
        fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 16.4585H10.8535V14.5239H38.6446V16.4585Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 23.2653H10.8535V21.3308H38.6446V23.2653Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 30.0749H10.8535V28.1404H38.6446V30.0749Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.6446 36.8818H10.8535V34.9472H38.6446V36.8818Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M52.3777 50.0975C52.4883 49.4784 52.5463 48.8207 52.5463 48.1242C52.5463 47.4278 52.4883 46.7507 52.375 46.1261C51.7062 42.398 49.1139 40.0986 45.4825 39.5072C44.8634 39.4077 44.214 39.3552 43.5369 39.3552C42.8321 39.3552 42.155 39.4105 41.5111 39.5183C37.8769 40.1263 35.2902 42.4173 34.6186 46.1261C34.5053 46.7535 34.4473 47.4195 34.4473 48.1242C34.4473 48.829 34.5053 49.4784 34.6158 50.0975C35.2819 53.8008 37.8686 56.0973 41.5111 56.7053C42.155 56.8131 42.8321 56.8684 43.5369 56.8684C44.214 56.8684 44.8634 56.8159 45.4825 56.7164C49.1194 56.125 51.7145 53.8229 52.3777 50.0975Z",
        fill: "var(--ds-chart-blue-bolder-hovered, #1868DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M44.1254 39.3718C43.9319 39.3635 43.7357 39.358 43.5339 39.358C42.8292 39.358 42.1521 39.4132 41.5082 39.521C37.874 40.1263 35.2872 42.4201 34.6157 46.1289C34.5024 46.7562 34.4443 47.4223 34.4443 48.127C34.4443 48.8234 34.5024 49.4812 34.6129 50.1002C34.682 50.4788 34.7732 50.8381 34.881 51.1891C38.2609 50.9791 41.4474 50.5894 44.1226 49.9427V39.3718H44.1254Z",
        fill: "var(--ds-text-accent-blue-bolder, #123263)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M49.5754 49.2905H37.8438V47.3559H49.5754V49.2905Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.7432 54.1876V42.4588H44.6777V54.1876H42.7432Z",
        fill: "var(--ds-icon-inverse, #FFFFFF)"
    }));


const $a0273ad7ea242640$export$9aefb52db43407b5 = ({ onSuggestDocs: onSuggestDocs, isLoading: isLoading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $a0273ad7ea242640$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b5b2252444058be7$export$d16cbb23892d5ea), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "large",
        weight: "medium",
        color: "color.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a0273ad7ea242640$var$i18n.pinImportantDocs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $a0273ad7ea242640$var$styles.buttonWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        onClick: onSuggestDocs,
        isLoading: isLoading,
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e2ZTm))), {
                ...iconProps,
                label: ""
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $a0273ad7ea242640$var$i18n.suggestDocs))));
const $a0273ad7ea242640$var$styles = {
    container: "_18zrv47k _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _1bsb1osq",
    buttonWrapper: "_1q51u2gc"
};
const $a0273ad7ea242640$var$i18n = (0, $aXWIB.defineMessages)({
    pinImportantDocs: {
        id: "space-overview.smart-space-overview.top-docs-card.empty-state.pin-docs",
        defaultMessage: "Pin important docs here"
    },
    suggestDocs: {
        id: "space-overview.smart-space-overview.top-docs-card.empty-state.suggest-docs",
        defaultMessage: "Suggest docs"
    }
});


const $33f02f0950ddab6e$var$i18n = (0, $aXWIB.defineMessages)({
    topDocs: {
        id: "space-overview.smart-space-overview.top-docs-card.title",
        defaultMessage: "Top docs"
    }
});
const $33f02f0950ddab6e$var$topLinksItemWrapperStyles = {
    itemWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _kqswh2mm _8hrz1qre",
    itemWrapperHalf: "_16jlkb7n _1o9zkb7n _i0dlhwvj _1ul9idpf _kqswh2mm _8hrz1qre"
};
const $33f02f0950ddab6e$var$TAB_PIN_FLIP_MS = 200;
const $33f02f0950ddab6e$var$TAB_PIN_FLIP_EASING = 'cubic-bezier(0.2, 0.85, 0.3, 1)';
const $33f02f0950ddab6e$var$TAB_PIN_COMPRESS_SCALE = 0.86;
const $33f02f0950ddab6e$var$maxCount = 4; /** Same URLs (multiset) as `next`, but row order follows `prev`. Refreshes `title` / `isPinned` from `next`. */ 
function $33f02f0950ddab6e$var$mergeTopLinksPreservingOrder(prev, next) {
    if (prev.length === 0 || next.length === 0 || prev.length !== next.length) return next;
    const nextByUrl = new Map(next.map((l)=>[
            l.url,
            l
        ]));
    const prevSig = [
        ...prev.map((l)=>l.url)
    ].sort().join('\0');
    const nextSig = [
        ...next.map((l)=>l.url)
    ].sort().join('\0');
    if (prevSig !== nextSig) return next;
    return prev.map((p)=>{
        const n = nextByUrl.get(p.url);
        if (!n) return p;
        return {
            ...p,
            title: n.title,
            isPinned: n.isPinned
        };
    });
} /**
   * Builds update input with `topLinks.add` (see `topLinksUpdateMutationInput.types.ts` — Relay artifact
   * input type lags the schema for `topLinks`).
   */ 
function $33f02f0950ddab6e$var$buildAddTopLinkMutationInput(spaceKey, link) {
    return {
        spaceKey: spaceKey,
        topLinks: {
            add: {
                url: link.url,
                title: link.title,
                isPinned: link.isPinned
            }
        }
    };
} /**
   * `input.topLinks` → `edit` → `ConfluenceEditTopLinkInput` (`url`, `isPinned` only — no `title`).
   */ 
function $33f02f0950ddab6e$var$buildEditTopLinkMutationInput(spaceKey, link) {
    return {
        spaceKey: spaceKey,
        topLinks: {
            edit: {
                url: link.url,
                isPinned: link.isPinned
            }
        }
    };
} /**
   * `input.topLinks` → `remove` → `ConfluenceRemoveTopLinkInput`.
   */ 
function $33f02f0950ddab6e$var$buildRemoveTopLinkMutationInput(spaceKey, url) {
    return {
        spaceKey: spaceKey,
        topLinks: {
            remove: {
                url: url
            }
        }
    };
}
const $33f02f0950ddab6e$var$topLinksCardUpdateTopLinksMutation = (0, $71c53debaf0f9345$export$2e2bcd8739ae039);
const $33f02f0950ddab6e$var$topLinksCardRefreshTopLinksMutation = (0, $096db6ea15398f90$export$2e2bcd8739ae039);
const $33f02f0950ddab6e$export$61bde326403f45f = ({ topLinks: topLinks, spaceKey: spaceKey, spaceId: spaceId })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [commitUpdateTopLinks] = (0, $308Wd.useMutationInterop)($33f02f0950ddab6e$var$topLinksCardUpdateTopLinksMutation, {
        __callerPackage__: "@confluence/space-overview"
    });
    const [commitRefreshTopLinks, { loading: isRefreshLoading }] = (0, $308Wd.useMutationInterop)($33f02f0950ddab6e$var$topLinksCardRefreshTopLinksMutation, {
        __callerPackage__: "@confluence/space-overview"
    });
    const queryLinks = (0, $42omo.useMemo)(()=>{
        const rawLinks = topLinks?.links;
        if (!rawLinks) return [];
        const mapped = rawLinks.reduce((acc, link)=>{
            if (link?.url && link?.title) acc.push({
                id: link.url,
                url: link.url,
                title: link.title,
                isPinned: link.isPinned ?? false
            });
            return acc;
        }, []);
        return mapped.slice(0, $33f02f0950ddab6e$var$maxCount);
    }, [
        topLinks
    ]);
    const [links, setLinks] = (0, $42omo.useState)(queryLinks);
    const applyPayload = (0, $42omo.useCallback)((payload, rollback, orderHint)=>{
        if (payload?.success) {
            const serverTopLinks = payload.overview?.topLinks;
            const list = serverTopLinks?.links?.filter((link)=>link != null && link.url != null && link.url !== '' && link.title != null);
            if (list != null && list.length > 0) {
                const fromServer = list.map((link)=>({
                        id: link.url,
                        url: link.url,
                        title: link.title,
                        subtitle: new URL(link.url).hostname,
                        isPinned: link.isPinned ?? false
                    }));
                const merged = orderHint != null ? $33f02f0950ddab6e$var$mergeTopLinksPreservingOrder(orderHint, fromServer) : fromServer;
                setLinks(merged);
            }
            return;
        }
        rollback();
    }, [
        setLinks
    ]);
    const applyTopLinksMutationResponse = (0, $42omo.useCallback)((data, rollback, orderHint)=>{
        applyPayload(data?.confluence_updateSmartSpaceOverview, rollback, orderHint);
    }, [
        applyPayload
    ]);
    const linksRef = (0, $42omo.useRef)(links);
    linksRef.current = links;
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const getContentType = (url)=>{
        const cardState = store.getState()[url];
        const data = cardState?.details?.data;
        const generator = data && 'generator' in data ? data.generator : undefined;
        const platform = generator && typeof generator === 'object' && '@type' in generator && generator['@type'] !== 'Link' ? generator.name : undefined;
        return {
            platform: platform,
            contentType: cardState?.details?.meta?.resourceType
        };
    };
    const isModuleHoveredRef = (0, $42omo.useRef)(false);
    const handleModuleMouseEnter = (0, $42omo.useCallback)(()=>{
        if (isModuleHoveredRef.current) return;
        isModuleHoveredRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'hovered',
                actionSubject: 'module',
                actionSubjectId: 'topDocsModule',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceKey
    ]);
    const handleModuleMouseLeave = (0, $42omo.useCallback)(()=>{
        isModuleHoveredRef.current = false;
    }, []);
    const itemWrapperRefs = (0, $42omo.useRef)(new Map());
    const prevItemRectsRef = (0, $42omo.useRef)(new Map());
    const runTabReorderFlipRef = (0, $42omo.useRef)(false);
    const primaryMotionLinkIdRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        setLinks((prev)=>$33f02f0950ddab6e$var$mergeTopLinksPreservingOrder(prev, queryLinks));
    }, [
        queryLinks
    ]);
    const isAtCapacity = links.length >= $33f02f0950ddab6e$var$maxCount;
    const handleAddLink = (linkData)=>{
        const newLink = {
            id: `${linkData.url}-${linkData.title}`,
            url: linkData.url,
            title: linkData.title,
            subtitle: new URL(linkData.url).hostname,
            isPinned: true
        };
        const nextLinks = (0, $708b3e73f2b8fa2a$export$9b320488069db95e)(links, newLink, $33f02f0950ddab6e$var$maxCount);
        runTabReorderFlipRef.current = true;
        primaryMotionLinkIdRef.current = newLink.id;
        setLinks(nextLinks);
        const variables = {
            cloudId: cloudId,
            input: $33f02f0950ddab6e$var$buildAddTopLinkMutationInput(spaceKey, newLink)
        };
        commitUpdateTopLinks({
            variables: variables
        }).then(({ data: data })=>applyTopLinksMutationResponse(data, ()=>setLinks((prevLinks)=>prevLinks.filter((link)=>link.id !== newLink.id)), nextLinks)).catch(()=>{
            setLinks((prevLinks)=>prevLinks.filter((link)=>link.id !== newLink.id));
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'submitLinkButton',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    docId: newLink.id,
                    contentType: getContentType(linkData.url),
                    inputMethod: linkData.inputMethod,
                    spaceKey: spaceKey
                }
            }
        }).fire();
    };
    const handleRemoveLink = (linkId)=>{
        const link = links.find((l)=>l.id === linkId);
        if (!link) return;
        const previousLinks = links;
        const afterRemove = previousLinks.filter((l)=>l.id !== linkId);
        setLinks(afterRemove);
        const variables = {
            cloudId: cloudId,
            input: $33f02f0950ddab6e$var$buildRemoveTopLinkMutationInput(spaceKey, link.url)
        };
        commitUpdateTopLinks({
            variables: variables
        }).then(({ data: data })=>applyTopLinksMutationResponse(data, ()=>setLinks(previousLinks), afterRemove)).catch(()=>{
            setLinks(previousLinks);
        });
    }; /** Pin and unpin both persist with `topLinks.edit` (`isPinned` true/false). */ 
    const handlePinLink = (linkId)=>{
        const previousLinks = links;
        const { nextLinks: nextLinks, didReorder: didReorder } = (0, $708b3e73f2b8fa2a$export$c42d680a28a18ad7)(previousLinks, linkId);
        const updatedLink = nextLinks.find((l)=>l.id === linkId);
        if (!updatedLink) return;
        if (didReorder) {
            runTabReorderFlipRef.current = true;
            primaryMotionLinkIdRef.current = linkId;
        }
        setLinks(nextLinks);
        const variables = {
            cloudId: cloudId,
            input: $33f02f0950ddab6e$var$buildEditTopLinkMutationInput(spaceKey, updatedLink)
        };
        commitUpdateTopLinks({
            variables: variables
        }).then(({ data: data })=>applyTopLinksMutationResponse(data, ()=>setLinks(previousLinks), nextLinks)).catch(()=>{
            setLinks(previousLinks);
        });
    };
    const handleSuggestDocs = (0, $42omo.useCallback)(()=>{
        const variables = {
            cloudId: cloudId,
            input: {
                spaceKey: spaceKey,
                topLinks: {
                    overridePinned: false
                }
            }
        };
        commitRefreshTopLinks({
            variables: variables
        }).then(({ data: data })=>{
            applyPayload(data?.confluence_refreshSmartSpaceOverview, ()=>{});
        }).catch(()=>{});
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'suggestDocsButton',
                source: 'smartSpaceOverview',
                attributes: {
                    moduleType: 'topDocs',
                    spaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        cloudId,
        spaceKey,
        commitRefreshTopLinks,
        applyPayload,
        createAnalyticsEvent
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const currentRects = new Map();
        for (const link of links){
            const el = itemWrapperRefs.current.get(link.id);
            if (el) currentRects.set(link.id, el.getBoundingClientRect());
        }
        if (runTabReorderFlipRef.current) {
            runTabReorderFlipRef.current = false;
            const primaryMotionId = primaryMotionLinkIdRef.current;
            const elementsToAnimate = new Set();
            for (const link of links){
                const el = itemWrapperRefs.current.get(link.id);
                const prev = prevItemRectsRef.current.get(link.id);
                const curr = currentRects.get(link.id);
                if (!el || !prev || !curr) continue;
                const dx = prev.left - curr.left;
                const dy = prev.top - curr.top;
                if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) {
                    const isPrimaryMotionTile = primaryMotionId !== null && link.id === primaryMotionId;
                    const compress = isPrimaryMotionTile ? ` scale(${$33f02f0950ddab6e$var$TAB_PIN_COMPRESS_SCALE})` : '';
                    el.style.transition = 'none';
                    el.style.willChange = 'transform';
                    el.style.zIndex = isPrimaryMotionTile ? '3' : '2';
                    el.style.transform = `translate(${dx}px, ${dy}px)${compress}`;
                    elementsToAnimate.add(el);
                }
            }
            if (elementsToAnimate.size > 0) requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    for (const el of elementsToAnimate){
                        el.style.transition = `transform ${$33f02f0950ddab6e$var$TAB_PIN_FLIP_MS}ms ${$33f02f0950ddab6e$var$TAB_PIN_FLIP_EASING}`;
                        el.style.transform = '';
                    }
                    window.setTimeout(()=>{
                        for (const el of elementsToAnimate){
                            el.style.transition = '';
                            el.style.transform = '';
                            el.style.willChange = '';
                            el.style.zIndex = '';
                        }
                        primaryMotionLinkIdRef.current = null;
                    }, $33f02f0950ddab6e$var$TAB_PIN_FLIP_MS + 50);
                });
            });
            else primaryMotionLinkIdRef.current = null;
        }
        prevItemRectsRef.current = currentRects;
    }, [
        links
    ]);
    const renderTopLinkItemWrapperFull = (0, $42omo.useCallback)((child, index)=>{
        const linkId = linksRef.current[index]?.id ?? (child.key != null ? String(child.key) : '');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: linkId || (child.key ?? index),
            ref: (el)=>{
                if (!linkId) return;
                if (el) itemWrapperRefs.current.set(linkId, el);
                else itemWrapperRefs.current.delete(linkId);
            },
            className: (0, $gMc0m.default)([
                $33f02f0950ddab6e$var$topLinksItemWrapperStyles.itemWrapper
            ])
        }, child);
    }, []);
    const renderTopLinkItemWrapperHalf = (0, $42omo.useCallback)((child, index)=>{
        const linkId = linksRef.current[index]?.id ?? (child.key != null ? String(child.key) : '');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            key: linkId || (child.key ?? index),
            ref: (el)=>{
                if (!linkId) return;
                if (el) itemWrapperRefs.current.set(linkId, el);
                else itemWrapperRefs.current.delete(linkId);
            },
            className: (0, $gMc0m.default)([
                $33f02f0950ddab6e$var$topLinksItemWrapperStyles.itemWrapperHalf
            ])
        }, child);
    }, []);
    const renderTopLinkItemWrapper = isAtCapacity ? renderTopLinkItemWrapperHalf : renderTopLinkItemWrapperFull;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "top-links-module",
        onMouseEnter: handleModuleMouseEnter,
        onMouseLeave: handleModuleMouseLeave,
        onFocus: handleModuleMouseEnter,
        onBlur: handleModuleMouseLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fe608f906a4fdf3e$export$60332b2344f7fe41), {
        title: $33f02f0950ddab6e$var$i18n.topDocs,
        count: links.length,
        maxCount: $33f02f0950ddab6e$var$maxCount,
        renderItemWrapper: renderTopLinkItemWrapper,
        actionButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2d6c8d1397947730$export$b665e181ecd1797), {
            onLinkSubmit: handleAddLink,
            disabled: isAtCapacity,
            existingLinks: links
        })
    }, links.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a0273ad7ea242640$export$9aefb52db43407b5), {
        onSuggestDocs: handleSuggestDocs,
        isLoading: isRefreshLoading
    }) : links.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2a4c4438bdd7c14c$export$532cb6865ebe8946), {
            key: link.id,
            link: link,
            onRemove: handleRemoveLink,
            onPin: handlePinLink,
            isPinned: link.isPinned,
            docPosition: index,
            spaceKey: spaceKey,
            spaceId: spaceId
        }))));
};
const $33f02f0950ddab6e$export$3e180c03b339583e = ({ topLinks: topLinks, spaceKey: spaceKey, spaceId: spaceId })=>{
    const initialState = window['__SSR_TOP_DOCS__'];
    const storeData = (0, $btIEy.useStoreOptions)(initialState, (0, $i6Ps3.isPageSSRd)());
    const storeOptions = (0, $i6Ps3.isPageSSRd)() ? storeData : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        authFlow: "disabled",
        ...storeOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($33f02f0950ddab6e$export$61bde326403f45f, {
        topLinks: topLinks,
        spaceKey: spaceKey,
        spaceId: spaceId
    }));
};


const $ca3580c7763f9e9f$export$56d49a1a95eb0a18 = ({ spaceKey: spaceKey, smartSpaceOverviewData: smartSpaceOverviewData, cloudId: cloudId })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const spaceOverviewQueryResult = (0, $jMyy4.useQueryInterop)((0, $ixL26.default), {
        variables: {
            spaceKey: spaceKey,
            excludeOperations: true
        },
        __callerPackage__: "@confluence/space-overview"
    });
    const spaceData = spaceOverviewQueryResult.data;
    const isAdminLoading = spaceOverviewQueryResult.loading;
    const isAdmin = spaceData?.space?.currentUser?.isAdmin ?? false;
    const isPersonalSpace = spaceData?.space?.type === 'personal';
    const spaceId = spaceData?.space?.id ?? '';
    const spaceName = spaceData?.space?.name ?? '';
    const emoji = (0, $8rneB.getEmojiFromPublishedPageProperties)(spaceData?.space?.homepage ?? null);
    const spaceIconPath = spaceData?.space?.icon?.path;
    const hasEmoji = !!emoji || !!spaceIconPath;
    const topLinks = smartSpaceOverviewData.topLinks;
    if (!contentId || !spaceKey || isAdminLoading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e1b54ae933da37d5$export$2359131f9fa9ca50), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dhfse.RecommendedSpaceBannerLoader), {
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.coverWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9c2fb682b28c513$export$4c3aaf664391b8c5), {
        contentId: contentId,
        isAdmin: isAdmin,
        hasEmoji: hasEmoji
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.logoPositioner
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c0f874fe2d27e0c7$export$36f67a5ef9dc0044), {
        spaceKey: spaceKey,
        spaceId: spaceId,
        isAdmin: isAdmin,
        isPersonalSpace: isPersonalSpace,
        emoji: emoji,
        spaceIconPath: spaceIconPath
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.contentContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $ca3580c7763f9e9f$var$styles.titleSummarySection
        ])
    }, spaceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h1",
        size: "xxlarge"
    }, spaceName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6lna.ConfluenceTeamButton), {
        containerId: (0, $lQS7C.ConfluenceSpaceAri).create({
            siteId: cloudId,
            spaceId: spaceId
        }).toString(),
        numberOfTeams: 1,
        orgId: cloudId
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d3f4a8c5a2c21120$export$54ca75a6425bb521), {
        summaryData: smartSpaceOverviewData.summary,
        spaceKey: spaceKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $33f02f0950ddab6e$export$3e180c03b339583e), {
        topLinks: topLinks,
        spaceKey: spaceKey,
        spaceId: spaceId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b940e14642ad4976$export$5f1dbecc17d9b4ee), {
        faqData: smartSpaceOverviewData.faq,
        spaceKey: spaceKey
    })));
};
const $ca3580c7763f9e9f$var$styles = {
    container: "_1yt4oahv _19pkidpf _2hwx1wug _otyridpf _18u01wug _zulpze3t _bfhkvuon _ca0qidpf _p12f1fra _1e0c1txw _2lx21bp4",
    coverWrapper: "_kqswh2mm",
    logoPositioner: "_kqswstnw _94n5ze3t _1ltvxy5q _t9ecpqlc _1pbykb7n",
    contentContainer: "_zulpxy5q _18zrxy5q _1q518vuz _1e0c1txw _2lx21bp4",
    titleSummarySection: "_zulppxbi _1e0c1txw _2lx21bp4"
};


const $3bd39c5a85a3f0c2$export$d9d632754278a62e = (0, $3hHGU.default);
const $3bd39c5a85a3f0c2$export$145c4eaf64607c26 = ({ spaceKey: spaceKey, children: children, onExperienceResolved: onExperienceResolved })=>{
    const { isRovoEnabled: isRovoEnabled, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    const trackedResolvedExperienceRef = (0, $42omo.useRef)(null);
    const smartSpaceOverviewEnabled = (0, $jpSPX.isSmartSpaceOverviewEnabled)({
        spaceKey: spaceKey,
        isRovoEnabled: isRovoEnabled,
        cloudId: cloudId
    });
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3bd39c5a85a3f0c2$export$d9d632754278a62e, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        skip: !smartSpaceOverviewEnabled,
        __callerPackage__: "@confluence/space-overview"
    });
    const smartSpaceOverviewData = data?.confluence_smartSpaceOverview;
    const hasSummary = smartSpaceOverviewData?.summary?.body !== null && smartSpaceOverviewData?.summary?.body !== undefined;
    const resolvedExperience = smartSpaceOverviewEnabled ? loading ? null : hasSummary ? 'smart' : 'regular' : 'regular';
    (0, $42omo.useEffect)(()=>{
        if (resolvedExperience) {
            onExperienceResolved?.(resolvedExperience);
            if (spaceId && trackedResolvedExperienceRef.current !== resolvedExperience) {
                trackedResolvedExperienceRef.current = resolvedExperience;
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'resolved',
                        actionSubject: 'spaceOverviewExperience',
                        source: 'spaceOverviewScreen',
                        containerId: spaceId,
                        attributes: {
                            spaceOverviewExperience: resolvedExperience,
                            spaceKey: spaceKey
                        }
                    }
                }).fire();
            }
        }
    }, [
        createAnalyticsEvent,
        resolvedExperience,
        onExperienceResolved,
        spaceId,
        spaceKey
    ]);
    if (smartSpaceOverviewEnabled) {
        if (loading) return null;
        if (hasSummary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ca3580c7763f9e9f$export$56d49a1a95eb0a18), {
            spaceKey: spaceKey,
            smartSpaceOverviewData: smartSpaceOverviewData,
            cloudId: cloudId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eiWUW.SpaceOverview), {
        spaceKey: spaceKey
    }, children);
};
module.exports["SpaceOverviewSwitcherQuery"] = $3bd39c5a85a3f0c2$export$d9d632754278a62e;
module.exports["SpaceOverviewSwitcher"] = $3bd39c5a85a3f0c2$export$145c4eaf64607c26;

});

parcelRegister("3hHGU", function(module, exports) {
/**
 * @generated SignedSource<<abae024d56bb296a6e54309a00011346>>
 * @relayHash 167c1a5fbdbb53604f3f562e570f1f91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030
const $02fb880a65c09e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "isPinned"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceSmartSpaceOverview",
            "kind": "LinkedField",
            "name": "confluence_smartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "body"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewFAQ",
                    "kind": "LinkedField",
                    "name": "faq",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewFAQEntry",
                            "kind": "LinkedField",
                            "name": "entries",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "question"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "answer"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "followUpQuestions"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewFAQSource",
                                    "kind": "LinkedField",
                                    "name": "sources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "excerpt"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "embeddedProduct"
                                                },
                                                {
                                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webui"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                    "kind": "LinkedField",
                    "name": "topLinks",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastRefreshed"
                        },
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "167c1a5fbdbb53604f3f562e570f1f91",
            "id": "9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030",
            "metadata": {},
            "name": "SpaceOverviewSwitcherQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewSwitcherQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(cloudId:$cloudId,spaceKey:$spaceKey){summary{body,isPinned},faq{entries{question,answer,followUpQuestions,sources{content{id,title,excerpt,embeddedProduct,links{webui}}}}},topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}"
        }
    };
}();
$02fb880a65c09e36$var$node.hash = "1b64f396256f01419c73a81884314905";
var $02fb880a65c09e36$export$2e2bcd8739ae039 = $02fb880a65c09e36$var$node;
module.exports["default"] = $02fb880a65c09e36$export$2e2bcd8739ae039;

});

parcelRegister("jpSPX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $cEgMD = parcelRequire("cEgMD");


var $8Psje = parcelRequire("8Psje");

const $d271b30f20f80b69$export$bb12d233342ab079 = ({ spaceKey: spaceKey, isRovoEnabled: isRovoEnabled, cloudId: cloudId })=>Boolean(cloudId) && !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && !(0, $8Psje.isRovoSystemSpaceKey)(spaceKey) && isRovoEnabled && (0, $6mKj3.expVal)('smart_space_overview', 'isEnabled', false);
module.exports["isSmartSpaceOverviewEnabled"] = $d271b30f20f80b69$export$bb12d233342ab079;

});

parcelRegister("jPACe", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4ff4f509ac781670$export$e8a47c72fec9e984 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "SUzCl",
    name: "EditorPageCoverPictureEntry",
    loader: async ()=>{
        const { EditorPageCoverPictureEntry: EditorPageCoverPictureEntry } = await (parcelRequire("3bSR9"));
        return EditorPageCoverPictureEntry;
    }
});
module.exports["EditorPageCoverPictureEntry"] = $4ff4f509ac781670$export$e8a47c72fec9e984;

});

parcelRegister("3bSR9", function(module, exports) {

let $252cf37b87908591$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $252cf37b87908591$var$load("4KvE8"),
    $252cf37b87908591$var$load("dVM1q")
]).then(()=>parcelRequire('5tKh7'));

});

parcelRegister("5d01x", function(module, exports) {
/* SourceLogoStack.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Renders a stack of overlapping product logo icons for the given source URLs.
 * Deduplicates logos and displays up to 3, with a "+X" overflow count if there
 * are more unique source types than can be displayed.
 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $2wGhm = parcelRequire("2wGhm");

const $48dbefd9a27e4f40$export$bbe9fefbd7814f35 = 3;
const $48dbefd9a27e4f40$var$styles = {
    outerContainer: "_1e0c116y _4cvr1h6o",
    overflowCount: "_12l21b66",
    container: "_1e0c116y _4cvr1h6o _kqswh2mm",
    logoWrapper: "_kqswh2mm _1e0c116y _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _ahbqx0bf",
    firstLogo: "_ahbq1i6y",
    logo: "_2rko1qi0 _189e1dm9 _1dqonqa1 _1h6dveue _1bsbgktf _4t3igktf"
};
const $48dbefd9a27e4f40$export$3b2450ab8d88608 = ({ sources: sources, hideOverflowCount: hideOverflowCount = false })=>{
    if (sources.length === 0) return null;
    const allUniqueSourceTypes = Array.from(new Set(sources.map((0, $2wGhm.getSourceType))));
    const visibleSourceTypes = allUniqueSourceTypes.slice(0, $48dbefd9a27e4f40$export$bbe9fefbd7814f35);
    const overflowCount = sources.length - visibleSourceTypes.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $48dbefd9a27e4f40$var$styles.outerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $48dbefd9a27e4f40$var$styles.container
    }, visibleSourceTypes.map((sourceType, index)=>{
        const Logo = (0, $2wGhm.getLogoForSourceType)(sourceType);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            key: sourceType,
            xcss: (0, $1Whri.cx)($48dbefd9a27e4f40$var$styles.logoWrapper, index === 0 && $48dbefd9a27e4f40$var$styles.firstLogo),
            style: {
                zIndex: visibleSourceTypes.length - index
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $48dbefd9a27e4f40$var$styles.logo
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Logo, {
            size: "xxsmall",
            shouldUseNewLogoDesign: true
        })));
    })), !hideOverflowCount && overflowCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $48dbefd9a27e4f40$var$styles.overflowCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "small",
        color: "color.text.subtlest"
    }, "+", overflowCount)));
};
module.exports["MAX_VISIBLE_LOGOS"] = $48dbefd9a27e4f40$export$bbe9fefbd7814f35;
module.exports["SourceLogoStack"] = $48dbefd9a27e4f40$export$3b2450ab8d88608;

});

parcelRegister("2wGhm", function(module, exports) {
/**
 * Maps source URLs to product logo components.
 *
 * TODO: TREX-805 — Consolidate with recommended-feed to eliminate duplication.
 * This is a copy of platform/packages/townsquare/recommended-feed/src/ui/util/SourceUtil.tsx.
 */ 
var $42omo = parcelRequire("42omo");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");

/** Fallback icon for unrecognized source URLs. */ const $47223c9953757ad7$var$UnknownIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
        appearance: "neutral",
        label: "",
        size: "xxsmall"
    });
const $47223c9953757ad7$var$LogoMap = {
    jira: (0, $lAFHW.JiraIcon),
    confluence: (0, $lAFHW.ConfluenceIcon),
    bitbucket: (0, $lAFHW.BitbucketIcon),
    loom: (0, $lAFHW.LoomIcon),
    goals: (0, $lAFHW.GoalsIcon),
    projects: (0, $lAFHW.ProjectsIcon),
    teams: (0, $lAFHW.TeamsIcon),
    home: (0, $lAFHW.HomeIcon),
    unknown: $47223c9953757ad7$var$UnknownIcon
};
function $47223c9953757ad7$export$369d94b7632e2acd(source) {
    const lowerSource = source.toLowerCase();
    if (lowerSource.includes('/browse/') || lowerSource.includes('/jira/')) return 'jira';
    if (lowerSource.includes('/wiki/')) return 'confluence';
    if (lowerSource.includes('bitbucket')) return 'bitbucket';
    if (lowerSource.includes('loom.com')) return 'loom';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/goal/')) return 'goals';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/project/')) return 'projects';
    if (lowerSource.includes('home.atlassian.com') && lowerSource.includes('/people/')) return 'teams';
    if (lowerSource.includes('home.atlassian.com')) return 'home';
    return 'unknown';
}
function $47223c9953757ad7$export$70ffc3122e8f5e93(sourceType) {
    return $47223c9953757ad7$var$LogoMap[sourceType];
}
module.exports["getSourceType"] = $47223c9953757ad7$export$369d94b7632e2acd;
module.exports["getLogoForSourceType"] = $47223c9953757ad7$export$70ffc3122e8f5e93;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("4iPjq", function(module, exports) {

var $aqrhZ = parcelRequire("aqrhZ");


var $5wEPK = parcelRequire("5wEPK");


const $74848600c16eb369$var$LazyLinkPickerComponent = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("1Fw1a")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $74848600c16eb369$var$_default_1 = (0, $5wEPK.composeLinkPicker)($74848600c16eb369$var$LazyLinkPickerComponent);
var $74848600c16eb369$export$2e2bcd8739ae039 = $74848600c16eb369$var$_default_1;
module.exports["default"] = $74848600c16eb369$export$2e2bcd8739ae039;

});

parcelRegister("5wEPK", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


var $bYRk6 = parcelRequire("bYRk6");


var $2lNr8 = parcelRequire("2lNr8");


var $knjgj = parcelRequire("knjgj");


var $918lS = parcelRequire("918lS");


var $jrfDA = parcelRequire("jrfDA");


var $lQSkW = parcelRequire("lQSkW");

const $99bf16152ad1d840$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $99bf16152ad1d840$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $2lNr8.COMPONENT_NAME),
    source: (0, $2lNr8.COMPONENT_NAME)
};
const $99bf16152ad1d840$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $99bf16152ad1d840$var$fixedWidthContainerStyles = null;
const $99bf16152ad1d840$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb1ubl"
        ])
    });
};
const $99bf16152ad1d840$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $42omo.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $99bf16152ad1d840$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
            data: $99bf16152ad1d840$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $knjgj.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lQSkW.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $2lNr8.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($99bf16152ad1d840$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $918lS.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aqrhZ.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrfDA.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(RootComponent, {
            ...props,
            "data-testid": $99bf16152ad1d840$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $99bf16152ad1d840$export$922eb685ceb4a294;

});

parcelRegister("2lNr8", function(module, exports) {
const $7282d690d6f118fb$export$85183a312807388d = 'media';
const $7282d690d6f118fb$export$fc44104665f4d1e5 = 'linkPicker';
const $7282d690d6f118fb$export$452f1062ecf44be7 = 5;
const $7282d690d6f118fb$export$bf31a09f182d5584 = 342;
const $7282d690d6f118fb$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $7282d690d6f118fb$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $7282d690d6f118fb$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $7282d690d6f118fb$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $7282d690d6f118fb$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $7282d690d6f118fb$export$542fb16962bf430c;

});

parcelRegister("knjgj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $hzd6s = parcelRequire("hzd6s");

const $56c0565d5892d700$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $56c0565d5892d700$export$3285420c698bc605 = /*#__PURE__*/ (0, $42omo.createContext)($56c0565d5892d700$export$c07727f5eddb98f);
const $56c0565d5892d700$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $42omo.useRef)((0, $dQl1W.v4)());
    (0, $42omo.useEffect)(()=>{
        (0, $hzd6s.startUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
        return ()=>(0, $hzd6s.abortUfoExperience)((0, $hzd6s.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($56c0565d5892d700$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $56c0565d5892d700$export$36ecc935abdc3636 = ()=>(0, $42omo.useContext)($56c0565d5892d700$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $56c0565d5892d700$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $56c0565d5892d700$export$36ecc935abdc3636;

});

parcelRegister("hzd6s", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $f665373313765471$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $f665373313765471$var$ufoExperiences = {
    [$f665373313765471$export$f9c7780c574346a2.mounted]: new (0, $9801n.ConcurrentExperience)($f665373313765471$export$f9c7780c574346a2.mounted, {
        type: (0, $iqaft.ExperienceTypes).Load,
        performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $f665373313765471$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $f665373313765471$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $f665373313765471$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $f665373313765471$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $f665373313765471$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $f665373313765471$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $f665373313765471$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $f665373313765471$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $f665373313765471$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $f665373313765471$export$b1021040eb94cdca;

});

parcelRegister("918lS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hzd6s = parcelRequire("hzd6s");


var $2lNr8 = parcelRequire("2lNr8");


var $abGcM = parcelRequire("abGcM");


var $knjgj = parcelRequire("knjgj");


var $khavy = parcelRequire("khavy");


var $3blls = parcelRequire("3blls");

function $4548d496336bec74$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $knjgj.useLinkPickerSessionId)();
    const handleError = (0, $42omo.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $abGcM.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $2lNr8.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $hzd6s.failUfoExperience)((0, $hzd6s.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $khavy.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $3blls.ErrorBoundaryFallback)
    }, children);
}
module.exports["ErrorBoundary"] = $4548d496336bec74$export$e926676385687eaf;

});

parcelRegister("abGcM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $1d2d80882026b768$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $1d2d80882026b768$export$2e2bcd8739ae039 = $1d2d80882026b768$var$createEventPayload;
module.exports["default"] = $1d2d80882026b768$export$2e2bcd8739ae039;

});

parcelRegister("khavy", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $096b317da4a8d9ff$export$688779ac61ee945f extends (0, $42omo.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $096b317da4a8d9ff$export$688779ac61ee945f;

});

parcelRegister("3blls", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $2lNr8 = parcelRequire("2lNr8");


var $c2ARh = parcelRequire("c2ARh");


var $atwsN = parcelRequire("atwsN");


var $lO9iE = parcelRequire("lO9iE");

const $6fbfcea2b9f5c943$var$errorBoundaryFallbackStyles = null;
const $6fbfcea2b9f5c943$var$messages = (0, $aXWIB.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $6fbfcea2b9f5c943$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const header = intl.formatMessage($6fbfcea2b9f5c943$var$messages.heading);
    const description = intl.formatMessage($6fbfcea2b9f5c943$var$messages.description);
    return /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
        minHeight: (0, $2lNr8.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $gMc0m.default)([
            "_11c8i4vh"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $atwsN.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $42omo.createElement((0, $c2ARh.GenericErrorSVG), null),
        description: description
    }));
};
module.exports["ErrorBoundaryFallback"] = $6fbfcea2b9f5c943$export$8a28b7e38e4685dd;

});

parcelRegister("c2ARh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $2890d1e9307e8ae4$var$SIZE = 96;
const $2890d1e9307e8ae4$var$genericErrorStyles = null;
const $2890d1e9307e8ae4$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $2890d1e9307e8ae4$export$e54420a1a27457a4;

});

parcelRegister("atwsN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");

const $e8c7333955d8c82e$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $e8c7333955d8c82e$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $1s5hv.default), {
        xcss: $e8c7333955d8c82e$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $42omo.createElement((0, $cO1el.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $e8c7333955d8c82e$export$fddf379e22a74b00;

});

parcelRegister("lO9iE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

const $562443300071d672$var$minHeightComponentStyles = null;
const $562443300071d672$export$42134e2a251518b3 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $562443300071d672$export$42134e2a251518b3;

});

parcelRegister("jrfDA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $lO9iE = parcelRequire("lO9iE");

const $c92e1a3420d5d33f$var$styles = null;
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $c92e1a3420d5d33f$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $c92e1a3420d5d33f$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $c92e1a3420d5d33f$export$d96e921133238c41 = (props)=>{
    const minHeight = $c92e1a3420d5d33f$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $42omo.createElement((0, $lO9iE.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $gMc0m.default)([
            "_4cvr1h6o"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $9hlns.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $c92e1a3420d5d33f$export$d96e921133238c41;

});

parcelRegister("lQSkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ab7LA = parcelRequire("ab7LA");

const $6958f3d9e68e6f8d$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab7LA.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $6958f3d9e68e6f8d$export$54320b51a950d54a;

});

parcelRegister("ab7LA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $iaMDd = parcelRequire("iaMDd");


var $3lHRF = parcelRequire("3lHRF");

const $42f9fe6b4d8a0292$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $keVvA.default), {
        defaultMessages: (0, $iaMDd.default),
        loaderFn: (0, $3lHRF.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $42f9fe6b4d8a0292$export$d013d33430f9fb4b;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

function $e1a1ee666860bb23$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $42omo.useRef)(localeState.locale);
    (0, $42omo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $aXWIB.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $aXWIB.IntlContext));
    if (!context) return (0, $aXWIB.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("3lHRF", function(module, exports) {

var $aWYpi = parcelRequire("aWYpi");

const $b1e230aff09883c2$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $aWYpi.locales)) {
            const messages = await (0, $aWYpi.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $b1e230aff09883c2$export$2b153a2030b0feb2;

});

parcelRegister("aWYpi", function(module, exports) {

























const $c4ed7fdc8607c9f9$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("49ni4")),
    da: ()=>(parcelRequire("9i24I")),
    de: ()=>(parcelRequire("3GGRL")),
    en_GB: ()=>(parcelRequire("f9H50")),
    en_ZZ: ()=>(parcelRequire("ecHgQ")),
    en: ()=>Promise.resolve((parcelRequire("iaMDd"))),
    es: ()=>(parcelRequire("b9n7m")),
    fi: ()=>(parcelRequire("9Ymrs")),
    fr: ()=>(parcelRequire("c09we")),
    hu: ()=>(parcelRequire("eWHOv")),
    it: ()=>(parcelRequire("joBHN")),
    ja: ()=>(parcelRequire("EDSZV")),
    ko: ()=>(parcelRequire("f5q2I")),
    nb: ()=>(parcelRequire("rJqkb")),
    nl: ()=>(parcelRequire("58PdT")),
    pl: ()=>(parcelRequire("enArn")),
    pt_BR: ()=>(parcelRequire("5XYTp")),
    ru: ()=>(parcelRequire("k3D4M")),
    sv: ()=>(parcelRequire("819Nj")),
    th: ()=>(parcelRequire("khF3L")),
    tr: ()=>(parcelRequire("3Shvv")),
    uk: ()=>(parcelRequire("7MpfQ")),
    vi: ()=>(parcelRequire("bbM1s")),
    zh_TW: ()=>(parcelRequire("hE3F1")),
    zh: ()=>(parcelRequire("dpRbE"))
};
module.exports["locales"] = $c4ed7fdc8607c9f9$export$df1c34db1371eeed;

});

parcelRegister("49ni4", function(module, exports) {

let $305a11b60fea096a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $305a11b60fea096a$var$load("4Mixi"),
    $305a11b60fea096a$var$load("1jsQH"),
    $305a11b60fea096a$var$load("i5eMd"),
    $305a11b60fea096a$var$load("bv8GZ"),
    $305a11b60fea096a$var$load("i9sd0"),
    $305a11b60fea096a$var$load("4DYJ5"),
    $305a11b60fea096a$var$load("gyXEE"),
    $305a11b60fea096a$var$load("hoPZ9")
]).then(()=>parcelRequire('k82rV'));

});

parcelRegister("9i24I", function(module, exports) {

let $6c376795d61b5f16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6c376795d61b5f16$var$load("cjveN"),
    $6c376795d61b5f16$var$load("deyvi"),
    $6c376795d61b5f16$var$load("4UPfH"),
    $6c376795d61b5f16$var$load("cdeuH"),
    $6c376795d61b5f16$var$load("aNg21"),
    $6c376795d61b5f16$var$load("hfFxJ"),
    $6c376795d61b5f16$var$load("1Mp9N"),
    $6c376795d61b5f16$var$load("2Fu3d")
]).then(()=>parcelRequire('5CXR9'));

});

parcelRegister("3GGRL", function(module, exports) {

let $2af68baa2ba0afdb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2af68baa2ba0afdb$var$load("8XGJb"),
    $2af68baa2ba0afdb$var$load("6dERU"),
    $2af68baa2ba0afdb$var$load("gd4qs"),
    $2af68baa2ba0afdb$var$load("7gF8f"),
    $2af68baa2ba0afdb$var$load("YEGhv"),
    $2af68baa2ba0afdb$var$load("gofGr"),
    $2af68baa2ba0afdb$var$load("dBb6q"),
    $2af68baa2ba0afdb$var$load("eJgH8")
]).then(()=>parcelRequire('28QMN'));

});

parcelRegister("f9H50", function(module, exports) {

let $b0891d001c3b0f5d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b0891d001c3b0f5d$var$load("hdvZr"),
    $b0891d001c3b0f5d$var$load("kTurq"),
    $b0891d001c3b0f5d$var$load("fviv5"),
    $b0891d001c3b0f5d$var$load("djb49"),
    $b0891d001c3b0f5d$var$load("d8WL7"),
    $b0891d001c3b0f5d$var$load("2RQvP"),
    $b0891d001c3b0f5d$var$load("7Lkvk")
]).then(()=>parcelRequire('b4NXj'));

});

parcelRegister("ecHgQ", function(module, exports) {

let $a573c0545bc835b1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a573c0545bc835b1$var$load("4ViGN"),
    $a573c0545bc835b1$var$load("j0PWv"),
    $a573c0545bc835b1$var$load("eBoC7"),
    $a573c0545bc835b1$var$load("ksTQ6"),
    $a573c0545bc835b1$var$load("j5F5K"),
    $a573c0545bc835b1$var$load("7NpX8"),
    $a573c0545bc835b1$var$load("cukQS"),
    $a573c0545bc835b1$var$load("5FaEJ")
]).then(()=>parcelRequire('5SuH4'));

});

parcelRegister("b9n7m", function(module, exports) {

let $81e277acab2bd080$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $81e277acab2bd080$var$load("32vlK"),
    $81e277acab2bd080$var$load("dlmud"),
    $81e277acab2bd080$var$load("bNv64"),
    $81e277acab2bd080$var$load("5CGnz"),
    $81e277acab2bd080$var$load("dXu4x"),
    $81e277acab2bd080$var$load("bFU3Y"),
    $81e277acab2bd080$var$load("3CucM"),
    $81e277acab2bd080$var$load("9yemY")
]).then(()=>parcelRequire('7TuuZ'));

});

parcelRegister("9Ymrs", function(module, exports) {

let $742b201de0044ee5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $742b201de0044ee5$var$load("bjoGV"),
    $742b201de0044ee5$var$load("cbkj0"),
    $742b201de0044ee5$var$load("4Afgd"),
    $742b201de0044ee5$var$load("9Oxgj"),
    $742b201de0044ee5$var$load("18TX5"),
    $742b201de0044ee5$var$load("exaJ2"),
    $742b201de0044ee5$var$load("lp8Wm"),
    $742b201de0044ee5$var$load("l2LZP")
]).then(()=>parcelRequire('ezgWl'));

});

parcelRegister("c09we", function(module, exports) {

let $8bccde637f75ef88$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8bccde637f75ef88$var$load("8oiz7"),
    $8bccde637f75ef88$var$load("17m16"),
    $8bccde637f75ef88$var$load("cMubu"),
    $8bccde637f75ef88$var$load("kAg8V"),
    $8bccde637f75ef88$var$load("9Cdzw"),
    $8bccde637f75ef88$var$load("hcCcg"),
    $8bccde637f75ef88$var$load("cHWSM"),
    $8bccde637f75ef88$var$load("35Ssm")
]).then(()=>parcelRequire('gYv97'));

});

parcelRegister("eWHOv", function(module, exports) {

let $ae1877f695269b3f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae1877f695269b3f$var$load("hFxmj"),
    $ae1877f695269b3f$var$load("b4NO6"),
    $ae1877f695269b3f$var$load("3fLE9"),
    $ae1877f695269b3f$var$load("fM2oh"),
    $ae1877f695269b3f$var$load("guNAg"),
    $ae1877f695269b3f$var$load("j9KTb"),
    $ae1877f695269b3f$var$load("b37xN"),
    $ae1877f695269b3f$var$load("ik6u5")
]).then(()=>parcelRequire('bVNwo'));

});

parcelRegister("joBHN", function(module, exports) {

let $e1ed81b248c56b08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e1ed81b248c56b08$var$load("BXOZB"),
    $e1ed81b248c56b08$var$load("1K1Fj"),
    $e1ed81b248c56b08$var$load("8hOn0"),
    $e1ed81b248c56b08$var$load("xnqy2"),
    $e1ed81b248c56b08$var$load("cM3gY"),
    $e1ed81b248c56b08$var$load("3hjAq"),
    $e1ed81b248c56b08$var$load("7PjNK"),
    $e1ed81b248c56b08$var$load("Vt6S9")
]).then(()=>parcelRequire('lxZVf'));

});

parcelRegister("EDSZV", function(module, exports) {

let $07a2ad1527c69f6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $07a2ad1527c69f6b$var$load("9Xiuh"),
    $07a2ad1527c69f6b$var$load("38sfA"),
    $07a2ad1527c69f6b$var$load("h4OCL"),
    $07a2ad1527c69f6b$var$load("awkVi"),
    $07a2ad1527c69f6b$var$load("6yRq3"),
    $07a2ad1527c69f6b$var$load("2bCHJ"),
    $07a2ad1527c69f6b$var$load("ktSfi"),
    $07a2ad1527c69f6b$var$load("9GZ76")
]).then(()=>parcelRequire('hflsJ'));

});

parcelRegister("f5q2I", function(module, exports) {

let $afbb862f455b1607$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $afbb862f455b1607$var$load("7Odo3"),
    $afbb862f455b1607$var$load("bjmre"),
    $afbb862f455b1607$var$load("bcQs2"),
    $afbb862f455b1607$var$load("11DLa"),
    $afbb862f455b1607$var$load("cft22"),
    $afbb862f455b1607$var$load("fdXnq"),
    $afbb862f455b1607$var$load("iouLY"),
    $afbb862f455b1607$var$load("4sOIV")
]).then(()=>parcelRequire('73LWR'));

});

parcelRegister("rJqkb", function(module, exports) {

let $0535c1e8d4cff100$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0535c1e8d4cff100$var$load("4VkvT"),
    $0535c1e8d4cff100$var$load("asvK9"),
    $0535c1e8d4cff100$var$load("aBa7j"),
    $0535c1e8d4cff100$var$load("barSq"),
    $0535c1e8d4cff100$var$load("gctEz"),
    $0535c1e8d4cff100$var$load("cItJR"),
    $0535c1e8d4cff100$var$load("hPZE5"),
    $0535c1e8d4cff100$var$load("QTjdE")
]).then(()=>parcelRequire('h0YR4'));

});

parcelRegister("58PdT", function(module, exports) {

let $3be56eed8368bce0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3be56eed8368bce0$var$load("g5qJV"),
    $3be56eed8368bce0$var$load("7v6wU"),
    $3be56eed8368bce0$var$load("b544F"),
    $3be56eed8368bce0$var$load("a8heY"),
    $3be56eed8368bce0$var$load("9PPH7"),
    $3be56eed8368bce0$var$load("SctKm"),
    $3be56eed8368bce0$var$load("dzIm8"),
    $3be56eed8368bce0$var$load("hrf1M")
]).then(()=>parcelRequire('573SD'));

});

parcelRegister("enArn", function(module, exports) {

let $a77f7b0327a81145$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a77f7b0327a81145$var$load("dPa6p"),
    $a77f7b0327a81145$var$load("aEpRh"),
    $a77f7b0327a81145$var$load("K6fhx"),
    $a77f7b0327a81145$var$load("6hlNE"),
    $a77f7b0327a81145$var$load("1y1eN"),
    $a77f7b0327a81145$var$load("1fJz1"),
    $a77f7b0327a81145$var$load("jqwnR"),
    $a77f7b0327a81145$var$load("lsloj")
]).then(()=>parcelRequire('8sMYh'));

});

parcelRegister("5XYTp", function(module, exports) {

let $4581b27058c75bd4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4581b27058c75bd4$var$load("iG4uh"),
    $4581b27058c75bd4$var$load("3fuR9"),
    $4581b27058c75bd4$var$load("gZU54"),
    $4581b27058c75bd4$var$load("2bqSD"),
    $4581b27058c75bd4$var$load("e8jpx"),
    $4581b27058c75bd4$var$load("9yA8o"),
    $4581b27058c75bd4$var$load("bGhLc"),
    $4581b27058c75bd4$var$load("iRKhU")
]).then(()=>parcelRequire('lRfBG'));

});

parcelRegister("k3D4M", function(module, exports) {

let $e9a266292735eae2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e9a266292735eae2$var$load("9tVE8"),
    $e9a266292735eae2$var$load("fMrUo"),
    $e9a266292735eae2$var$load("4Wdqb"),
    $e9a266292735eae2$var$load("bJykp"),
    $e9a266292735eae2$var$load("fjbzp"),
    $e9a266292735eae2$var$load("448N7"),
    $e9a266292735eae2$var$load("9v6ER"),
    $e9a266292735eae2$var$load("aEAsN")
]).then(()=>parcelRequire('hZouV'));

});

parcelRegister("819Nj", function(module, exports) {

let $5d6603af87dbf1fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5d6603af87dbf1fc$var$load("6UAlo"),
    $5d6603af87dbf1fc$var$load("9eNkX"),
    $5d6603af87dbf1fc$var$load("k10Cs"),
    $5d6603af87dbf1fc$var$load("dh2Er"),
    $5d6603af87dbf1fc$var$load("1pFHs"),
    $5d6603af87dbf1fc$var$load("gBDdh"),
    $5d6603af87dbf1fc$var$load("8Mz40"),
    $5d6603af87dbf1fc$var$load("l6YHr")
]).then(()=>parcelRequire('4LH4L'));

});

parcelRegister("khF3L", function(module, exports) {

let $ec453ec2806faba2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec453ec2806faba2$var$load("jYGxH").then(()=>parcelRequire('hlxQj'));

});

parcelRegister("3Shvv", function(module, exports) {

let $2d23fecbe4644720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d23fecbe4644720$var$load("czAFw").then(()=>parcelRequire('gQkbc'));

});

parcelRegister("7MpfQ", function(module, exports) {

let $5aa09b1e53b19903$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5aa09b1e53b19903$var$load("c0Efy").then(()=>parcelRequire('lC9hp'));

});

parcelRegister("bbM1s", function(module, exports) {

let $8255f915989d7a01$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8255f915989d7a01$var$load("dKBuH").then(()=>parcelRequire('fzD7h'));

});

parcelRegister("hE3F1", function(module, exports) {

let $cd890306c10c6d8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cd890306c10c6d8a$var$load("ia9y3"),
    $cd890306c10c6d8a$var$load("j9OUx"),
    $cd890306c10c6d8a$var$load("l079e"),
    $cd890306c10c6d8a$var$load("bV8sS"),
    $cd890306c10c6d8a$var$load("kKXTS"),
    $cd890306c10c6d8a$var$load("ebljE"),
    $cd890306c10c6d8a$var$load("hF4v3"),
    $cd890306c10c6d8a$var$load("afU9w")
]).then(()=>parcelRequire('6PXdj'));

});

parcelRegister("dpRbE", function(module, exports) {

let $9c46ddff53e4b24d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c46ddff53e4b24d$var$load("15ncj"),
    $9c46ddff53e4b24d$var$load("gDiIK"),
    $9c46ddff53e4b24d$var$load("f1B4n"),
    $9c46ddff53e4b24d$var$load("eLlpV"),
    $9c46ddff53e4b24d$var$load("7sItg"),
    $9c46ddff53e4b24d$var$load("j4dSZ"),
    $9c46ddff53e4b24d$var$load("1Tuyb"),
    $9c46ddff53e4b24d$var$load("7iCpI")
]).then(()=>parcelRequire('5WXmf'));

});

parcelRegister("1Fw1a", function(module, exports) {

let $137274d4507a3181$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $137274d4507a3181$var$load("3Zwna"),
    $137274d4507a3181$var$load("6wr18"),
    $137274d4507a3181$var$load("27glK"),
    $137274d4507a3181$var$load("bvY53"),
    $137274d4507a3181$var$load("7EorR"),
    $137274d4507a3181$var$load("Wowvf"),
    $137274d4507a3181$var$load("hhss7"),
    $137274d4507a3181$var$load("ffEVr"),
    $137274d4507a3181$var$load("c0JsV")
]).then(()=>parcelRequire('cDSVd'));

});

parcelRegister("8fW0f", function(module, exports) {

var $4CPyF = parcelRequire("4CPyF");

var $aQaGv = parcelRequire("aQaGv");


var $dh538 = parcelRequire("dh538");


var $6hu6G = parcelRequire("6hu6G");


var $7dyLS = parcelRequire("7dyLS");


var $44rik = parcelRequire("44rik");


var $k1Kn6 = parcelRequire("k1Kn6");


var $4LCen = parcelRequire("4LCen");


var $7OCSv = parcelRequire("7OCSv");


var $1MqUK = parcelRequire("1MqUK");

const $072a50f740811d00$export$452f1062ecf44be7 = 5;
const $072a50f740811d00$var$DEBOUNCE_MS = 400;
/**
 * Plugin responsible for handling fetching + caching of Atlassian Link Picker results
 */ class $072a50f740811d00$var$AtlassianLinkPickerPlugin {
    /**
   * Create search provider if config params are provided
   */ createSearchProvider(scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri) {
        if (!this.cloudId || !scope) return undefined;
        return Promise.resolve(new (0, $4LCen.default)(this.cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri, this.cloudIds));
    }
    /**
   * Filter out fields from recent or search items.
   * @param items The recent items to remove fields from.
   * @returns Items with fields removed.
   */ filterListItemFields(items) {
        // Assume this.products won't change during function call
        const products = this.products;
        // We can't filter out items if we don't have a product or we have more than one product,
        // as we can't tell which product a given item is from.
        if (products?.length !== 1) return items;
        // Config of map of products to fields to filter out from each item
        const productFieldsMap = {
            townsquare: [
                'lastViewedDate',
                'lastUpdatedDate',
                'container'
            ]
        };
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            // Set fields to be undefined when they have been specified to be based on a given product in productFieldsMap
            for (const [productToCheck, fieldsToCheck] of Object.entries(productFieldsMap)){
                if (products[0] === productToCheck) for (const field of fieldsToCheck)newItem[field] = undefined;
            }
            return newItem;
        });
    }
    /**
   * Set lastUpdatedDate for Loom search results and unset lastViewedDate.
   * @param items The recent Loom items .
   * @returns Items with lastUpdatedDate set.
   */ setLoomRecentItemsDateField(items) {
        return items.map((item)=>{
            const newItem = {
                ...item
            };
            newItem.lastViewedDate = item.lastUpdatedDate;
            newItem.lastUpdatedDate = undefined;
            return newItem;
        });
    }
    /**
   * Retrieve recent items from the activity provider
   */ async getRecentItems() {
        if (!this.activityClient) return [];
        if (!this.recentItems) {
            const { viewed: items } = await this.activityClient.fetchActivities([
                50,
                125,
                250
            ], // retries
            {
                limit: 100,
                products: this.products,
                rootContainerIds: this.allowMultiSiteRecents ? this.cloudIds?.reduce((acc, cloudId)=>acc.concat(...(0, $1MqUK.getArisForProducts)(this.products, cloudId)), []) : // If cloudIds array is provided, do not scope activities query
                this.cloudId !== undefined && !this.isMultisiteSearch ? (0, $1MqUK.getArisForProducts)(this.products, this.cloudId) : undefined
            }, [
                'viewed'
            ], true);
            this.recentItems = items.map((0, $1MqUK.mapActivityClientResultToLinkSearchItemData));
            this.recentItems = this.filterListItemFields(this.recentItems);
        }
        return this.recentItems;
    }
    /**
   * Given a query, search the activity provider for recent activity
   */ async searchRecentItems({ query: query }) {
        if (!this.recentItems) await this.getRecentItems();
        return (0, $44rik.filterItems)(this.recentItems, query);
    }
    async quickSearch(state) {
        const isLoomRecentSearch = this._scope === (0, $7dyLS.Scope).Loom && state.query.length === 0;
        // similar to getRecentItems() we return the initial recent result when query string is reset
        if (isLoomRecentSearch && this._loomRecentItems) return this._loomRecentItems;
        const items = await this.debouncedSearch(state.query);
        let searchListItems = items.map((0, $k1Kn6.mapSearchProviderResultToLinkSearchItemData));
        // For Loom both recent and search results are fetched from search client. When search query is empty
        // the search returns recent items, when the query is not empty it returns searched items.
        // The setLoomRecentItemsDateField method sets the correct date field for the UI to consume.
        if (isLoomRecentSearch) {
            searchListItems = this.setLoomRecentItemsDateField(searchListItems);
            this._loomRecentItems = searchListItems;
        }
        return this.filterListItemFields(searchListItems);
    }
    /**
   * Merge list of recent items and search items, and dedupes
   */ mergeResults(itemsA, itemsB) {
        // Dedupe the items based on the URL
        return (0, $4CPyF.filterUniqueItems)([
            ...itemsA,
            ...itemsB
        ], (itemA, itemB)=>itemA.url === itemB.url);
    }
    applyPluginFilter(items) {
        return items.filter(({ objectId: objectId })=>this._pluginItemFilter?.(objectId) ?? true).filter(({ objectId: objectId, url: url })=>this._pluginDataFilter?.({
                id: objectId,
                url: url
            }) ?? true);
    }
    /**
   * Given link picker state yields updates to the list of link picker results
   * The plugin is considered to be in a loading state until the generator returns a final value
   * The plugin can yield intermediate lists of results to present the user with initial results
   * while loading additional results to update the list with.
   */ async *resolve(state) {
        if (this.activityClient && state.query.length === 0) return {
            data: this.applyPluginFilter(await this.getRecentItems())
        };
        // Filter recents based on current state
        const filteredRecentItems = this.applyPluginFilter(await this.searchRecentItems(state));
        // If we have enough results, or there's no search provider to fetch more, return what we have
        if (filteredRecentItems.length >= $072a50f740811d00$export$452f1062ecf44be7 || !this.searchProvider) return {
            data: filteredRecentItems
        };
        if (filteredRecentItems.length) // Update with what we have while we search for more
        yield {
            data: filteredRecentItems
        };
        // Get more results and return them merged with recents
        const searchResults = this.applyPluginFilter(await this.quickSearch(state));
        return {
            data: this.mergeResults(filteredRecentItems, searchResults)
        };
    }
    emptyStateNoResults() {
        if ((0, $dh538.fg)('link-picker-atl-plugin-empty-state')) {
            if (!this.activityClient) return null; // recent activity isn't supported, so leave this as blank
            if (!this.products || this.products.length !== 1) // don't support multi-product, as message gets too confusing
            return null;
            return (0, $7OCSv.renderEmptyStateNoResults)(this.products[0], this.action, this.cloudId, this.isMultisiteSearch);
        }
        return null;
    }
    get tabKey() {
        return this._tabKey;
    }
    get tabTitle() {
        return this._tabTitle;
    }
    get action() {
        return this._action;
    }
    constructor(config){
        this._tabKey = void 0;
        this._tabTitle = void 0;
        this.products = void 0;
        this.debouncedSearch = void 0;
        this.searchProvider = void 0;
        this.activityClient = void 0;
        this.recentItems = void 0;
        this.analyticsIdentifier = 'link-picker-quick-search';
        this.useConfluenceTypeInAri = true;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.isMultisiteSearch = void 0;
        this.allowMultiSiteRecents = void 0;
        this._action = void 0;
        this._scope = void 0;
        this._loomRecentItems = void 0;
        this._pluginItemFilter = void 0;
        this._pluginDataFilter = void 0;
        const { tabConfig: tabConfig, activityClientEndpoint: activityClientEndpoint, disableActivityClient: disableActivityClient = false, searchProvider: searchProvider, cloudId: cloudId, cloudIds: cloudIds, scope: scope, products: products, aggregatorUrl: aggregatorUrl, action: action, itemFilter: itemFilter, dataFilter: dataFilter, allowMultiSiteRecents: allowMultiSiteRecents } = config ?? {};
        const { tabKey: tabKey, tabTitle: tabTitle } = tabConfig ?? {};
        this._tabKey = tabKey || 'Atlassian';
        this._tabTitle = tabTitle || 'Atlassian';
        this.products = products;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.isMultisiteSearch = (this.cloudIds?.length ?? 0) > 0;
        this.allowMultiSiteRecents = this.isMultisiteSearch && allowMultiSiteRecents;
        this._action = action;
        this._scope = scope;
        this._pluginItemFilter = itemFilter;
        this._pluginDataFilter = dataFilter;
        this.searchProvider = searchProvider || this.createSearchProvider(scope, aggregatorUrl, this.analyticsIdentifier, this.useConfluenceTypeInAri);
        if (!disableActivityClient) this.activityClient = (0, $6hu6G.createActivityClient)('v3', 'link_picker_atlassian_plugin', undefined, activityClientEndpoint);
        this.debouncedSearch = (0, $aQaGv.promiseDebounce)(async (query)=>{
            if (!this.searchProvider) return [];
            const searchProvider = await this.searchProvider;
            return searchProvider.quickSearch(query, $072a50f740811d00$export$452f1062ecf44be7);
        }, $072a50f740811d00$var$DEBOUNCE_MS);
    }
}
var $072a50f740811d00$export$2e2bcd8739ae039 = $072a50f740811d00$var$AtlassianLinkPickerPlugin;
module.exports["default"] = $072a50f740811d00$export$2e2bcd8739ae039;

});

parcelRegister("4CPyF", function(module, exports) {
/**
 * Filters array to a set of unique items given a predicate/comparator function
 * @param arr Initial array of items
 * @param comparator Predicate function
 * @returns Array of filtered / unique items
 */ function $b8ef4b094e13b3c4$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}
module.exports["filterUniqueItems"] = $b8ef4b094e13b3c4$export$8437fc55448c6e05;

});

parcelRegister("aQaGv", function(module, exports) {
/**
 * Given a callback function returns a promise that resolves to the result of calling the callback function but is
 * debounced (execution is cancelled and promise will remain pending if `promiseDebounce` is re-called within the `time` interval)
 * @param cb Callback which returns result to be resolved
 * @param time Debounce interval
 * @returns Function that returns debounced promise
 */ function $b114f862ee74d165$export$390f1673aa3d5232(cb, time) {
    let timeoutId;
    // Returns a promise that fires the debounce fn and pushes a resolver
    // to have the debounced result resolved
    return (...args)=>{
        timeoutId && clearTimeout(timeoutId);
        return new Promise((resolve, reject)=>{
            timeoutId = setTimeout(()=>{
                cb(...args).then(resolve).catch(reject);
            }, time);
        });
    };
}
module.exports["promiseDebounce"] = $b114f862ee74d165$export$390f1673aa3d5232;

});

parcelRegister("6hu6G", function(module, exports) {

var $89ZxY = parcelRequire("89ZxY");


var $8AdqG = parcelRequire("8AdqG");

let $ab62de022060b56f$var$previousClientVersion;
const $ab62de022060b56f$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch)=>{
    if ($ab62de022060b56f$var$previousClientVersion && $ab62de022060b56f$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $ab62de022060b56f$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $89ZxY.ActivityClientV2)(product, baseUrl);
    return new (0, $8AdqG.ActivityClientV3)(product, baseUrl, logger, configFetch);
};
module.exports["createActivityClient"] = $ab62de022060b56f$export$224367b01f71f2aa;

});

parcelRegister("89ZxY", function(module, exports) {

var $1kGOm = parcelRequire("1kGOm");


var $aMbzE = parcelRequire("aMbzE");


var $9Zwww = parcelRequire("9Zwww");

class $d9872470f8564e9f$export$330ab0047f2fb745 extends (0, $aMbzE.ActivityClient) {
    constructor(_product, baseUrl){
        super('v2', _product, undefined, baseUrl);
        this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            return (0, $1kGOm.fetchActivitiesWithExperience)((experience)=>(0, $9Zwww.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filters,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        };
        this.setProduct = (product)=>{
            this.product = product;
        };
    }
}
module.exports["ActivityClientV2"] = $d9872470f8564e9f$export$330ab0047f2fb745;

});

parcelRegister("1kGOm", function(module, exports) {

var $8vHBJ = parcelRequire("8vHBJ");


var $lsrrn = parcelRequire("lsrrn");


var $agkwD = parcelRequire("agkwD");

async function $32117be304c7c4e1$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $agkwD.recentWorkClientExperienceV2)() : (0, $agkwD.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $lsrrn.packageName,
            packageVersion: $lsrrn.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $32117be304c7c4e1$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $32117be304c7c4e1$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $8vHBJ.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};
module.exports["fetchActivitiesWithExperience"] = $32117be304c7c4e1$export$4a906f16800734f3;

});

parcelRegister("8vHBJ", function(module, exports) {
class $2e5e077062c7732f$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.message = void 0;
        this.method = void 0;
        this.path = void 0;
        this.statusCode = void 0;
        this.xRequestId = void 0;
        this.headers = void 0;
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $2e5e077062c7732f$export$97b788730ba59845 = (e)=>e instanceof $2e5e077062c7732f$export$2e2bcd8739ae039;
module.exports["default"] = $2e5e077062c7732f$export$2e2bcd8739ae039;

});

parcelRegister("lsrrn", function(module, exports) {
const $5fc4693544cc0e9d$export$9345d7360ffe0722 = "platform-pkg";
const $5fc4693544cc0e9d$export$91546b032799aa40 = "0.0.0-use.local";
module.exports["packageName"] = $5fc4693544cc0e9d$export$9345d7360ffe0722;
module.exports["packageVersion"] = $5fc4693544cc0e9d$export$91546b032799aa40;

});

parcelRegister("agkwD", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $a4fb49f1c23260ee$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $a4fb49f1c23260ee$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($a4fb49f1c23260ee$var$keyToTiming);
const $a4fb49f1c23260ee$export$d7769758f5eaa63b = ()=>{
    return new (0, $5aVN7.UFOExperience)('client', {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $a4fb49f1c23260ee$var$timings
    });
};
const $a4fb49f1c23260ee$export$9e32a4ed888f4717 = ()=>new (0, $5aVN7.UFOExperience)('client-v3', {
        type: (0, $9NDUe.ExperienceTypes).Load,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $a4fb49f1c23260ee$var$timings
    });
module.exports["recentWorkClientExperienceV2"] = $a4fb49f1c23260ee$export$d7769758f5eaa63b;
module.exports["recentWorkClientExperienceV3"] = $a4fb49f1c23260ee$export$9e32a4ed888f4717;

});

parcelRegister("aMbzE", function(module, exports) {

var $lJ9dF = parcelRequire("lJ9dF");

class $cfb0c7d09d50e5a4$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl){
        this.clientVersion = void 0;
        this.product = 'unknown';
        this.headers = void 0;
        this.baseUrl = (0, $lJ9dF.GRAPHQL_GATEWAY_PATH);
        this.fetchActivities = void 0;
        this.setProduct = void 0;
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
    }
}
module.exports["ActivityClient"] = $cfb0c7d09d50e5a4$export$157740f5433f3dbe;

});

parcelRegister("lJ9dF", function(module, exports) {
const $328c904cbc4ce376$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $328c904cbc4ce376$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SMARTLINK_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SMARTLINK_CLICKED"] = "sl-clicked";
    return VIEWED_EVENT;
}({});
var $328c904cbc4ce376$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $328c904cbc4ce376$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    // 3P Graph types below
    ActivityObjectType["DOCUMENT"] = "document";
    ActivityObjectType["PULL_REQUEST"] = "pull-request";
    ActivityObjectType["REMOTE_LINK"] = "remote-link";
    return ActivityObjectType;
}({});
module.exports["GRAPHQL_GATEWAY_PATH"] = $328c904cbc4ce376$export$851c5df667ca24c8;
module.exports["VIEWED_EVENT"] = $328c904cbc4ce376$export$d245b105c09339d8;
module.exports["WORKED_EVENT"] = $328c904cbc4ce376$export$eb4e9f525aef1cc3;
module.exports["ActivityObjectType"] = $328c904cbc4ce376$export$d02a56686be43f69;

});

parcelRegister("9Zwww", function(module, exports) {

var $9M6Bq = parcelRequire("9M6Bq");


var $flhdq = parcelRequire("flhdq");


var $8ONYO = parcelRequire("8ONYO");


var $2w7rF = parcelRequire("2w7rF");

const $e96892609f021260$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $e96892609f021260$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $e96892609f021260$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $e96892609f021260$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $e96892609f021260$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $8ONYO.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $e96892609f021260$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $flhdq.postResource)(baseUrl, {
            operationName: (0, $9M6Bq.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($e96892609f021260$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $2w7rF.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $2w7rF.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $2w7rF.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $2w7rF.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $2w7rF.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};
module.exports["fetchActivitiesV2"] = $e96892609f021260$export$750ec7816fdd2f9e;

});

parcelRegister("9M6Bq", function(module, exports) {

var $5nZsM = parcelRequire("5nZsM");

const $6478cdf7ffdfed6b$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(product);
};
const $6478cdf7ffdfed6b$export$41bca9dc6871dd4e = (product)=>{
    return `${$6478cdf7ffdfed6b$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};
module.exports["getOperationName"] = $6478cdf7ffdfed6b$export$41bca9dc6871dd4e;

});

parcelRegister("flhdq", function(module, exports) {
parcelRequire("jjbGD");
var $99X6x = parcelRequire("99X6x");
var $jjbGD = parcelRequire("jjbGD");


var $g6Nhv = parcelRequire("g6Nhv");


var $8vHBJ = parcelRequire("8vHBJ");

const $50a49ab2b7b0fd3b$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $g6Nhv.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $99X6x.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $50a49ab2b7b0fd3b$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $8vHBJ.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $50a49ab2b7b0fd3b$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $50a49ab2b7b0fd3b$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return text ? JSON.parse(text) : {};
};
const $50a49ab2b7b0fd3b$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $jjbGD.retryOnException)(()=>$50a49ab2b7b0fd3b$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $50a49ab2b7b0fd3b$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}
module.exports["postResource"] = $50a49ab2b7b0fd3b$export$2ff3e1f219ccfad6;

});

parcelRegister("jjbGD", function(module, exports) {
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("99X6x")).default);

var $ugvwf = parcelRequire("ugvwf");


var $8r8H1 = parcelRequire("8r8H1");


var $99X6x = parcelRequire("99X6x");

const $e6bcc9a5af5d2f35$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $e6bcc9a5af5d2f35$var$NO_CALLS_ERROR = 'No calls made';
const $e6bcc9a5af5d2f35$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $8r8H1.NO_RETRIES), retryOn: retryOn = [
    (0, $99X6x.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($e6bcc9a5af5d2f35$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $e6bcc9a5af5d2f35$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $e6bcc9a5af5d2f35$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $ugvwf.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};
module.exports["retryOnException"] = $e6bcc9a5af5d2f35$export$1d94629c94e7a17f;

});

parcelRegister("ugvwf", function(module, exports) {
const $b720f8bd3e196adc$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $b720f8bd3e196adc$export$2e2bcd8739ae039 = $b720f8bd3e196adc$var$convertToError;
module.exports["default"] = $b720f8bd3e196adc$export$2e2bcd8739ae039;

});

parcelRegister("8r8H1", function(module, exports) {
const $3648e78e1eff0ebe$export$a0a1c8f90becc136 = [];
const $3648e78e1eff0ebe$export$972171517b12aa4 = [
    0,
    0
];
const $3648e78e1eff0ebe$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $3648e78e1eff0ebe$export$f6858378b665f957 = [
    100,
    500,
    1000
];
module.exports["NO_RETRIES"] = $3648e78e1eff0ebe$export$a0a1c8f90becc136;

});

parcelRegister("99X6x", function(module, exports) {
class $96df690c33121e3a$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.method = void 0;
        this.originalName = void 0;
        this.path = void 0;
        this.stack = void 0;
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}
module.exports["default"] = $96df690c33121e3a$export$2e2bcd8739ae039;

});

parcelRegister("g6Nhv", function(module, exports) {
const $ed7d1e76b1f471ae$var$urlRegex = new RegExp(/^https?:\/\//);
function $ed7d1e76b1f471ae$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($ed7d1e76b1f471ae$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}
module.exports["getFullUrl"] = $ed7d1e76b1f471ae$export$2414511207262909;

});

parcelRegister("8ONYO", function(module, exports) {

var $9M6Bq = parcelRequire("9M6Bq");


var $tyUdU = parcelRequire("tyUdU");

const $5e56b4855b8ddd4f$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $5e56b4855b8ddd4f$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$5e56b4855b8ddd4f$var$ACTIVITIES}
   }
`;
const $5e56b4855b8ddd4f$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$5e56b4855b8ddd4f$var$ACTIVITIES}
   }
`;
const $5e56b4855b8ddd4f$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$5e56b4855b8ddd4f$var$ACTIVITIES}
    }
`;
const $5e56b4855b8ddd4f$var$activityQueryMap = new Map([
    [
        'workedOn',
        $5e56b4855b8ddd4f$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $5e56b4855b8ddd4f$var$VIEWED__QUERY
    ],
    [
        'all',
        $5e56b4855b8ddd4f$var$ALL__QUERY
    ]
]);
const $5e56b4855b8ddd4f$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $5e56b4855b8ddd4f$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $9M6Bq.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $5e56b4855b8ddd4f$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
	 * If we are filtering by `accountIds` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $5e56b4855b8ddd4f$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$5e56b4855b8ddd4f$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $5e56b4855b8ddd4f$var$getActivitiesQuery(product, $5e56b4855b8ddd4f$var$getMyActivitiesQuery(activityQueries.map((query)=>$5e56b4855b8ddd4f$var$activityQueryMap.get(query)))),
        queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};
module.exports["generateActivityQueryWithFilters"] = $5e56b4855b8ddd4f$export$855cd08371c65b8c;

});

parcelRegister("tyUdU", function(module, exports) {

var $jcjam = parcelRequire("jcjam");


var $bOQQO = parcelRequire("bOQQO");

const $3ce1f7f21e6b0975$export$5201d39848130041 = {
    v2: (0, $jcjam.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $bOQQO.ACTIVITY_FILTER_V3_MAP)
};
module.exports["ACTIVITY_FILTER_COLLECTION"] = $3ce1f7f21e6b0975$export$5201d39848130041;

});

parcelRegister("jcjam", function(module, exports) {

var $g1YDs = parcelRequire("g1YDs");


var $f8Fj5 = parcelRequire("f8Fj5");

const $a229434d184cb046$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $f8Fj5.default)
    ],
    [
        'activities',
        (0, $g1YDs.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V2_MAP"] = $a229434d184cb046$export$1dca7bc1ec360897;

});

parcelRegister("g1YDs", function(module, exports) {

var $2dGYV = parcelRequire("2dGYV");

/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $aa3e39d5302b5352$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $2dGYV.generateActivityFiltersV2)(restFilters);
};
var $aa3e39d5302b5352$export$2e2bcd8739ae039 = $aa3e39d5302b5352$var$generateV2ActivitiesFilters;
module.exports["default"] = $aa3e39d5302b5352$export$2e2bcd8739ae039;

});

parcelRegister("2dGYV", function(module, exports) {

var $cfWcp = parcelRequire("cfWcp");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $91acf2a102fe0c9f$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $91acf2a102fe0c9f$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $91acf2a102fe0c9f$export$ebef9c1f1e15c057 = (filters = {})=>(0, $cfWcp.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $91acf2a102fe0c9f$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $91acf2a102fe0c9f$var$KEYS_TO_TRANSFROM.has(originalkey) ? $91acf2a102fe0c9f$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });
module.exports["generateActivityFiltersV2"] = $91acf2a102fe0c9f$export$ebef9c1f1e15c057;

});

parcelRegister("cfWcp", function(module, exports) {
const $b77a537090dafa9a$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};
module.exports["generateActivityFilters"] = $b77a537090dafa9a$export$23c75313f46dd54e;

});

parcelRegister("f8Fj5", function(module, exports) {

var $2dGYV = parcelRequire("2dGYV");

/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $0a24d92d27935207$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $2dGYV.generateActivityFiltersV2)(restFilters);
};
var $0a24d92d27935207$export$2e2bcd8739ae039 = $0a24d92d27935207$var$generateV2MyActivityFilters;
module.exports["default"] = $0a24d92d27935207$export$2e2bcd8739ae039;

});

parcelRegister("bOQQO", function(module, exports) {

var $dQITg = parcelRequire("dQITg");


var $jBMZs = parcelRequire("jBMZs");

const $68c8b19d94c6d0af$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $jBMZs.default)
    ],
    [
        'activities',
        (0, $dQITg.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V3_MAP"] = $68c8b19d94c6d0af$export$9a1782843b6e99d2;

});

parcelRegister("dQITg", function(module, exports) {

var $cYpDV = parcelRequire("cYpDV");

/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $c500a5dd90aab1cd$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $cYpDV.generateActivityFiltersV3)(restFilters);
};
var $c500a5dd90aab1cd$export$2e2bcd8739ae039 = $c500a5dd90aab1cd$var$generateV3ActivityFilters;
module.exports["default"] = $c500a5dd90aab1cd$export$2e2bcd8739ae039;

});

parcelRegister("cYpDV", function(module, exports) {

var $cfWcp = parcelRequire("cfWcp");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $a9947c270139ebd0$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $a9947c270139ebd0$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds'
];
const $a9947c270139ebd0$export$e73fe7ded3fe2664 = (filters = {})=>(0, $cfWcp.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $a9947c270139ebd0$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $a9947c270139ebd0$var$ROOT_LEVEL_FILTERS);
module.exports["generateActivityFiltersV3"] = $a9947c270139ebd0$export$e73fe7ded3fe2664;

});

parcelRegister("jBMZs", function(module, exports) {

var $cYpDV = parcelRequire("cYpDV");

/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $233cbacaae2fcf7a$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $cYpDV.generateActivityFiltersV3)(restFilters);
};
var $233cbacaae2fcf7a$export$2e2bcd8739ae039 = $233cbacaae2fcf7a$var$generateV3MyActivityFilters;
module.exports["default"] = $233cbacaae2fcf7a$export$2e2bcd8739ae039;

});

parcelRegister("2w7rF", function(module, exports) {
const $75279b3aeb424623$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $75279b3aeb424623$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$75279b3aeb424623$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}
module.exports["transformActivitiesItems"] = $75279b3aeb424623$export$306a8b649360ca6f;

});

parcelRegister("8AdqG", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $jjbGD = parcelRequire("jjbGD");


var $dh538 = parcelRequire("dh538");


var $lJ9dF = parcelRequire("lJ9dF");


var $lsrrn = parcelRequire("lsrrn");


var $1kGOm = parcelRequire("1kGOm");


var $flhdq = parcelRequire("flhdq");


var $8slu7 = parcelRequire("8slu7");


var $1HpcN = parcelRequire("1HpcN");


var $fX414 = parcelRequire("fX414");


var $a3sLS = parcelRequire("a3sLS");


var $l4NdO = parcelRequire("l4NdO");


var $h4NLj = parcelRequire("h4NLj");


var $aMbzE = parcelRequire("aMbzE");


var $dB4CM = parcelRequire("dB4CM");


var $9t27K = parcelRequire("9t27K");


var $2OHoP = parcelRequire("2OHoP");

const $0954b34b93e72b05$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $0954b34b93e72b05$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $0954b34b93e72b05$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $0954b34b93e72b05$var$DEFAULT_TAGS = {
    source: (0, $lsrrn.packageName),
    sourcePackageVersion: (0, $lsrrn.packageVersion)
};
class $0954b34b93e72b05$export$3c3c237c92ca1fb9 extends (0, $aMbzE.ActivityClient) {
    constructor(_product, baseUrl, logger, configFetch){
        super('v3', _product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl);
        this.hydratorConfigClient = void 0;
        this.clientHandlers = void 0;
        this.setProduct = (product)=>{
            this.product = product;
        };
        this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$0954b34b93e72b05$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$0954b34b93e72b05$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig();
        this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $1HpcN.GraphQLJSError)(err));
                    const invalidFragment = (0, $dB4CM.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        };
        this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $jjbGD.retryOnException)(async ()=>{
                    const request = (0, $9t27K.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $2OHoP.filtersToMetadata)(filters)
                    });
                    const res = await (0, $flhdq.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $2OHoP.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $8slu7.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $8slu7.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$0954b34b93e72b05$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$0954b34b93e72b05$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $2OHoP.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $fX414.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $0954b34b93e72b05$var$transformActivityItem('workedOn', (0, $2OHoP.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $0954b34b93e72b05$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $0954b34b93e72b05$var$transformActivityItem('all', (0, $2OHoP.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $2OHoP.rollupActivitiesData)(activities) : activities;
        };
        this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            return (0, $1kGOm.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filters, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $h4NLj.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, _product, configFetch);
    }
}
const $0954b34b93e72b05$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $l4NdO.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc) return (0, $l4NdO.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    if (object.product === 'graph' && (0, $l4NdO.isThirdPartyARI)(object.id)) {
        const product = (0, $l4NdO.parseThirdPartyProduct)(object.id).split('.').at(1);
        return (0, $l4NdO.hydrate3pIcon)(product, hydratedData.icon, hydratedData.staticFallbacks);
    }
    return $0954b34b93e72b05$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $l4NdO.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $l4NdO.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
const $0954b34b93e72b05$var$setStatusHydration = (hydratedData)=>{
    const value = (0, $l4NdO.hydratedValueToString)(hydratedData.statusValue);
    const score = (0, $l4NdO.hydratedValueToString)(hydratedData.statusScore);
    const color = (0, $l4NdO.hydratedValueToString)(hydratedData.statusColor);
    return value || score || color ? {
        value: value,
        score: score,
        color: color
    } : undefined;
};
function $0954b34b93e72b05$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            let product = object.product;
            if (object.product === 'graph' || object.id.startsWith('ari:cloud:graph::pull-request')) product = (0, $2OHoP.getThirdPartyGraphProvider)(object);
            const isSmartlinkViewedType = item.node.event.eventType === (0, $lJ9dF.VIEWED_EVENT).SMARTLINK_VIEWED;
            const isRemoteLinkGateDisabled = !(0, $dh538.fg)('recent_work_client_enable_graph_remote_links');
            const isSmartlinkViewedGateEnabled = (0, $dh538.fg)('platform_recent_work_enable_sl-viewed_results');
            const isExternalRemoteLink = item.node.object.data?.__typename === 'ExternalRemoteLink';
            const isExternalPullRequest = item.node.object.data?.__typename === 'ExternalPullRequest';
            const isGithubRecentsEnabled = (0, $c6GJD.default).getExperimentValue('add-github-activityplatform-recentworkitem', 'isEnabled', false);
            if (isSmartlinkViewedType && !isSmartlinkViewedGateEnabled) // Don't return any `sl-viewed` event results
            return acc;
            if (isExternalRemoteLink && isRemoteLinkGateDisabled) // Don't return Remote Link result if not rolled out to product yet
            return acc;
            if (isExternalPullRequest && product === 'github' && !isGithubRecentsEnabled) // Don't return GitHub pull request results until the feature gate is enabled
            return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $a3sLS.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $l4NdO.hydratedValueToString)(hydratedData.key, ' ')
                });
                if (hydratedData.containers) containers.push({
                    name: (0, $l4NdO.hydratedValueToString)(hydratedData.containers, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $lJ9dF.WORKED_EVENT).CREATED ? (0, $lJ9dF.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $2OHoP.parseRootContainerARI)(object.rootContainerId),
                        icon: $0954b34b93e72b05$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $l4NdO.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $l4NdO.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $l4NdO.hydratedValueToString)(hydratedData.name, ' '),
                        product: product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: (0, $l4NdO.hydratedValueToString)(hydratedData.subtype) || object.data.subtype,
                        url: (0, $l4NdO.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $l4NdO.hydratedValueToString)(hydratedData.objectTypeName),
                        creator: (0, $l4NdO.hydratedValueToString)(hydratedData.creator),
                        providerId: (0, $l4NdO.hydratedValueToString)(hydratedData.providerId),
                        status: $0954b34b93e72b05$var$setStatusHydration(hydratedData),
                        __typename: object.data.__typename
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}
module.exports["ActivityClientV3"] = $0954b34b93e72b05$export$3c3c237c92ca1fb9;

});

parcelRegister("8slu7", function(module, exports) {
class $d9ab8e53f4fb0597$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}
module.exports["GraphQLFragmentError"] = $d9ab8e53f4fb0597$export$2d1b192199788179;

});

parcelRegister("1HpcN", function(module, exports) {
class $6d47e15a0e40ba32$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.error = void 0;
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}
module.exports["GraphQLJSError"] = $6d47e15a0e40ba32$export$8d4af49ee2a0fbe2;

});

parcelRegister("fX414", function(module, exports) {
class $5d9f0e5a45afc0ec$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.errors = void 0;
        this.errorMessages = void 0;
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}
module.exports["GraphQLNoResultsError"] = $5d9f0e5a45afc0ec$export$3f19ff30d409b70;

});

parcelRegister("a3sLS", function(module, exports) {

var $kkhbp = parcelRequire("kkhbp");


var $2fnPs = parcelRequire("2fnPs");

const $24f658990005dffd$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $24f658990005dffd$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $2fnPs.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $2fnPs.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $2fnPs.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $24f658990005dffd$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $24f658990005dffd$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, ''));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($kkhbp)))(object, path);
}
function $24f658990005dffd$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $24f658990005dffd$var$getOrSearch(current, split);
    return current;
}
function $24f658990005dffd$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($kkhbp)))(edge, fieldId) === searchValue);
}
function $24f658990005dffd$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$24f658990005dffd$var$resolvePath(object, path));
}
const $24f658990005dffd$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $24f658990005dffd$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};
module.exports["hydratePolymorphicData"] = $24f658990005dffd$export$d658049bf1a63492;

});

parcelRegister("2fnPs", function(module, exports) {
class $88b1285615459d57$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        this.originalName = void 0;
        this.originalMessage = void 0;
        this.stack = void 0;
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}
module.exports["default"] = $88b1285615459d57$export$2e2bcd8739ae039;

});

parcelRegister("l4NdO", function(module, exports) {
const $5fe052f51633fc0f$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $5fe052f51633fc0f$var$isURL(icon) {
    return typeof icon === 'string';
}
function $5fe052f51633fc0f$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $5fe052f51633fc0f$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $5fe052f51633fc0f$export$4578ef3572b21f34 = (ari)=>{
    const result = $5fe052f51633fc0f$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$5fe052f51633fc0f$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $5fe052f51633fc0f$export$fccbae65febb6fd4 = (ari)=>$5fe052f51633fc0f$var$thirdPartyRegex.test(ari);
const $5fe052f51633fc0f$export$c60ec7b3c8b44fe1 = (product, icons, fallbacks, fallbackKey = 'icon')=>{
    if (fallbacks?.[fallbackKey] && product) {
        const thirdPartyLogo = fallbacks['thirdPartyIconPath']?.replace('{replaceProductName}', product) ?? fallbacks[fallbackKey];
        return {
            type: 'URL',
            value: thirdPartyLogo,
            fallbackIcon: fallbacks[fallbackKey]
        };
    }
    return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
};
const $5fe052f51633fc0f$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $5fe052f51633fc0f$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $5fe052f51633fc0f$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($5fe052f51633fc0f$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($5fe052f51633fc0f$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $5fe052f51633fc0f$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks?.[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};
module.exports["hydratedValueToString"] = $5fe052f51633fc0f$export$c5cea44a1f75b431;
module.exports["parseThirdPartyProduct"] = $5fe052f51633fc0f$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $5fe052f51633fc0f$export$fccbae65febb6fd4;
module.exports["hydrate3pIcon"] = $5fe052f51633fc0f$export$c60ec7b3c8b44fe1;
module.exports["hydrateIcon"] = $5fe052f51633fc0f$export$a328b2bb0d21d984;
module.exports["hydrateConfluenceIcon"] = $5fe052f51633fc0f$export$86b9f44277b105a6;

});

parcelRegister("h4NLj", function(module, exports) {

var $g58eM = parcelRequire("g58eM");


var $hwkRt = parcelRequire("hwkRt");

const $3f0e325881d700a2$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $3f0e325881d700a2$var$FD_ENVIRONMENT = 'prod';
const $3f0e325881d700a2$export$c270c412a04ff3e6 = {
    name: $3f0e325881d700a2$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $3f0e325881d700a2$var$FD_ENVIRONMENT
    }
};
class $3f0e325881d700a2$export$2e2bcd8739ae039 {
    async fetchArtifact() {
        if (this.artifactFetch) return 0, $hwkRt.default;
        // We're using the bundled artifact temporarily as FD caching is broken and does not expire for 365 days
        // https://atlassian.slack.com/archives/C01UV3QT21F/p1753393679628199
        return 0, $hwkRt.default;
    }
    constructor(handlers, product, artifactFetch){
        this.artifactFetch = artifactFetch;
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        new (0, $g58eM.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $3f0e325881d700a2$var$FD_ENVIRONMENT
                },
                value: (0, $hwkRt.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
}
module.exports["FD_CLIENT_FETCH_PROPS"] = $3f0e325881d700a2$export$c270c412a04ff3e6;
module.exports["default"] = $3f0e325881d700a2$export$2e2bcd8739ae039;

});

parcelRegister("g58eM", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $jjbGD = parcelRequire("jjbGD");


var $kt8c2 = parcelRequire("kt8c2");


var $6yH3R = parcelRequire("6yH3R");

var $jmRYU = parcelRequire("jmRYU");


var $h2xad = parcelRequire("h2xad");


var $kvSko = parcelRequire("kvSko");


var $5Wn20 = parcelRequire("5Wn20");

function $bb5380b95425c19e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bb5380b95425c19e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bb5380b95425c19e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bb5380b95425c19e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $bb5380b95425c19e$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $bb5380b95425c19e$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $bb5380b95425c19e$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $jjbGD.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $6yH3R.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $h2xad.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$bb5380b95425c19e$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $5Wn20.flightDeckClientExperience)() : new (0, $jmRYU.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $bb5380b95425c19e$var$_objectSpread($bb5380b95425c19e$var$_objectSpread({}, artifact), {}, {
                key: (0, $kvSko.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $5Wn20.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $iLaQ6.default)(this, "fallbackArtifactMap", new Map());
        (0, $iLaQ6.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $kt8c2.default)($bb5380b95425c19e$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $kvSko.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
}
module.exports["default"] = $bb5380b95425c19e$export$2e2bcd8739ae039;

});

parcelRegister("6yH3R", function(module, exports) {

var $eoZW1 = parcelRequire("eoZW1");


var $4Nb0k = parcelRequire("4Nb0k");


var $gnjN9 = parcelRequire("gnjN9");


var $exN00 = parcelRequire("exN00");


var $5F2TE = parcelRequire("5F2TE");


var $jmRYU = parcelRequire("jmRYU");


var $1uJFJ = parcelRequire("1uJFJ");

/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $4c6752261483d0e7$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $4c6752261483d0e7$var$defaultPerimeter = "commercial";
async function $4c6752261483d0e7$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $4c6752261483d0e7$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $4c6752261483d0e7$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $4c6752261483d0e7$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $eoZW1.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $4c6752261483d0e7$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $4c6752261483d0e7$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $4c6752261483d0e7$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $4c6752261483d0e7$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $4c6752261483d0e7$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $4c6752261483d0e7$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $jmRYU.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $jmRYU.getVersionMetadataFetchExperience)();
    return new (0, $5F2TE.ConfigClient)(new (0, $gnjN9.BifrostDataSource)(new (0, $exN00.BifrostHttpClientImpl)(env, perimeter), (0, $4Nb0k.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $4c6752261483d0e7$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}
module.exports["fetchFlightDeckConfiguration"] = $4c6752261483d0e7$export$6026918e023c9101;

});

parcelRegister("eoZW1", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $639791195d5194df$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $639791195d5194df$export$2e2bcd8739ae039 = $639791195d5194df$export$852ff24d0930c62f;
module.exports["default"] = $639791195d5194df$export$2e2bcd8739ae039;

});

parcelRegister("4Nb0k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $1l7nm = parcelRequire("1l7nm");

Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $1l7nm.Either;
    }
});

var $dQfUU = parcelRequire("dQfUU");

Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $dQfUU.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $dQfUU.tryGetArtifactData;
    }
});

var $56c1N = parcelRequire("56c1N");

Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $56c1N.parseArtifactManifest;
    }
});

var $4rmqH = parcelRequire("4rmqH");

Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $4rmqH.parseVersionMetadata;
    }
});

var $ejfcn = parcelRequire("ejfcn");

Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $ejfcn.checkManifest;
    }
});

var $ecQWM = parcelRequire("ecQWM");

Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $ecQWM.ConfigRegistryDataSource;
    }
});

var $keTF5 = parcelRequire("keTF5");

Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $keTF5.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $keTF5.Versions;
    }
});

});

parcelRegister("1l7nm", function(module, exports) {
"use strict";
var $0f9d7946bab332da$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $0f9d7946bab332da$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $0f9d7946bab332da$var$Right(value);
    };
    Either.left = function(error) {
        return new $0f9d7946bab332da$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $0f9d7946bab332da$var$Either;
var $0f9d7946bab332da$var$Right = /** @class */ function(_super) {
    $0f9d7946bab332da$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $0f9d7946bab332da$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $0f9d7946bab332da$var$Either.right(this.right);
    };
    return Right;
}($0f9d7946bab332da$var$Either);
var $0f9d7946bab332da$var$Left = /** @class */ function(_super) {
    $0f9d7946bab332da$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $0f9d7946bab332da$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $0f9d7946bab332da$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $0f9d7946bab332da$var$Either.left(f(this.left));
    };
    return Left;
}($0f9d7946bab332da$var$Either);

});

parcelRegister("dQfUU", function(module, exports) {
"use strict";
var $0299bfe91f926726$var$__assign = module.exports && module.exports.__assign || function() {
    $0299bfe91f926726$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0299bfe91f926726$var$__assign.apply(this, arguments);
};
var $0299bfe91f926726$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0299bfe91f926726$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $0299bfe91f926726$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $0299bfe91f926726$var$tryGetArtifactData;

var $e1gYo = parcelRequire("e1gYo");


var $4Nb0k = parcelRequire("4Nb0k");


var $gtZqo = parcelRequire("gtZqo");


var $9kSKy = parcelRequire("9kSKy");


var $4245y = parcelRequire("4245y");

function $0299bfe91f926726$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $0299bfe91f926726$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $0299bfe91f926726$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $0299bfe91f926726$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $0299bfe91f926726$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $4Nb0k.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $gtZqo.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $0299bfe91f926726$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $9kSKy.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $0299bfe91f926726$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $0299bfe91f926726$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $0299bfe91f926726$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $e1gYo.interpolateTagScheme)(manifest.tagScheme, $0299bfe91f926726$var$__assign($0299bfe91f926726$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $0299bfe91f926726$var$__awaiter(_this, void 0, void 0, function() {
                                return $0299bfe91f926726$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $0299bfe91f926726$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $4245y.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $4245y.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $9kSKy.assertUnreachable)(artifact);
    }
}

});

parcelRegister("e1gYo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $a34e5329a6d15964$var$interpolateTagScheme;
module.exports.generateTagScheme = $a34e5329a6d15964$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $a34e5329a6d15964$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $a34e5329a6d15964$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $a34e5329a6d15964$var$getVersionMetadataTag;
const $a34e5329a6d15964$var$TAG_SCHEME_VERSION = 2;
function $a34e5329a6d15964$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($a34e5329a6d15964$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $a34e5329a6d15964$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $a34e5329a6d15964$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $a34e5329a6d15964$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $a34e5329a6d15964$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $a34e5329a6d15964$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $a34e5329a6d15964$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $a34e5329a6d15964$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("gtZqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $bfff0076b2a38448$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $bfff0076b2a38448$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("9kSKy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $6cc0738327f40e2f$var$assertUnreachable;
function $6cc0738327f40e2f$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("4245y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $2efa854173b183a4$var$toJson;
module.exports.toPrettyJson = $2efa854173b183a4$var$toPrettyJson;
function $2efa854173b183a4$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $2efa854173b183a4$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("56c1N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $3b66d7c76b5a6f30$var$parseArtifactManifest;

var $7YiFT = parcelRequire("7YiFT");

function $3b66d7c76b5a6f30$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $7YiFT.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $7YiFT.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $3b66d7c76b5a6f30$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $7YiFT.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $3b66d7c76b5a6f30$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $3b66d7c76b5a6f30$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $7YiFT.parseUnknownObject)(dimensions);
    var supported = (0, $7YiFT.parseArray)(unparsedDimensions.supported).map($7YiFT.parseString);
    var fallback = (0, $7YiFT.parseUndefinedOr)($7YiFT.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $3b66d7c76b5a6f30$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $7YiFT.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $3b66d7c76b5a6f30$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $3b66d7c76b5a6f30$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $7YiFT.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $7YiFT.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $7YiFT.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $7YiFT.parseUndefinedOr)($7YiFT.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $3b66d7c76b5a6f30$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $3b66d7c76b5a6f30$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});

parcelRegister("7YiFT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $5cdc9f61297a7705$var$parseString;
module.exports.parseArray = $5cdc9f61297a7705$var$parseArray;
module.exports.parseBoolean = $5cdc9f61297a7705$var$parseBoolean;
module.exports.parseUnknownObject = $5cdc9f61297a7705$var$parseUnknownObject;
module.exports.parseUndefinedOr = $5cdc9f61297a7705$var$parseUndefinedOr;
function $5cdc9f61297a7705$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $5cdc9f61297a7705$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $5cdc9f61297a7705$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $5cdc9f61297a7705$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $5cdc9f61297a7705$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});

parcelRegister("4rmqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $33bb15189e2a597d$var$parseVersionMetadata;

var $7YiFT = parcelRequire("7YiFT");

function $33bb15189e2a597d$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $7YiFT.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $7YiFT.parseString)(unknownObject.version);
    var publishTime = new Date((0, $7YiFT.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $7YiFT.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("ejfcn", function(module, exports) {
"use strict";
var $a6aea1303ef4c284$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $a6aea1303ef4c284$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $a6aea1303ef4c284$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $a6aea1303ef4c284$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("ecQWM", function(module, exports) {
"use strict";
var $a57b41e342284c93$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a57b41e342284c93$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $e1gYo = parcelRequire("e1gYo");


var $1l7nm = parcelRequire("1l7nm");


var $56c1N = parcelRequire("56c1N");


var $4rmqH = parcelRequire("4rmqH");

var $a57b41e342284c93$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $a57b41e342284c93$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $a57b41e342284c93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $e1gYo.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($56c1N.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $1l7nm.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $a57b41e342284c93$var$__awaiter(this, void 0, void 0, function() {
            return $a57b41e342284c93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $a57b41e342284c93$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $a57b41e342284c93$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $e1gYo.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $4rmqH.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $a57b41e342284c93$var$ConfigRegistryDataSource;

});

parcelRegister("keTF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $ebc04ab7747b3e03$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $ebc04ab7747b3e03$var$BaseUrls;
var $ebc04ab7747b3e03$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $ebc04ab7747b3e03$var$Versions;

});

parcelRegister("gnjN9", function(module, exports) {

var $4Nb0k = parcelRequire("4Nb0k");


var $e1gYo = parcelRequire("e1gYo");

class $bebe258c209dced8$export$2cb8d79200775058 {
    async getLatestVersionMetadata() {
        const tag = (0, $e1gYo.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $4Nb0k.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $4Nb0k.parseVersionMetadata)(response);
                return (0, $4Nb0k.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $4Nb0k.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $e1gYo.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $4Nb0k.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $4Nb0k.parseArtifactManifest)(response);
                return (0, $4Nb0k.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $4Nb0k.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
}
module.exports["BifrostDataSource"] = $bebe258c209dced8$export$2cb8d79200775058;

});

parcelRegister("exN00", function(module, exports) {

var $4Nb0k = parcelRequire("4Nb0k");

function $a96a27f8779f7f59$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $a96a27f8779f7f59$export$45c6d12ca9c14f83 {
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $4Nb0k.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $4Nb0k.Either).right(json)));
            }).catch((error)=>resolve((0, $4Nb0k.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
    constructor(env, perimeter){
        this.baseUrl = $a96a27f8779f7f59$export$f654b28f82155665(env, perimeter);
    }
}
module.exports["BifrostHttpClientImpl"] = $a96a27f8779f7f59$export$45c6d12ca9c14f83;

});

parcelRegister("5F2TE", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $4Nb0k = parcelRequire("4Nb0k");


var $iLqQe = parcelRequire("iLqQe");

function $41f3074aaceffd34$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41f3074aaceffd34$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41f3074aaceffd34$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41f3074aaceffd34$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $41f3074aaceffd34$export$8489e2f039bfcc4c {
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $41f3074aaceffd34$var$_objectSpread($41f3074aaceffd34$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $4Nb0k.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $4Nb0k.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $iLqQe.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
}
module.exports["ConfigClient"] = $41f3074aaceffd34$export$8489e2f039bfcc4c;

});

parcelRegister("iLqQe", function(module, exports) {
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $da916feb1601e8a8$export$1cc944571619e6e8 {
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
}
module.exports["ExperienceDataSourceWrapper"] = $da916feb1601e8a8$export$1cc944571619e6e8;

});

parcelRegister("jmRYU", function(module, exports) {
const $03a383e7109b9e96$var$SAMPLING_RATE = 10;
class $03a383e7109b9e96$var$UFOExperienceWrapper {
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
    constructor(experience){
        this.experience = experience;
    }
}
class $03a383e7109b9e96$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $03a383e7109b9e96$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $03a383e7109b9e96$var$SAMPLING_RATE) return new $03a383e7109b9e96$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("649YS"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $03a383e7109b9e96$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $03a383e7109b9e96$export$5e7536cf7bc56fee();
    }
}
const $03a383e7109b9e96$export$a3006f8f221c0a3b = ()=>$03a383e7109b9e96$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $03a383e7109b9e96$export$c3ac7702bfd47c1b = ()=>$03a383e7109b9e96$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});
module.exports["MockExperience"] = $03a383e7109b9e96$export$5e7536cf7bc56fee;
module.exports["getFlightDeckFetchExperience"] = $03a383e7109b9e96$export$a3006f8f221c0a3b;
module.exports["getVersionMetadataFetchExperience"] = $03a383e7109b9e96$export$c3ac7702bfd47c1b;

});

parcelRegister("649YS", function(module, exports) {

let $46aadbccc4f1e03a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46aadbccc4f1e03a$var$load("h05Zl").then(()=>parcelRequire('1pDeP'));

});

parcelRegister("1uJFJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $Eff3A = parcelRequire("Eff3A");

Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $Eff3A.parseConfigWithTargeting;
    }
});

var $eqS6f = parcelRequire("eqS6f");

Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $eqS6f.TargetedConfig;
    }
});

});

parcelRegister("Eff3A", function(module, exports) {
"use strict";
var $078f8f416dfc8880$var$__assign = module.exports && module.exports.__assign || function() {
    $078f8f416dfc8880$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $078f8f416dfc8880$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $078f8f416dfc8880$var$parseConfigWithTargeting;

var $eqS6f = parcelRequire("eqS6f");

/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $078f8f416dfc8880$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $078f8f416dfc8880$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $eqS6f.TargetedConfig({
                defaultConfig: $078f8f416dfc8880$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $078f8f416dfc8880$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $eqS6f.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $078f8f416dfc8880$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $078f8f416dfc8880$var$__assign($078f8f416dfc8880$var$__assign({}, accObject), (_a = {}, _a[key] = $078f8f416dfc8880$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $078f8f416dfc8880$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $078f8f416dfc8880$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $078f8f416dfc8880$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $078f8f416dfc8880$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $078f8f416dfc8880$var$parseIdentifierList(target.orgIds),
            siteIds: $078f8f416dfc8880$var$parseIdentifierList(target.siteIds),
            userIds: $078f8f416dfc8880$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $078f8f416dfc8880$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});

parcelRegister("eqS6f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $a81d757bffb50f80$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
   * Determines whether to use the targeted configuration value or the default value
   * depending on whether the specified values match any of the target's rules.
   *
   * @param target the values to use to evaluate the config
   * @returns the {@link TargetingResult}, which would be the default value
   *     if the specified target did not match, or the targeted value if there
   *     was a match
   */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $a81d757bffb50f80$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $a81d757bffb50f80$var$TargetedConfig;
function $a81d757bffb50f80$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});

parcelRegister("h2xad", function(module, exports) {
class $c67c5938243bac5e$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $c67c5938243bac5e$export$1d76d155060824c9 = (e)=>e instanceof $c67c5938243bac5e$export$2e2bcd8739ae039;
module.exports["default"] = $c67c5938243bac5e$export$2e2bcd8739ae039;

});

parcelRegister("kvSko", function(module, exports) {
const $eef0d84a095af3e3$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};
module.exports["artifactKey"] = $eef0d84a095af3e3$export$e3553dc63541d477;

});

parcelRegister("5Wn20", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

function $45343c0ee8becd11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45343c0ee8becd11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45343c0ee8becd11$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $iLaQ6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45343c0ee8becd11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $45343c0ee8becd11$export$1e3a41a51f6457c5 = ()=>new (0, $5aVN7.UFOExperience)("retrieve-artifact", {
        type: (0, $9NDUe.ExperienceTypes).Operation,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $45343c0ee8becd11$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $45343c0ee8becd11$var$_objectSpread($45343c0ee8becd11$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};
module.exports["flightDeckClientExperience"] = $45343c0ee8becd11$export$1e3a41a51f6457c5;
module.exports["exceptionToMetadata"] = $45343c0ee8becd11$export$f33622abb5224195;

});

parcelRegister("hwkRt", function(module, exports) {
// This file is auto-generated. Do not edit manually.
/* Update via: cd platform/packages/activity-platform/recent-work-client && yarn update:bundled:config */ const $1fd3741f1fad91b0$var$_default_1 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-viewed': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            clicked: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-clicked': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'status.value'
                ],
                statusScore: [
                    'status.score'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'state.value'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceWhiteboard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'whiteboardId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceDatabase: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'databaseId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/database.svg'
            }
        },
        ConfluenceEmbed: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'embedId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/embed.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'key'
                ],
                statusValue: [
                    'fieldsByIdOrAlias(fieldId: "status").status.name'
                ],
                statusColor: [
                    'fieldsByIdOrAlias(fieldId: "status").status.statusCategory.colorName'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        TrelloBoard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'boardName'
                ],
                url: [
                    'boardUrl'
                ],
                containers: [
                    'workspace.displayName'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/board.svg'
            }
        },
        TrelloCard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'cardName'
                ],
                url: [
                    'cardUrl'
                ],
                containers: [
                    'list.name',
                    'list.board.name'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/card.svg'
            }
        },
        DevOpsDocument: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ],
                icon: [
                    'type.iconUrl'
                ]
            }
        },
        DevOpsPullRequestDetails: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                url: [
                    'url'
                ],
                containers: [
                    'repositoryName'
                ],
                key: [
                    'providerName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg'
            }
        },
        DevOpsDesign: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/design.svg'
            }
        },
        ExternalDocument: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'type.category'
                ],
                key: [
                    'parent.displayName'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalRemoteLink: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'category'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        MercuryFocusArea: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'focusAreaType.name'
                ],
                icon: [
                    'icon.url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/focus-area.svg'
            }
        },
        MercuryPortfolio: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'label'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/view.svg'
            }
        },
        RadarPosition: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'worker.preferredName'
                ],
                url: [
                    'url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/talent/position.svg'
            }
        },
        RadarView: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'viewName'
                ],
                url: [
                    'url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/talent/view.svg'
            }
        },
        CompassComponent: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'typeMetadata.iconUrl'
                ],
                key: [
                    'typeMetadata.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/compass/logo.svg'
            }
        },
        BitbucketPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'pullRequestTitle'
                ],
                url: [
                    'href'
                ],
                key: [
                    'pullRequestTitle'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/bitbucket/logo.svg'
            }
        },
        LoomVideo: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'loomUrl'
                ],
                key: [
                    'owner.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/loom/logo.svg'
            }
        },
        AssetsObject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'label'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'avatar.url48'
                ],
                containers: [
                    'objectType.schema.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsObjectType: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsObjectTypeName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'assetsObjectTypeIcon.url48'
                ],
                containers: [
                    'schema.assetsSchemaName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsSchema: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsSchemaName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n    status {\n      value\n      score\n    }\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n    state {\n      value\n    }\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    subtype\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceWhiteboard on ConfluenceWhiteboard {\n    id\n    title\n    whiteboardId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceDatabase on ConfluenceDatabase {\n    id\n    title\n    databaseId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceEmbed on ConfluenceEmbed {\n    id\n    title\n    embedId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n  fieldsByIdOrAlias(idsOrAliases: ["status"]) @optIn(to: "JiraIssueFieldsByIdOrAlias") {\n    __typename\n    fieldId\n    ...jiraStatusField\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    name\n    avatar {\n      medium\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\nfragment jiraStatusField on JiraStatusField {\n  status {\n    name\n    statusCategory {\n      colorName\n    }\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment trelloBoard on TrelloBoard {\n  id\n  objectId\n  boardName: name\n  boardUrl: url\n  workspace {\n    id\n    displayName\n  }\n}\n\n\nfragment trelloCard on TrelloCard {\n  id\n  objectId\n  cardName: name\n  cardUrl: url\n  list {\n    id\n    name\n    board @optIn(to: "TrelloListBoard") {\n      id\n      name\n    }\n  }\n}\n\n\n        fragment graphDevOpsDocument on DevOpsDocument {\n          id\n          displayName\n          webUrl: url\n          type {\n            iconUrl\n          }\n        }\n    \n\n        fragment graphExternalDocument on ExternalDocument {\n            id\n            type {\n                category\n            }\n            displayName\n            parent @optIn(to: "ExternalDataDepotQueryV2"){\n                ...on ExternalDocument {\n                    displayName\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            thirdPartyId\n        }\n    \n\nfragment graphPullRequest on DevOpsPullRequestDetails {\n  id\n  title\n  url\n  repositoryName\n  providerName\n}\n\n\nfragment graphExternalPullRequest on ExternalPullRequest {\n  id\n  displayName\n  url\n  pullRequestStatus: status\n  provider {\n    providerId\n  }\n}\n\n\nfragment graphDesign on DevOpsDesign {\n  id\n  displayName\n  webUrl: url\n}\n\n\n        fragment graphExternalRemoteLink on ExternalRemoteLink {\n            id\n            displayName\n            category\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            thirdPartyId\n        }\n    \n\n    fragment mercuryFocusArea on MercuryFocusArea {\n        id\n        name\n        url\n        focusAreaType {\n            name\n        }\n        icon {\n            url\n        }\n    }\n    \n\n    fragment mercuryPortfolio on MercuryPortfolio {\n        id\n        name\n        url\n        label\n    }\n    \n\n    fragment radarPosition on RadarPosition {\n        id\n        worker {\n            preferredName\n        }\n        url\n    }\n    \n\n    fragment radarView on RadarView {\n        id\n        viewName\n        url\n    }\n    \n\nfragment compassComponent on CompassComponent {\n  id\n  name\n  url\n  typeMetadata {\n    iconUrl\n    name\n  }\n}\n\n\nfragment bitbucketPullRequest on BitbucketPullRequest {\n  id\n  pullRequestTitle: title\n  href\n  author {\n    picture\n  }\n}\n\n\nfragment loomVideo on LoomVideo {\n  id\n  name\n  loomUrl: url\n  owner {\n    name\n    picture\n  }\n}\n\n\n    fragment assetsObject on AssetsObject {\n      id\n      label\n      objectKey\n      links {\n        web\n      }\n      avatar {\n        url48\n      }\n      objectType {\n        name\n        schema {\n          name\n        }\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsObjectType on AssetsObjectType {\n      id\n      assetsObjectTypeName: name\n      links {\n        web\n      }\n      assetsObjectTypeIcon: icon {\n        url48\n      }\n      schema {\n        id\n        assetsSchemaName: name\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsSchema on AssetsSchema {\n      id\n      assetsSchemaKey: key\n      assetsSchemaName: name\n      links {\n        web\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceWhiteboard\n\t...confluenceDatabase\n\t...confluenceEmbed\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n\t...trelloBoard\n\t...trelloCard\n\t...graphDevOpsDocument\n\t...graphExternalDocument\n\t...graphPullRequest\n\t...graphExternalPullRequest\n\t...graphDesign\n\t...graphExternalRemoteLink\n\t...mercuryFocusArea\n\t...mercuryPortfolio\n\t...radarPosition\n\t...radarView\n\t...compassComponent\n\t...bitbucketPullRequest\n\t...loomVideo\n\t...assetsObject\n\t...assetsObjectType\n\t...assetsSchema\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};
var $1fd3741f1fad91b0$export$2e2bcd8739ae039 = $1fd3741f1fad91b0$var$_default_1;
module.exports["default"] = $1fd3741f1fad91b0$export$2e2bcd8739ae039;

});

parcelRegister("dB4CM", function(module, exports) {

var $42tRz = parcelRequire("42tRz");

const $ed61875d80ed744a$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $42tRz.default)
    ]
]);
const $ed61875d80ed744a$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $ed61875d80ed744a$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $ed61875d80ed744a$export$2e2bcd8739ae039 = $ed61875d80ed744a$var$graphQLErrorHandler;
module.exports["default"] = $ed61875d80ed744a$export$2e2bcd8739ae039;

});

parcelRegister("42tRz", function(module, exports) {
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $67eeec4a0df79f16$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $67eeec4a0df79f16$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $67eeec4a0df79f16$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $67eeec4a0df79f16$export$2e2bcd8739ae039 = $67eeec4a0df79f16$var$validationErrorHandler;
module.exports["default"] = $67eeec4a0df79f16$export$2e2bcd8739ae039;

});

parcelRegister("9t27K", function(module, exports) {

var $9M6Bq = parcelRequire("9M6Bq");


var $tyUdU = parcelRequire("tyUdU");

const $54cb9195043b6c70$var$ACTIVITIES_LIMIT = 50;
const $54cb9195043b6c70$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $54cb9195043b6c70$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $54cb9195043b6c70$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $54cb9195043b6c70$var$activityQueryMap = new Map([
    [
        'workedOn',
        $54cb9195043b6c70$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $54cb9195043b6c70$var$VIEWED__QUERY
    ],
    [
        'all',
        $54cb9195043b6c70$var$ALL__QUERY
    ]
]);
const $54cb9195043b6c70$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $54cb9195043b6c70$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $9M6Bq.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $54cb9195043b6c70$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
	 * If we are filtering by `actors` then we can't use the `myActivity` query.
	 */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $54cb9195043b6c70$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$54cb9195043b6c70$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $54cb9195043b6c70$var$getActivitiesQuery(product, $54cb9195043b6c70$var$getMyActivitiesQuery(activityQueries.map((query)=>$54cb9195043b6c70$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $tyUdU.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $54cb9195043b6c70$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $54cb9195043b6c70$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $54cb9195043b6c70$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $9M6Bq.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};
module.exports["generateGraphQLRequest"] = $54cb9195043b6c70$export$7489a6ef09862e48;

});

parcelRegister("2OHoP", function(module, exports) {

var $fBDYu = parcelRequire("fBDYu");

function $f8c057548f88677e$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $f8c057548f88677e$var$rollUpActivityItems(all),
        viewed: $f8c057548f88677e$var$rollUpActivityItems(viewed),
        workedOn: $f8c057548f88677e$var$rollUpActivityItems(workedOn)
    };
}
function $f8c057548f88677e$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $f8c057548f88677e$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$f8c057548f88677e$var$fragmentName(key)} on ${$f8c057548f88677e$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $f8c057548f88677e$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $f8c057548f88677e$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $f8c057548f88677e$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $f8c057548f88677e$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $f8c057548f88677e$var$containerMapTypes = new Map([
    [
        $f8c057548f88677e$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $f8c057548f88677e$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $f8c057548f88677e$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $f8c057548f88677e$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $f8c057548f88677e$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $f8c057548f88677e$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$f8c057548f88677e$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($f8c057548f88677e$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $f8c057548f88677e$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $f8c057548f88677e$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$f8c057548f88677e$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $f8c057548f88677e$export$884573c560ed3600(response.data);
}
function $f8c057548f88677e$export$884573c560ed3600(queryData) {
    return !queryData.activity || $f8c057548f88677e$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $f8c057548f88677e$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}
function $f8c057548f88677e$export$618af76292d5645c(object) {
    const ari = object.id;
    let product = 'graph';
    if (ari.startsWith('ari:cloud:graph::pull-request') && object.data?.providerName) product = object.data?.providerName || 'graph';
    else if ((0, $fBDYu.isThirdPartyARI)(ari)) product = (0, $fBDYu.parseThirdPartyProduct)(ari).split('.')[1];
    return product.toLowerCase();
}
module.exports["rollupActivitiesData"] = $f8c057548f88677e$export$750d93207e30f59a;
module.exports["activityRoot"] = $f8c057548f88677e$export$ea55e8e0446efa94;
module.exports["parseRootContainerARI"] = $f8c057548f88677e$export$788e6013936a6bb4;
module.exports["filtersToMetadata"] = $f8c057548f88677e$export$e8f56bed6776c7ea;
module.exports["filterInvalidFragments"] = $f8c057548f88677e$export$e22863ec502608d2;
module.exports["isEmptyActivitiesWithErrorsResponse"] = $f8c057548f88677e$export$c939d6148e47244a;
module.exports["getThirdPartyGraphProvider"] = $f8c057548f88677e$export$618af76292d5645c;

});

parcelRegister("fBDYu", function(module, exports) {
const $3421cba56261eeed$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $3421cba56261eeed$export$4578ef3572b21f34 = (ari)=>{
    const result = $3421cba56261eeed$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$3421cba56261eeed$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $3421cba56261eeed$export$fccbae65febb6fd4 = (ari)=>$3421cba56261eeed$var$thirdPartyRegex.test(ari);
module.exports["parseThirdPartyProduct"] = $3421cba56261eeed$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $3421cba56261eeed$export$fccbae65febb6fd4;

});

parcelRegister("7dyLS", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $lEY55 = parcelRequire("lEY55");


var $iUYhn = parcelRequire("iUYhn");


var $eFiFf = parcelRequire("eFiFf");


var $3YFt4 = parcelRequire("3YFt4");

var $ff4c1fab1412a389$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $ff4c1fab1412a389$export$775b6bb06e53a214 = {
    ...(0, $lEY55.Scope),
    ...(0, $iUYhn.Scope),
    ...(0, $3YFt4.TownsquareScope),
    ...(0, $eFiFf.Scope)
};
module.exports["Scope"] = $ff4c1fab1412a389$export$775b6bb06e53a214;

});

parcelRegister("lEY55", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $31e4730094d25be0$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $31e4730094d25be0$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $31e4730094d25be0$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $31e4730094d25be0$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $31e4730094d25be0$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $31e4730094d25be0$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $31e4730094d25be0$export$80a5be864676016b = 'confluence.space';
const $31e4730094d25be0$export$70542451ad6057d2 = 'urs.user-confluence';
const $31e4730094d25be0$export$6ec00f56b27cdc1d = 'generic-container-result';
const $31e4730094d25be0$export$ca1a50bc869949e = 'person-result';
const $31e4730094d25be0$export$a99961038e9d5471 = 'confluence-object-result';
const $31e4730094d25be0$export$18c69de2b4aa679c = 'recent-confluence';
const $31e4730094d25be0$export$dc31f0db54ab1a30 = 'result-confluence';
const $31e4730094d25be0$export$cb8b6c470492bee8 = 'recent-person';
const $31e4730094d25be0$export$ebb42dafe7a39a20 = 'result-person';
const $31e4730094d25be0$export$602b44a55c824e30 = 'advanced-search-confluence';
const $31e4730094d25be0$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $31e4730094d25be0$export$bbd1709e62826142 = 'confluence-page';
const $31e4730094d25be0$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $31e4730094d25be0$export$b441f0c13fd510b9 = 'confluence-attachment';
const $31e4730094d25be0$export$8ee8726ca4e2f8bd = 'confluence-space';
const $31e4730094d25be0$export$d0e824889e01c751 = 'person';
const $31e4730094d25be0$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $31e4730094d25be0$export$775b6bb06e53a214;

});

parcelRegister("iUYhn", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $4cce666965dd4176$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $4cce666965dd4176$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $4cce666965dd4176$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $4cce666965dd4176$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $4cce666965dd4176$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $4cce666965dd4176$export$775b6bb06e53a214;

});

parcelRegister("eFiFf", function(module, exports) {
var $e9e0239fba21ef53$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $e9e0239fba21ef53$export$775b6bb06e53a214;

});

parcelRegister("3YFt4", function(module, exports) {
var $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $e1c90e4cbab1fa73$export$fca43c5c12a4e3fa;

});

parcelRegister("44rik", function(module, exports) {
const $6873537e3409ebab$export$16c4c0987c894b8c = (items, searchTerm)=>{
    if (!searchTerm || !items) return [];
    return items.filter((item)=>{
        return item.name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    });
};
module.exports["filterItems"] = $6873537e3409ebab$export$16c4c0987c894b8c;

});

parcelRegister("k1Kn6", function(module, exports) {

var $7OCSv = parcelRequire("7OCSv");

const $fcdb22c28e10bf47$export$b76efb0c656bea6e = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp, iconUrl: iconUrl, subtype: subtype })=>({
        objectId: objectId,
        name: title,
        container: container,
        url: url,
        ...// which return defaultAlt if no icon is found. Otherwise find an icon by looking up the content type
        iconUrl ? {
            icon: iconUrl,
            iconAlt: (0, $7OCSv.getIconFromContentType)(contentType, subtype).iconAlt
        } : (0, $7OCSv.getIconFromContentType)(contentType, subtype),
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        prefetch: false,
        meta: {
            source: 'xp-search'
        }
    });
module.exports["mapSearchProviderResultToLinkSearchItemData"] = $fcdb22c28e10bf47$export$b76efb0c656bea6e;

});

parcelRegister("7OCSv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $duwSm = parcelRequire("duwSm");


var $lAFHW = parcelRequire("lAFHW");





var $6iY4P = parcelRequire("6iY4P");


var $l5jcq = parcelRequire("l5jcq");


var $57Wda = parcelRequire("57Wda");


var $kWiYc = parcelRequire("kWiYc");


var $8hhCV = parcelRequire("8hhCV");


var $66dpz = parcelRequire("66dpz");


var $9J3bP = parcelRequire("9J3bP");


var $7G33r = parcelRequire("7G33r");


var $eQfRp = parcelRequire("eQfRp");


var $8d3zB = parcelRequire("8d3zB");


var $dh538 = parcelRequire("dh538");


var $hjLb5 = parcelRequire("hjLb5");


var $d5Nnx = parcelRequire("d5Nnx");

var $0d10d22313e2a678$var$LinkContentType = /*#__PURE__*/ function(LinkContentType) {
    LinkContentType[LinkContentType["jira.issue"] = 0] = "jira.issue";
    LinkContentType[LinkContentType["jira.issue.bug"] = 1] = "jira.issue.bug";
    LinkContentType[LinkContentType["jira.issue.story"] = 2] = "jira.issue.story";
    LinkContentType[LinkContentType["jira.issue.task"] = 3] = "jira.issue.task";
    LinkContentType[LinkContentType["jira.issue.epic"] = 4] = "jira.issue.epic";
    LinkContentType[LinkContentType["jira.dashboard"] = 5] = "jira.dashboard";
    LinkContentType[LinkContentType["jira.board"] = 6] = "jira.board";
    LinkContentType[LinkContentType["jira.project"] = 7] = "jira.project";
    LinkContentType[LinkContentType["jira.filter"] = 8] = "jira.filter";
    LinkContentType[LinkContentType["confluence.page"] = 9] = "confluence.page";
    LinkContentType[LinkContentType["confluence.blogpost"] = 10] = "confluence.blogpost";
    LinkContentType[LinkContentType["confluence.whiteboard"] = 11] = "confluence.whiteboard";
    LinkContentType[LinkContentType["loom.video"] = 12] = "loom.video";
    LinkContentType[LinkContentType["confluence.database"] = 13] = "confluence.database";
    LinkContentType[LinkContentType["confluence.embed"] = 14] = "confluence.embed";
    return LinkContentType;
}($0d10d22313e2a678$var$LinkContentType || {});
const $0d10d22313e2a678$export$74b0c6644317c84d = (product, action, cloudId, isMultisiteSearch)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjLb5.EmptyStateNoResults), {
        product: product,
        action: action,
        cloudId: cloudId,
        isMultisiteSearch: isMultisiteSearch
    });
};
const $0d10d22313e2a678$export$f642707b43bbbafc = (contentType)=>{
    return Boolean(contentType && Object.keys($0d10d22313e2a678$var$LinkContentType).includes(contentType));
};
const $0d10d22313e2a678$export$80e948449ec854a9 = {
    'jira.issue': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d3zB.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconIssueLabel
    },
    'jira.issue.bug': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5jcq.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconBugLabel
    },
    'jira.issue.story': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9J3bP.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconStoryLabel
    },
    'jira.issue.task': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G33r.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconTaskLabel
    },
    'jira.issue.epic': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kWiYc.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconEpicLabel
    },
    'jira.dashboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconDashboardLabel
    },
    'jira.board': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconBoardLabel
    },
    'jira.project': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconProjectLabel
    },
    'jira.filter': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
                label: alt,
                size: "xxsmall",
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconFilterLabel
    },
    'confluence.page': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconPageLabel
    },
    'confluence.blogpost': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iY4P.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconBlogLabel
    },
    'confluence.whiteboard': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eQfRp.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconWhiteboardLabel
    },
    'loom.video': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomIcon), {
                label: alt,
                shouldUseNewLogoDesign: true,
                size: "xxsmall"
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconLoomLabel
    },
    'confluence.database': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $57Wda.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconDatabaseLabel
    },
    'confluence.embed': {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($duwSm))), {
                color: "var(--ds-icon-accent-blue, #357DE8)",
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconEmbedLabel
    }
};
const $0d10d22313e2a678$export$d71678bb4eba5b81 = (contentType, subtype)=>{
    if (!$0d10d22313e2a678$export$f642707b43bbbafc(contentType)) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).defaultAltText
    };
    if (contentType === 'jira.issue' && (0, $dh538.fg)('confluence-issue-terminology-refresh')) return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d3zB.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconIssueLabelIssueTermRefresh
    };
    if (contentType === 'confluence.page' && subtype === 'live') return {
        icon: ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66dpz.default), {
                label: alt
            }),
        iconAlt: (0, $d5Nnx.messages).hyperlinkIconLiveDocLabel
    };
    return $0d10d22313e2a678$export$80e948449ec854a9[contentType];
};
const $0d10d22313e2a678$export$ac1fda7301622804 = (iconUrl)=>{
    let alt = (0, $d5Nnx.messages).defaultAltText;
    // TODO add in extra cases for V3 api
    if (iconUrl.includes('story.svg')) alt = (0, $d5Nnx.messages).story;
    if (iconUrl.includes('epic.svg')) alt = (0, $d5Nnx.messages).epic;
    if (iconUrl.includes('avatarId=10318')) alt = (0, $d5Nnx.messages).task;
    if (iconUrl.includes('avatarId=10303')) alt = (0, $d5Nnx.messages).bug;
    if (iconUrl.includes('avatarId=10518')) alt = (0, $d5Nnx.messages).subTask;
    if (iconUrl.includes('avatarId=10310')) alt = (0, $d5Nnx.messages).improvement;
    return alt;
};
const $0d10d22313e2a678$export$fd251dec3e575ea1 = (iconUrl)=>{
    return {
        icon: iconUrl,
        iconAlt: $0d10d22313e2a678$export$ac1fda7301622804(iconUrl)
    };
};
module.exports["renderEmptyStateNoResults"] = $0d10d22313e2a678$export$74b0c6644317c84d;
module.exports["getIconFromContentType"] = $0d10d22313e2a678$export$d71678bb4eba5b81;
module.exports["getIconFromIconUrl"] = $0d10d22313e2a678$export$fd251dec3e575ea1;

});

parcelRegister("6iY4P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0e9f22edb5bbb2a5$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97191d14e335e1cb9997865bd9c31c4d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $kXb3C = parcelRequire("kXb3C");

function $0e9f22edb5bbb2a5$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("kXb3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $5412502140f64e3a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $5412502140f64e3a$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, icon: Icon }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        size: size === 'medium' ? 'medium' : 'small',
        color: color,
        testId: testId
    });
}

});

parcelRegister("l5jcq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6c7fb5a91851c05d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3405feb70bdc0482b21b411108f82ba5>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $kXb3C = parcelRequire("kXb3C");

function $6c7fb5a91851c05d$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
}

});

parcelRegister("57Wda", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::599e4be29a2a39bcbf5cf9b372d0e03e>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $6B0jU = parcelRequire("6B0jU");


var $kXb3C = parcelRequire("kXb3C");

function $0a57bdd6dcbbb0a3$export$2e2bcd8739ae039({ label: label = 'Database', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("kWiYc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4ce94c9023f0019e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d32d0479ba45c629729cf798e1abfca>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $kXb3C = parcelRequire("kXb3C");

function $4ce94c9023f0019e$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
}

});

parcelRegister("8hhCV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $02745cd2b6b0665c$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c46a68f431db1746de65e15ef846dc14>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $8jHAi = parcelRequire("8jHAi");


var $kXb3C = parcelRequire("kXb3C");

function $02745cd2b6b0665c$export$2e2bcd8739ae039({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("66dpz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("9J3bP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $458cec0faf8f188b$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc6be74be899a91647cea1371235d747>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $kXb3C = parcelRequire("kXb3C");

function $458cec0faf8f188b$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
}

});

parcelRegister("7G33r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b1b906ca2447e962$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::00a580c76a83b898772f38add89d77e3>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $kXb3C = parcelRequire("kXb3C");

function $b1b906ca2447e962$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("eQfRp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $26650821103220c8$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a634b13ea98c89a9c27945d37a8a7571>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $ZDq1z = parcelRequire("ZDq1z");


var $kXb3C = parcelRequire("kXb3C");

function $26650821103220c8$export$2e2bcd8739ae039({ label: label = 'Whiteboard', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        color: "var(--ds-icon-accent-teal, #2898BD)"
    });
}

});

parcelRegister("8d3zB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $487ca0b42e22d1f4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d7811e9ce600b90f94930755b99d471>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $kXb3C = parcelRequire("kXb3C");

function $487ca0b42e22d1f4$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
}

});

parcelRegister("hjLb5", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $abC4X = parcelRequire("abC4X");


var $2Nwuj = parcelRequire("2Nwuj");


var $kiOFr = parcelRequire("kiOFr");


var $kSC7A = parcelRequire("kSC7A");


var $dh538 = parcelRequire("dh538");


var $4CdHI = parcelRequire("4CdHI");

const $6b6b665bcf70315b$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    noResults: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.heading",
        defaultMessage: "Get started with {productName}."
    },
    noResultsConfluenceDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.confluenceDescription",
        defaultMessage: "Recently viewed pages will appear once you <link>start using Confluence</link>."
    },
    noResultsJiraDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription",
        defaultMessage: "Recently viewed issues will appear once you <link>start using Jira</link>."
    },
    noResultsJiraDescriptionIssueTerminologyRefreshM4: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.jiraDescription-issue-terminology-refresh-m4",
        defaultMessage: "Recently viewed work items will appear once you <link>start using Jira</link>."
    },
    noResultsDefaultDescription: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.defaultDescription",
        defaultMessage: "Recently viewed items will appear once you <link>start using {productName}</link>."
    },
    noResultsConfluenceCreateOption: {
        id: "fabric.linkPickerAtlassianPlugin.emptyStateNoResults.description",
        defaultMessage: "You can also create a new page."
    }
});
const $6b6b665bcf70315b$export$800daf5fbbe96aff = {
    emptyStateNoResults: 'link-picker-empty-state-no-results'
};
const $6b6b665bcf70315b$var$emptyStateWrapperStyles = null;
const $6b6b665bcf70315b$export$e661eeb828fb7b2 = ({ product: product, action: action, cloudId: cloudId, isMultisiteSearch: isMultisiteSearch })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { data: data } = (0, $kiOFr.useAvailableSites)();
    const isConfluence = product === 'confluence'; // confluence has some special cases
    const productDetails = $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd(product);
    if (!productDetails) return null; // unsupported product
     // find the first matching site for this product
    const firstMatchingSite = data.find($6b6b665bcf70315b$export$5e557b52f4095909(productDetails.availableSitesProduct, cloudId, isMultisiteSearch));
    if (firstMatchingSite) {
        let baseUrl = firstMatchingSite.url; // Confluence is a special case where the baseUrl is the same as Jira's, so we need to add the path
        if (isConfluence) baseUrl += '/wiki';
        const intlDescription = intl.formatMessage(productDetails.description, {
            productName: productDetails.productName,
            link: (str)=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: baseUrl
                }, str)
        }); // Confluence is a special case because it has an optional "create", which we'll list as a call to action
        const intlConfCreate = isConfluence ? intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceCreateOption) : '';
        return /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_otyrmgjw _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf"
            ])
        }, /*#__PURE__*/ $42omo.createElement((0, $abC4X.default), {
            testId: $6b6b665bcf70315b$export$800daf5fbbe96aff.emptyStateNoResults,
            header: intl.formatMessage($6b6b665bcf70315b$export$defe85febe8b728c.noResults, {
                productName: productDetails.productName
            }),
            description: /*#__PURE__*/ $42omo.createElement("span", null, intlDescription, " ", intlConfCreate),
            renderImage: ()=>/*#__PURE__*/ $42omo.createElement((0, $4CdHI.EmptyStateNoResultsSVG), null)
        }));
    }
    return null;
};
const $6b6b665bcf70315b$export$dc8a6c8f6bc81cdd = (product)=>{
    switch(product){
        case 'confluence':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
                productName: 'Confluence',
                description: $6b6b665bcf70315b$export$defe85febe8b728c.noResultsConfluenceDescription
            };
        case 'jira':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
                productName: 'Jira',
                description: (0, $dh538.fg)('jira-issue-terminology-update-m4') ? $6b6b665bcf70315b$export$defe85febe8b728c.noResultsJiraDescriptionIssueTerminologyRefreshM4 : $6b6b665bcf70315b$export$defe85febe8b728c.noResultsJiraDescription
            };
        case 'atlas':
            return {
                availableSitesProduct: (0, $kSC7A.AvailableSitesProductType).ATLAS,
                productName: 'Atlas',
                description: $6b6b665bcf70315b$export$defe85febe8b728c.noResultsDefaultDescription
            };
        default:
            return undefined;
    }
};
const $6b6b665bcf70315b$export$5e557b52f4095909 = (availableSitesProduct, cloudId, isMultisiteSearch)=>{
    return (site)=>{
        // if the product doesn't match, this site doesn't match
        if (!site.products.includes(availableSitesProduct)) return false;
         // if the cloudId is undefined, this site matches (match everything)
        if (!cloudId) return true;
         // if we're mutlisite, match everything - this is probably a mistake,
        // but I'm not going to fix that here, and sticking to consistency with AtlassianLinkPickerPlugin.getRecentItems
        if (isMultisiteSearch) return true;
         // otherwise the site has to match the cloudId
        return site.cloudId === cloudId;
    };
};
module.exports["EmptyStateNoResults"] = $6b6b665bcf70315b$export$e661eeb828fb7b2;

});

parcelRegister("kiOFr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kSC7A = parcelRequire("kSC7A");


var $f8S0G = parcelRequire("f8S0G");


var $hBNGD = parcelRequire("hBNGD");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $bZKB2 = parcelRequire("bZKB2");


var $6fCTI = parcelRequire("6fCTI");

const $78f887db99bd3113$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH = '/gateway/api/v2/accessible-products';
const $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/v2/accessible-products';
const $78f887db99bd3113$var$defaultProducts = [
    (0, $kSC7A.AvailableSitesProductType).WHITEBOARD,
    (0, $kSC7A.AvailableSitesProductType).BEACON,
    (0, $kSC7A.AvailableSitesProductType).COMPASS,
    (0, $kSC7A.AvailableSitesProductType).CONFLUENCE,
    (0, $kSC7A.AvailableSitesProductType).JIRA_BUSINESS,
    (0, $kSC7A.AvailableSitesProductType).JIRA_INCIDENT_MANAGER,
    (0, $kSC7A.AvailableSitesProductType).JIRA_PRODUCT_DISCOVERY,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SERVICE_DESK,
    (0, $kSC7A.AvailableSitesProductType).JIRA_SOFTWARE,
    (0, $kSC7A.AvailableSitesProductType).MERCURY,
    (0, $kSC7A.AvailableSitesProductType).OPSGENIE,
    (0, $kSC7A.AvailableSitesProductType).STATUS_PAGE,
    (0, $kSC7A.AvailableSitesProductType).ATLAS,
    (0, $kSC7A.AvailableSitesProductType).LOOM
];
const $78f887db99bd3113$export$3738ff0cbe469211 = ({ gatewayBaseUrl: gatewayBaseUrl } = {})=>{
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const { sites: sites } = await $78f887db99bd3113$var$getAvailableSites({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                setState({
                    data: sites,
                    loading: false,
                    error: undefined
                });
            } catch (err) {
                createAnalyticsEvent((0, $f8S0G.default)('operational.getAvailableSitesResolve.failed', (0, $6fCTI.getOperationFailedAttributes)(err))).fire((0, $hBNGD.ANALYTICS_CHANNEL));
                const error = err instanceof Error ? err : new Error('unknown error');
                setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl
    ]);
    return state;
};
const $78f887db99bd3113$export$bd4055e8b60f8535 = (data)=>{
    const sites = [];
    data.products.forEach((product)=>{
        product.workspaces.forEach((workspace)=>{
            const currentSite = sites.find((site)=>site.cloudId === workspace.cloudId);
            if (currentSite) {
                currentSite.products.push(product.productId);
                return currentSite;
            }
            sites.push({
                avatarUrl: workspace.workspaceAvatarUrl,
                cloudId: workspace.cloudId,
                displayName: workspace.workspaceDisplayName,
                isVertigo: workspace.vortexMode === 'ENABLED',
                products: [
                    product.productId
                ],
                url: workspace.cloudUrl
            });
        });
    });
    return sites;
};
const $78f887db99bd3113$export$3f59b707a86875c4 = ({ gatewayBaseUrl: gatewayBaseUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isMounted = (0, $bZKB2.useIsMounted)();
    const [state, setState] = (0, $42omo.useState)({
        data: [],
        loading: true
    });
    (0, $42omo.useEffect)(()=>{
        const fetchSites = async ()=>{
            try {
                const response = await $78f887db99bd3113$var$getAccessibleProducts({
                    products: $78f887db99bd3113$var$defaultProducts,
                    gatewayBaseUrl: gatewayBaseUrl
                });
                if (isMounted()) setState({
                    data: $78f887db99bd3113$export$bd4055e8b60f8535(response.data),
                    loading: false,
                    error: undefined
                });
            } catch (error) {
                if (isMounted()) setState({
                    data: [],
                    loading: false,
                    error: error
                });
            }
        };
        fetchSites();
    }, [
        createAnalyticsEvent,
        gatewayBaseUrl,
        isMounted
    ]);
    return state;
};
async function $78f887db99bd3113$var$getAvailableSites({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const availableSitesPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$AVAILABLE_SITES_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: products
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${availableSitesPath}` : availableSitesPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
async function $78f887db99bd3113$var$getAccessibleProducts({ products: products, gatewayBaseUrl: gatewayBaseUrl }) {
    const accessibleProductsPath = (0, $dh538.fg)('linking_platform_site_picker_api_unit_compliant') ? $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_UNIT_COMPLIANT_PATH : $78f887db99bd3113$var$ACCESSIBLE_PRODUCTS_PATH;
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            productIds: products,
            permissionIds: []
        })
    };
    const response = await window.fetch(gatewayBaseUrl ? `${gatewayBaseUrl}${accessibleProductsPath}` : accessibleProductsPath, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
module.exports["useAvailableSites"] = $78f887db99bd3113$export$3738ff0cbe469211;
module.exports["mapAccessibleProductsToAvailableSites"] = $78f887db99bd3113$export$bd4055e8b60f8535;
module.exports["useAvailableSitesV2"] = $78f887db99bd3113$export$3f59b707a86875c4;

});

parcelRegister("kSC7A", function(module, exports) {
var $2f440bf1e6112d68$export$16bdf84263b17cf0 = /*#__PURE__*/ function(AvailableSitesProductType) {
    AvailableSitesProductType["WHITEBOARD"] = "atlassian-whiteboard";
    AvailableSitesProductType["BEACON"] = "beacon";
    AvailableSitesProductType["COMPASS"] = "compass";
    AvailableSitesProductType["CONFLUENCE"] = "confluence.ondemand";
    AvailableSitesProductType["JIRA_BUSINESS"] = "jira-core.ondemand";
    AvailableSitesProductType["JIRA_INCIDENT_MANAGER"] = "jira-incident-manager.ondemand";
    AvailableSitesProductType["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    AvailableSitesProductType["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    AvailableSitesProductType["JIRA_SOFTWARE"] = "jira-software.ondemand";
    AvailableSitesProductType["MERCURY"] = "mercury";
    AvailableSitesProductType["OPSGENIE"] = "opsgenie";
    AvailableSitesProductType["STATUS_PAGE"] = "statuspage";
    AvailableSitesProductType["ATLAS"] = "townsquare";
    AvailableSitesProductType["LOOM"] = "loom";
    return AvailableSitesProductType;
}({});
module.exports["AvailableSitesProductType"] = $2f440bf1e6112d68$export$16bdf84263b17cf0;

});

parcelRegister("f8S0G", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::bf8c5828b0e062cbddf6092143efece2>>
 * @codegenCommand yarn workspace @atlaskit/linking-common run codegen-analytics
 */ function $4a22b51dcbeecd57$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $4a22b51dcbeecd57$export$2e2bcd8739ae039 = $4a22b51dcbeecd57$var$createEventPayload;
module.exports["default"] = $4a22b51dcbeecd57$export$2e2bcd8739ae039;

});

parcelRegister("hBNGD", function(module, exports) {
const $eb5d052cb0327301$export$85183a312807388d = 'media';
const $eb5d052cb0327301$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $eb5d052cb0327301$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $eb5d052cb0327301$export$60efea3f80310017;

});

parcelRegister("bZKB2", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $d79b64f48ff0234f$export$80c2a3957bcb42ea() {
    const isMounted = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $42omo.useCallback)(()=>isMounted.current, []);
}
module.exports["useIsMounted"] = $d79b64f48ff0234f$export$80c2a3957bcb42ea;

});

parcelRegister("6fCTI", function(module, exports) {

var $6mn0G = parcelRequire("6mn0G");

const $9cbe6bde573cd7a4$var$getUrlPath = (url)=>{
    try {
        return new URL(url).pathname;
    } catch  {
        return 'Failed to parse pathname from url';
    }
};
const $9cbe6bde573cd7a4$export$294520aca64d4e59 = (error)=>{
    if (error instanceof Response) return {
        traceId: (0, $6mn0G.getTraceId)(error),
        status: error.status,
        path: $9cbe6bde573cd7a4$var$getUrlPath(error.url)
    };
    return {
        traceId: null,
        status: null,
        path: null
    };
};
const $9cbe6bde573cd7a4$export$e19f9f08a6d79fd2 = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9cbe6bde573cd7a4$export$b2d107ab31565d0b = (err)=>{
    if (err instanceof Response) return {
        error: 'NetworkError',
        errorType: 'NetworkError',
        ...$9cbe6bde573cd7a4$export$294520aca64d4e59(err)
    };
    const error = err instanceof Error ? err : new Error('unknown error');
    return {
        error: error.name,
        errorType: error.name,
        traceId: null,
        status: null,
        path: null
    };
};
module.exports["getOperationFailedAttributes"] = $9cbe6bde573cd7a4$export$b2d107ab31565d0b;

});

parcelRegister("6mn0G", function(module, exports) {
function $ef5055edddfff711$export$e88cb5bfb57ce9c4(response) {
    try {
        return response.headers.get('x-trace-id') ?? response.headers.get('atl-traceid') ?? null;
    } catch  {
        return null;
    }
}
module.exports["getTraceId"] = $ef5055edddfff711$export$e88cb5bfb57ce9c4;

});

parcelRegister("4CdHI", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c4f341a96ee4101f$var$noResultsSVGStyles = null;
const $c4f341a96ee4101f$export$88f98178b806da03 = ()=>{
    return /*#__PURE__*/ $42omo.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 96 96",
        className: (0, $gMc0m.default)([
            "_1bsb16xz _4t3i16xz _19pkidpf _2hwx1wug _otyrpxbi _18u01wug _1e0c1ule"
        ])
    }, /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#FCA700",
        d: "M74.189 55.386c.318-1.787.485-3.69.485-5.697a32.59 32.59 0 0 0-.496-5.774c-1.933-10.773-9.418-17.412-19.912-19.12-1.79-.29-3.669-.44-5.62-.44s-3.994.161-5.854.472c-10.5 1.752-17.971 8.375-19.909 19.088a32.362 32.362 0 0 0-.5 5.774c0 2.039.169 3.91.49 5.697 1.923 10.7 9.4 17.333 19.919 19.089 1.86.31 3.815.471 5.854.471s3.83-.15 5.62-.44c10.512-1.71 18.003-8.36 19.923-19.12Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#1868DB",
        d: "M40.02 77.477c-.248 6.944 3.225 9.59 8.598 9.59 5.044 0 8.434-2.646 8.434-9.59V69.54H40.02v7.938Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#101214",
        d: "M50.807 58.42c-.07.901-.133 1.802-.175 2.702 0 0-.035.29-.077.758a42.187 42.187 0 0 0-.146 1.808c-.088 1.404-.119 3.044-.021 3.98a81.585 81.585 0 0 0 .14 7.037s.062.734.174 1.571c.108.838.255 1.784.377 2.214.147.537.283.876.377.939.206.125.181-.862-.14-3.655.007-.035.007-.15.021-.164-.38-2.954-.248-5.83-.21-8.85-.052.039-.09-.063-.059-.157l.063.035c-.073-2.021.206-3.264.144-5.121 0 0 .066.216.066.22.122-1.571.314-3.292.576-5.052.136-.851.377-1.703.914-2.251.27-.276.615-.485.964-.562.349-.077.691-.014.97.188.283.2.507.53.618.901.056.185.087.377.087.566 0 .195-.024.397-.07.596-.184.8-.708 1.564-1.284 2.228a9.32 9.32 0 0 1-2.01 1.665c-.748.43-1.533.76-2.322.995h.035l-.01.014c.15-.032.44-.102.792-.192.335-.13.754-.245 1.113-.437.182-.09.367-.167.527-.258l.426-.255c.252-.143.395-.258.395-.258-.796.796-1.92 1.354-3.11 1.64-1.194.29-2.444.322-3.624.213l.024-.08c1.016.098 1.924-.042 2.273-.129-.9.105-2.05.112-3.257-.164-.597-.147-1.218-.328-1.805-.621-.147-.07-.293-.144-.443-.213l-.42-.262a4.987 4.987 0 0 1-.785-.573c-.474-.433-.88-.953-1.138-1.5a3.304 3.304 0 0 1-.258-.832 2.151 2.151 0 0 1 .038-.782c.143-.488.458-.88.866-1.078.402-.213.859-.266 1.257-.245-.038-.038-.31-.038-.594-.003-.279.038-.565.112-.715.084.74-.356 1.69-.283 2.426.059-.028.06-.143.035-.262-.007-.122-.031-.251-.077-.297-.08.144.073.754.223 1.362.83.286.3.586.751.803 1.285.22.541.373 1.184.454 1.896.083.712.097 1.487.09 2.307 0 .82-.017 1.672-.056 2.542a91.086 91.086 0 0 1-.373 5.257c-.339 3.453-.785 6.622-.992 8.486-.209 1.864-.195 2.416.213.618l.042.196c.308-1.875.559-3.428.946-5.373.025-.279.042-.31-.024-.317 0-.074-.004-.2-.038-.171-.168.007-.028-.597 0-.866.237.195.443-1.33.551-3.016.115-1.683.108-3.523.136-3.952.262-.157.077-1.69.185-2.206.007.038.063.268.07.3.042-.115.06-.684.042-1.435-.01-.747-.056-1.69-.196-2.541-.254-1.718-1.096-2.912-.436-1.97a4.525 4.525 0 0 0-.967-1.608 3.86 3.86 0 0 0-1.83-1.006 3.41 3.41 0 0 0-1.12-.094 2.874 2.874 0 0 0-1.155.321c-.37.196-.698.496-.936.859a2.7 2.7 0 0 0-.405 1.225c-.07.883.27 1.704.723 2.395.227.349.503.663.8.956.296.287.635.566.99.772l.531.325c.182.097.374.181.563.272.37.195.778.3 1.169.447.806.213 1.637.384 2.478.39l.315.015.314-.01.628-.029.622-.08.31-.042.308-.066.61-.136.597-.189.297-.094.29-.119.572-.24c1.487-.727 2.814-1.778 3.718-3.104.45-.657.828-1.407.911-2.245.087-.841-.188-1.71-.796-2.314-.303-.3-.712-.52-1.141-.59a2.392 2.392 0 0 0-1.232.129c-.744.283-1.32.845-1.673 1.46l.067-.06c-.056.073-.16.324-.217.37a7.214 7.214 0 0 0-.258 1.016c-.07.39-.119.81-.157 1.19l-.133 1.39-.003-.008Zm-4.675 3.376s-.014.01-.007.014c0-.014-.314-.063-.635-.108a8.793 8.793 0 0 1-.66-.154l.028-.077c.629.12 1.655.315 2.196.416.272.06.422.08.325.105-.098.028-.447.003-1.145-.105-.098.007-.091-.063-.105-.094l.003.003Zm-4.726-7.128c.213-.07.453-.126.719-.14a2.898 2.898 0 0 0-1.061.401c-.329.213-.597.52-.772.887-.373.733-.265 1.655.108 2.426.374.779.957 1.47 1.655 1.976.175.126.363.23.541.346l.272.167c.095.05.189.091.283.137.189.087.377.174.566.254.195.063.387.123.576.185-.573.018-1.47-.324-2.28-.872-.824-.566-1.435-1.418-1.735-2.053-.366-.6-.572-1.445-.342-2.217.119-.377.332-.712.593-.97.259-.266.587-.42.88-.52l-.003-.007ZM45.944 70.1l.042.01-.01.102s-.025-.014-.029-.035a.14.14 0 0 1-.003-.077Zm5.26-13.182c-.041-.223.147-1.022.179-.464-.05.133-.046.538-.178.464Zm-6.678-1.63c.039-.06.283.073.475.272.2.196.315.444.241.496a4.06 4.06 0 0 0-.715-.768Zm6.078 9.51c.133.286-.028.198-.122.29.025-.07.042-.326.108-.27l.014-.02Zm0 4.953c.074.07.122.349.13.482-.046.342-.19-.325-.13-.482Zm.527 8.14c.08 0 .13.193.056.256-.063-.014-.133-.245-.045-.287 0 0-.01.014-.01.032Zm-5.058-18.204c-.13-.133-.164-.433-.199-.761-.031-.328-.073-.685-.164-.915.126.024.202.265.244.552.042.286.046.61.084.799.014.136.025.24.032.321l.003.004Zm9.635-4.217c-.105.007-.119-.22-.182-.482-.056-.265-.185-.559-.296-.663l.07-.046c.279.374.44.674.408 1.173v.021-.003Zm-15.158.576c.014.097-.031.195-.066.303-.028.109-.08.217-.077.307-.028 0-.052-.052-.06-.125 0-.07.008-.164.025-.255.06-.171.14-.314.182-.234l-.004.004Zm5.254 5.264c.025.133-.394.017-.513-.01.09 0 .258-.05.36-.039.07.01.083.028.153.049Zm9.97-5.474a3.445 3.445 0 0 1-.363 1.18l-.07-.049c.182-.373.308-.76.35-1.152l.08.018.003.003Zm-2.203 3.327-.055-.063c.363-.464.558-.366.066.053l-.01.01Zm-.984-4.776c.042-.038.108-.1.147-.14.29-.264.276-.146.178-.02-.098.125-.248.3-.328.16h.003Zm-1.065 4.2c0 .087.014.206 0 .297-.08.607-.202-.091 0-.297ZM38.864 13.967l-.233-.314s-.112-.65-.392-.828l-.254-.946s-.189-.366-.353-.44a.488.488 0 0 0-.29-.041c-.17.038-.265.216-.073.565-.007.007-.014.028-.028.035.262.35.185.8.353 1.19.045-.02.09-.02.07 0l-.063.018c.216.223.08.457.373.628h-.09c.335.82.656 1.98 1.075 2.845l.007-.007h.01c.032-.104-.024-.537-.024-.537.401.195.216.646.342.96l-.08.024a.659.659 0 0 0-.179-.286c.07.534.405 1.536.699 1.969.055-.035-.13-.136.052-.241.045.122.119.234.154.35-.126.044-.105-.04-.133-.043-.066.248 1.229 4.336 1.42 3.184h.074c-.06-.258-.112-.471-.077-.775-.024-.032-.01-.042-.077-.018-.014-.006-.038-.017-.062 0-.157.06-.123-.041-.14-.076.506-.13-.237-.824-.258-.943.227-.105-.07-.223.003-.328.01 0 .073.014.084.014.13-.115-.646-.97-.255-.785.07-1.358-1.288-3.296-1.316-4.727l-.024.02s-.021-.038.01-.059c-.14-.094-.328-.401-.328-.401l.003-.007Zm.768 3.034s.014 0 .014-.004c-.024.01.05.168.046.178l-.077.028c-.21-.112.185-.684.084-.237.024.007-.042.028-.067.041v-.006Zm.514 1.462c0 .032.007.063.014.101-.381-.293-.259-.91-.52-1.288.397.018.334.423.376.608.144.153.123.398.13.576v.003Zm.81 2.465.041-.014v.014s-.02.007-.024.007c-.01 0-.018 0-.014-.007h-.004Zm-2.203-6.696c.073.007.073.123-.074.098.014-.024-.063-.056.074-.098Zm1.448 4.692c.13-.045.203.084.028.147-.02-.046-.024-.098-.028-.147Zm-1.951-5.68c-.15.01.007-.031.087-.073-.014.018-.01.052-.077.066l-.01.007Zm-.314-.621c-.07.014-.126-.007-.136-.024.035-.063.188-.018.136.024Zm-.391-1.068c-.077.024-.112.007-.039-.025.056-.017.112 0 .025.035 0 0 .01-.003.014-.01Zm2.611 8.11c-.237.041-.101-.151-.185-.196.23-.063.108.115.164.153a.229.229 0 0 0 .021.042Zm-1.445-4.235c-.2.073-.091-.126-.15-.157l.077-.028c.045.063.111.087.073.181v.004Zm.918 2.96c-.087 0-.032-.07-.042-.098.112-.038.171.07.038.098h.004Zm-.391-1.194c.119-.049.08.031.098.042-.028 0-.112 0-.115-.01 0-.011.01-.018.017-.032Zm-.433-1.742a1.4 1.4 0 0 1 .056.171l-.08.025a4.814 4.814 0 0 1-.056-.171l.08-.025Zm.077.6-.077.029c-.101-.056.094-.133.077-.028Zm-.423-1.284v.031c.05.112-.293.053 0-.031Zm-.29-.573s-.045-.014-.045-.028c-.02-.083.203-.062.046.028ZM51.327 14.843l-.007-.303s.28-.416.164-.67c.115-.22.237-.433.356-.65 0 0 .073-.304-.003-.44a.52.52 0 0 0-.196-.202c-.153-.087-.328-.053-.394.251-.01 0-.025.007-.042 0-.01.346-.335.541-.433.855.049.014.084.042.052.039l-.059-.028c.038.248-.206.3-.07.565l-.07-.052c-.206.65-.586 1.498-.694 2.238h.017c.08-.05.265-.332.265-.332.227.325-.164.492-.22.75l-.08-.024a.409.409 0 0 0 0-.262c-.223.356-.45 1.142-.412 1.55.063.004-.042-.143.164-.125-.02.097-.014.199-.038.29-.13-.032-.073-.074-.094-.088-.088.06-.356.89-.468 1.63-.112.74-.087 1.376.244 1.027l.067.028c.059-.196.104-.357.272-.538-.007-.031.007-.031-.06-.042a.093.093 0 0 0-.055-.028c-.164-.024-.091-.077-.091-.108.506.122.16-.628.199-.716.248.032.042-.174.157-.206.007.007.06.039.066.046.16-.014-.1-.894.15-.604.353-.405.482-1.047.632-1.704.147-.653.321-1.32.702-1.72h-.032s.008-.036.042-.029c-.059-.125-.041-.401-.041-.401l.01.003Zm-1.002 2.137.014.003c-.024-.007-.045.126-.052.13l-.08-.025c-.116-.175.506-.314.191-.101.018.014-.049-.004-.076-.01l.003.003Zm-.304 1.134c-.014.021-.024.042-.038.07-.185-.36.23-.68.203-1.033.32.206.07.415.01.551.045.161-.09.3-.178.412h.003Zm-.453 1.906.041.007v.01s-.028-.006-.03-.01c-.008 0-.015-.007-.011-.01v.003Zm1.522-5.093c.055.046-.01.112-.112.014.024-.007-.017-.066.112-.014Zm-1.243 3.498c.133.031.136.147-.049.105.007-.039.028-.07.049-.105ZM51.25 14.1c-.122-.08.025-.014.112.01-.021 0-.038.021-.098-.007h-.014V14.1Zm.115-.52c-.062-.035-.09-.08-.09-.095.063-.014.153.102.09.095Zm.332-.796c-.073-.035-.087-.063-.014-.035.052.028.084.07 0 .035h.014Zm-2.248 6.084c-.227-.08-.014-.14-.066-.21.23.064.034.123.07.172 0 .014-.004.024 0 .035l-.004.003Zm.946-3.288c-.2-.066-.004-.122-.035-.175l.077.028c0 .063.042.112-.042.143v.004Zm-.779 2.245c-.076-.042.01-.06.014-.08.116.027.112.125-.014.08Zm.276-.925c.126.03.053.059.06.076-.025-.017-.095-.056-.091-.066.003-.007.017-.003.031-.01Zm.566-1.254a.961.961 0 0 1-.046.13l-.076-.028c.014-.046.031-.088.045-.13l.077.028Zm-.262.388-.08-.025c-.056-.087.15-.028.08.025Zm.36-.97s-.018.013-.018.017c-.02.09-.265-.133.018-.018Zm.087-.486s-.028-.031-.021-.042c.031-.06.195.08.02.042ZM62.638 15.643l.17-.367s.528-.43.552-.768l.726-.708s.238-.353.227-.535a.489.489 0 0 0-.101-.279c-.115-.132-.321-.122-.541.224-.01 0-.028 0-.042-.007-.189.408-.628.572-.897.918.042.031.063.066.035.06l-.046-.046c-.097.303-.373.303-.384.649l-.042-.08c-.572.712-1.459 1.588-2.035 2.401h.01l.008.011c.108-.028.467-.293.467-.293.014.453-.474.52-.698.792l-.06-.056c.102-.111.165-.237.172-.303-.443.335-1.18 1.141-1.428 1.62.056.03.06-.182.237-.077-.087.1-.153.223-.237.314-.101-.087-.017-.112-.028-.14-.251.066-3.295 3.299-2.171 2.877l.035.066c.202-.185.37-.339.66-.464.017-.039.031-.032-.021-.077 0-.014-.004-.042-.028-.056-.126-.108-.021-.13 0-.164.36.38.621-.628.719-.709.202.147.167-.178.297-.164l.027.08c.165.056.559-1.064.584-.624 1.25-.632 2.335-2.821 3.606-3.575l-.028-.01s.028-.039.059-.021c.017-.172.203-.493.203-.493l-.008.004Zm-2.35 2.223s.007.011.01.011c-.02-.017-.125.13-.136.13l-.062-.057c0-.24.701-.185.254-.049.007.025-.045-.02-.07-.038l.004.003Zm-1.068 1.201a.653.653 0 0 0-.084.063c.08-.485.691-.694.904-1.117.175.36-.22.51-.363.646-.066.202-.3.314-.454.408h-.003Zm-1.815 1.973.031.028-.01.01s-.018-.017-.021-.024c-.004-.007-.007-.018 0-.018v.004Zm4.94-5.362c.03.07-.078.129-.123-.014.032 0 .021-.084.122.014Zm-3.51 3.676c.102.09.022.223-.118.097.032-.041.077-.07.119-.097Zm4.155-4.622c-.084-.126.032-.01.108.038-.02-.007-.052.018-.097-.035l-.01-.007v.004Zm.408-.594c-.045-.056-.052-.115-.041-.129.073 0 .104.157.041.13Zm.768-.89c-.059-.052-.059-.094.004-.045.042.042.056.097-.017.038 0 0 .01.007.013.007Zm-6.014 6.44c-.15-.188.087-.163.087-.265.168.172-.052.154-.06.224-.013.014-.02.028-.027.038v.004Zm3.1-3.434c-.161-.14.07-.143.07-.213l.062.056c-.035.073-.024.143-.129.157h-.003Zm-2.214 2.321c-.041-.077.05-.063.067-.084.087.08.017.189-.07.084h.003Zm.887-.953c.101.08.01.087.01.108-.01-.028-.055-.097-.045-.108.007-.007.021 0 .035 0Zm1.351-1.27c-.038.045-.084.094-.126.14l-.059-.057c.042-.045.084-.094.126-.136l.059.056v-.004Zm-.5.37-.062-.056c0-.12.164.014.063.052v.003Zm.947-1.027s-.025.01-.028.018c-.077.1-.185-.23.028-.018Zm.373-.548s-.007-.045 0-.056c.067-.06.15.147 0 .056Z"
    }), /*#__PURE__*/ $42omo.createElement("path", {
        fill: "#09326C",
        d: "M40.02 69.542v4.336a31.13 31.13 0 0 0 2.771.597c1.861.31 3.816.471 5.855.471 2.038 0 3.83-.15 5.62-.44a30.493 30.493 0 0 0 2.786-.586v-4.378H40.02Z"
    }));
};
module.exports["EmptyStateNoResultsSVG"] = $c4f341a96ee4101f$export$88f98178b806da03;

});

parcelRegister("d5Nnx", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $930927a24c397c44$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel",
        defaultMessage: "Issue"
    },
    hyperlinkIconBugLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBugLabel",
        defaultMessage: "Bug"
    },
    hyperlinkIconStoryLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconStoryLabel",
        defaultMessage: "Story"
    },
    hyperlinkIconTaskLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconTaskLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconEpicLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEpicLabel",
        defaultMessage: "Epic"
    },
    hyperlinkIconDashboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDashboardLabel",
        defaultMessage: "Dashboard"
    },
    hyperlinkIconBoardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBoardLabel",
        defaultMessage: "Board"
    },
    hyperlinkIconProjectLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconProjectLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconPlanLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPlanLabel",
        defaultMessage: "Plan"
    },
    hyperlinkIconFilterLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconFilterLabel",
        defaultMessage: "Filter"
    },
    hyperlinkIconPageLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconPageLabel",
        defaultMessage: "Page"
    },
    hyperlinkIconBlogLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconBlogLabel",
        defaultMessage: "Blog"
    },
    hyperlinkIconWhiteboardLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconWhiteboardLabel",
        defaultMessage: "Whiteboard"
    },
    hyperlinkIconDatabaseLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconDatabaseLabel",
        defaultMessage: "Database"
    },
    hyperlinkIconEmbedLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconEmbedLabel",
        defaultMessage: "Smart Link"
    },
    hyperlinkIconLoomLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLoomLabel",
        defaultMessage: "Loom"
    },
    hyperlinkIconLiveDocLabel: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconLiveDocLabel",
        defaultMessage: "Live Doc"
    },
    story: {
        id: "fabric.linkPicker.story",
        defaultMessage: "Story"
    },
    epic: {
        id: "fabric.linkPicker.epic",
        defaultMessage: "Epic"
    },
    task: {
        id: "fabric.linkPicker.task",
        defaultMessage: "Task"
    },
    bug: {
        id: "fabric.linkPicker.bug",
        defaultMessage: "Bug"
    },
    subTask: {
        id: "fabric.linkPicker.subTask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "fabric.linkPicker.improvement",
        defaultMessage: "Improvement"
    },
    defaultAltText: {
        id: "fabric.linkPicker.defaultAltText",
        defaultMessage: "List item"
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: "fabric.linkPicker.headingLink.hyperlinkIconIssueLabel-issue-term-refresh",
        defaultMessage: "Work item"
    }
});
module.exports["messages"] = $930927a24c397c44$export$defe85febe8b728c;

});

parcelRegister("4LCen", function(module, exports) {

var $7MEO5 = parcelRequire("7MEO5");


var $3paC4 = parcelRequire("3paC4");


var $7dyLS = parcelRequire("7dyLS");

const $2fe1ecad5a015726$var$ANALYTICS_IDENTIFIER = 'link-picker';
const $2fe1ecad5a015726$var$JIRA_DASHBOARD_URL_PATTERN = new RegExp(/(.*)\/issues\/\?dashboard=(\d+)$/);
class $2fe1ecad5a015726$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $7MEO5.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            const result = {
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                }) : item.baseUrl + item.url
            };
            if (item.subtype) result.subtype = item.subtype;
            return result;
        });
    }
    getIconUrlFromAvatar(avatar) {
        if ('urls' in avatar) return avatar.urls['16x16'];
        else return avatar.url;
    }
    jiraResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>{
            // The `item.url` here for Jira content is _usually_ absolute url, except for dashboard where the url is wrong
            // It respond with https://site/issues/?dashboard={dashboardId}, but the url needs to be
            // https://site/jira/dashboards/{dashboardId}
            const dashboardMatch = $2fe1ecad5a015726$var$JIRA_DASHBOARD_URL_PATTERN.exec(item.url);
            const url = dashboardMatch ? `${dashboardMatch[1]}/jira/dashboards/${dashboardMatch[2]}` : item.url;
            return {
                title: item.name,
                url: url,
                container: 'container' in item.attributes && item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], 'issueTypeName' in item.attributes ? item.attributes.issueTypeName : undefined),
                updatedTimestamp: 'updated' in item.attributes ? item.attributes.updated : undefined,
                iconUrl: 'avatar' in item.attributes && item.attributes.avatar ? this.getIconUrlFromAvatar(item.attributes.avatar) : undefined,
                objectId: this.cloudIds.length === 0 ? this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: item.attributes['@type'],
                    resourceId: item.id
                }) : url
            };
        });
    }
    townsquareProjectResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareProject'),
                objectId: url
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    townsquareGoalResponseTransformer(response) {
        if (!response) return [];
        const townsquareResponseToQuickSearch = (item)=>{
            const { id: id, title: title, url: url, iconUrl: iconUrl } = item;
            return {
                title: title,
                url: // The `item.url` in Townsquare/Atlas response is absolute url
                url,
                iconUrl: iconUrl,
                // There isn't any container like attribute in the response
                container: '',
                contentType: this.mapToContentType('townsquareGoal'),
                objectId: id
            };
        };
        return response.results.map(townsquareResponseToQuickSearch);
    }
    LoomResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                url: item.url,
                container: item.workspaceName,
                contentType: this.mapToContentType('loom'),
                objectId: item.url,
                updatedTimestamp: item.activityDate || item.createdAt
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    case 'Epic':
                        return 'jira.issue.epic';
                    default:
                        return 'jira.issue';
                }
            case 'project':
                return 'jira.project';
            case 'board':
                return 'jira.board';
            case 'filter':
                return 'jira.filter';
            case 'dashboard':
                return 'jira.dashboard';
            case 'townsquareProject':
                return 'townsquare.project';
            case 'townsquareGoal':
                return 'townsquare.goal';
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            case 'whiteboard':
                return 'confluence.whiteboard';
            case 'database':
                return 'confluence.database';
            case 'embed':
                return 'confluence.embed';
            case 'loom':
                return 'loom.video';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit,
            sites: this.cloudIds
        });
        if (this.scope === (0, $7dyLS.Scope).ConfluencePageBlog || this.scope === (0, $7dyLS.Scope).ConfluencePageBlogWhiteboard || this.scope === (0, $7dyLS.Scope).ConfluenceContentType) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.confluencePageBlogResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).JiraIssue || this.scope === (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.jiraResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).TownsquareProject) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareProjectResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).TownsquareGoal) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.townsquareGoalResponseTransformer(scopeResult);
        } else if (this.scope === (0, $7dyLS.Scope).Loom) {
            const scopeResult = result.response.retrieveScope(this.scope);
            return this.LoomResponseTransformer(scopeResult);
        } else throw new Error(`Unsupported scope - ${this.scope}`);
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $2fe1ecad5a015726$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false, cloudIds = []){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.cloudIds = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
            case (0, $7dyLS.Scope).ConfluencePageBlogWhiteboard:
            case (0, $7dyLS.Scope).ConfluenceContentType:
            case (0, $7dyLS.Scope).JiraIssue:
            case (0, $7dyLS.Scope).JiraDashboard:
            case (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter:
            case (0, $7dyLS.Scope).TownsquareProject:
            case (0, $7dyLS.Scope).TownsquareGoal:
            case (0, $7dyLS.Scope).Loom:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.cloudIds = cloudIds;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $3paC4.createClient)(config);
    }
}
module.exports["default"] = $2fe1ecad5a015726$export$2e2bcd8739ae039;

});

parcelRegister("3paC4", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $jppmC = parcelRequire("jppmC");

const $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY = 3;
const $6b372c322d10f06f$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $6b372c322d10f06f$var$MAX_SITES_INITIAL_QUERY);
};
class $6b372c322d10f06f$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $6b372c322d10f06f$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $jppmC.timed)(this.makePostRequest($6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$6b372c322d10f06f$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$6b372c322d10f06f$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $6b372c322d10f06f$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $6b372c322d10f06f$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $6b372c322d10f06f$export$5d730b7aed1a3eb0;

});

parcelRegister("jppmC", function(module, exports) {
const $e3bb250125deb745$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $e3bb250125deb745$export$d35186a762cd39c8;

});

parcelRegister("1MqUK", function(module, exports) {

var $7OCSv = parcelRequire("7OCSv");

const $13b92bff3b95cf64$export$d82137ca931458ca = ({ object: object, containers: containers, timestamp: timestamp })=>{
    let iconUrl = object.icon?.value || '';
    if (object.icon?.type === 'EMOJI') iconUrl = object.icon.fallback || '';
    const iconData = object.product === 'confluence' ? (0, $7OCSv.getIconFromContentType)(object.product + '.' + object.type.toLowerCase(), object.subtype?.toLowerCase()) : (0, $7OCSv.getIconFromIconUrl)(iconUrl);
    return {
        objectId: object.id,
        name: object.name || '',
        container: $13b92bff3b95cf64$var$getContainerName(containers),
        url: object.url,
        ...iconData,
        lastViewedDate: timestamp ? new Date(timestamp) : undefined,
        prefetch: true,
        meta: {
            source: 'recent-work'
        }
    };
};
const $13b92bff3b95cf64$var$getContainerName = (containers)=>{
    for(let i = containers.length - 1; i >= 0; --i){
        const containerName = containers[i].name;
        if (containerName) return containerName;
    }
    return '';
};
/** No results returned for townsquare (Atlas) if `platform` is used in filter
 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
 */ /**
 * Generate the ARI for particular product to send to the recent items API.
 */ function $13b92bff3b95cf64$var$generateProductSpecificAri(product, cloudId) {
    if (product === 'townsquare') /** No results returned for townsquare (Atlas) if `platform` is used in filter
		 * https://atlassian.slack.com/archives/CGZMUTRUL/p1684729057252109?thread_ts=1684727786.451419&cid=CGZMUTRUL
		 */ return `ari:cloud:townsquare::site/${cloudId}`;
    return `ari:cloud:platform::site/${cloudId}`;
}
function $13b92bff3b95cf64$export$4b7ffcf66d37c47b(products, cloudId) {
    const defaultAri = `ari:cloud:platform::site/${cloudId}`;
    if (products === undefined) return [
        defaultAri
    ];
    const allAris = products.map((product)=>$13b92bff3b95cf64$var$generateProductSpecificAri(product, cloudId));
    // Deduplicate
    return allAris.filter((value, index)=>allAris.indexOf(value) === index);
}
module.exports["mapActivityClientResultToLinkSearchItemData"] = $13b92bff3b95cf64$export$d82137ca931458ca;
module.exports["getArisForProducts"] = $13b92bff3b95cf64$export$4b7ffcf66d37c47b;

});

parcelRegister("3W9OD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7dyLS = parcelRequire("7dyLS");


var $2fkag = parcelRequire("2fkag");


var $bQm3c = parcelRequire("bQm3c");

function $267ba6a0568e3ab0$export$ffe8c124580b6e44() {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useMemo)(()=>Promise.resolve((0, $2fkag.createSearchProvider)(cloudId, (0, $7dyLS.Scope).ConfluencePageBlog, undefined, undefined, true)), [
        cloudId
    ]);
}
module.exports["useSearchProvider"] = $267ba6a0568e3ab0$export$ffe8c124580b6e44;

});

parcelRegister("2fkag", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dIeDA = parcelRequire("dIeDA");

const $f41289c0cfd3ba69$export$31a7d81156fc4fa1 = (cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri)=>{
    return new (0, $dIeDA.default)(cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri);
};
module.exports["createSearchProvider"] = $f41289c0cfd3ba69$export$31a7d81156fc4fa1;

});

parcelRegister("dIeDA", function(module, exports) {

var $3paC4 = parcelRequire("3paC4");


var $7dyLS = parcelRequire("7dyLS");


var $7MEO5 = parcelRequire("7MEO5");

const $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER = 'editor-quick-search';
class $2b54566fbe30c20f$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $7MEO5.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                })
            }));
    }
    jiraIssueResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                // The `item.url` here for Jira Issue is the absolute url
                url: item.url,
                container: item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], item.attributes.issueTypeName),
                updatedTimestamp: item.attributes.updated,
                objectId: this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: 'issue',
                    resourceId: item.id
                })
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    default:
                        return 'jira.issue';
                }
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit
        });
        switch(this.scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.confluencePageBlogResponseTransformer(scopeResult);
                }
            case (0, $7dyLS.Scope).JiraIssue:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.jiraIssueResponseTransformer(scopeResult);
                }
            default:
                throw new Error(`Unsupported scope - ${this.scope}`);
        }
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $2b54566fbe30c20f$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $7dyLS.Scope).ConfluencePageBlog:
            case (0, $7dyLS.Scope).JiraIssue:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $3paC4.createClient)(config);
    }
}
module.exports["default"] = $2b54566fbe30c20f$export$2e2bcd8739ae039;

});

parcelRegister("7642E", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $XOZYy = parcelRequire("XOZYy");


const $52ac3a8ba658d4f5$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
 * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
 *
 * This provides a lightweight replacement for the legacy Icon component that
 * was removed in DSP-24550. Instead of wrapping the glyph in a span with
 * complex styling, it simply renders the glyph component directly, passing
 * through relevant props.
 *
 * This is NOT a public API — it exists solely to unblock the removal of
 * deprecated icon APIs from @atlaskit/icon.
 */ const React = (parcelRequire("42omo"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $XOZYy, {
    default: $52ac3a8ba658d4f5$var$_inlined0
});
if ($XOZYy.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});

parcelRegister("e2ZTm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::abee860452bcaffc9cded3519ab61cd1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3a1430ff6078f73$var$_react = $a3a1430ff6078f73$var$_interopRequireDefault((parcelRequire("42omo")));

var $a3a1430ff6078f73$var$_baseNew = $a3a1430ff6078f73$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a3a1430ff6078f73$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SuggestedEdit".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for suggestions powered by Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3a1430ff6078f73$var$SuggestedEditIcon = (props)=>/*#__PURE__*/ $a3a1430ff6078f73$var$_react.default.createElement($a3a1430ff6078f73$var$_baseNew.default, Object.assign({
        name: "SuggestedEditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.84 5.85a2 2 0 0 1 2.83 0l.73.73a2 2 0 0 1 0 2.83l-5.14 5.14a2 2 0 0 1-.86.51l-3.19.91a.75.75 0 0 1-.93-.93l.91-3.19a2 2 0 0 1 .51-.86zm1.77 1.06a.5.5 0 0 0-.71 0l-.59.59 1.44 1.44.59-.59a.5.5 0 0 0 0-.71zM12.69 10l-1.44-1.44-3.49 3.49a.5.5 0 0 0-.13.22l-.54 1.89 1.89-.54a.5.5 0 0 0 .22-.13zM4.75 0c.31 0 .59.19.7.48l1 2.57 2.57 1a.75.75 0 0 1 0 1.4l-2.57 1-1 2.57a.75.75 0 0 1-1.4 0l-1-2.57-2.57-1a.75.75 0 0 1 0-1.4l2.57-1 1-2.57a.75.75 0 0 1 .7-.48m0 2.82L4.33 3.9a.75.75 0 0 1-.43.43l-1.08.42 1.08.42a.75.75 0 0 1 .43.43l.42 1.08.42-1.08a.75.75 0 0 1 .43-.43l1.08-.42-1.08-.42a.75.75 0 0 1-.43-.43z" clip-rule="evenodd"/>`
    }, props));
$a3a1430ff6078f73$var$SuggestedEditIcon.displayName = 'SuggestedEditIcon';
var $a3a1430ff6078f73$var$_default = module.exports.default = $a3a1430ff6078f73$var$SuggestedEditIcon;

});

parcelRegister("7hGsm", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $54db0de22feedc16$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("2UWw0")));

var $hXuPC = parcelRequire("hXuPC");


var $iIf3l = parcelRequire("iIf3l");


var $a5jIU = parcelRequire("a5jIU");


var $fkDf0 = parcelRequire("fkDf0");


var $6yHbi = parcelRequire("6yHbi");


var $2UWw0 = parcelRequire("2UWw0");

var $54db0de22feedc16$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $54db0de22feedc16$var$_window = (0, $fkDf0.getGlobalObject)();
if ($54db0de22feedc16$var$_window.Sentry && $54db0de22feedc16$var$_window.Sentry.Integrations) $54db0de22feedc16$var$windowIntegrations = $54db0de22feedc16$var$_window.Sentry.Integrations;
var $54db0de22feedc16$export$99d02219d259eb94 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, $54db0de22feedc16$var$windowIntegrations), (0, $a5jIU)), $6yHbi);
$parcel$exportWildcard(module.exports, $iIf3l);

});

parcelRegister("iIf3l", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("cs0rL")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("euURg")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("805AA")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("805AA")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("805AA")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("805AA")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("805AA")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("k3i2h")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("k3i2h")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("k3i2h")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("k3i2h")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("euURg")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("cSJat")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("805AA")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("cTFwF")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("805AA")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("805AA")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("805AA")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("805AA")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("805AA")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("805AA")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("805AA")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("cW7ac")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("1cvC0")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("a7P2i")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("a7P2i")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("ffG6S")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("ffG6S")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("ffG6S")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("ffG6S")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("ffG6S")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("ffG6S")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("ffG6S")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("ffG6S")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("ffG6S")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("brq4Q")).SDK_NAME);

var $cs0rL = parcelRequire("cs0rL");


var $805AA = parcelRequire("805AA");

var $euURg = parcelRequire("euURg");

var $k3i2h = parcelRequire("k3i2h");

var $cTFwF = parcelRequire("cTFwF");

var $cSJat = parcelRequire("cSJat");


var $cW7ac = parcelRequire("cW7ac");


var $1cvC0 = parcelRequire("1cvC0");


var $a7P2i = parcelRequire("a7P2i");


var $ffG6S = parcelRequire("ffG6S");


var $brq4Q = parcelRequire("brq4Q");


});

parcelRegister("brq4Q", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $854671b7fcc6622a$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $854671b7fcc6622a$export$ca61d37259221480;

});

parcelRegister("6yHbi", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("3BsQh")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("lIIKi")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bISXm")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("63fUW")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("eLUbA")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("fCIwr")).Dedupe);

var $3BsQh = parcelRequire("3BsQh");


var $lIIKi = parcelRequire("lIIKi");


var $bISXm = parcelRequire("bISXm");


var $63fUW = parcelRequire("63fUW");


var $eLUbA = parcelRequire("eLUbA");


var $fCIwr = parcelRequire("fCIwr");


});

parcelRegister("2UWw0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("1l2dO")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("8LVWj")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("2yXKF")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hB2rb")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("lgAM0")).makeNewXHRTransport);

var $1l2dO = parcelRequire("1l2dO");


var $8LVWj = parcelRequire("8LVWj");


var $2yXKF = parcelRequire("2yXKF");


var $hB2rb = parcelRequire("hB2rb");


var $lgAM0 = parcelRequire("lgAM0");


});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("9fywD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $3gadb = parcelRequire("3gadb");

const $43aed8c383cce8da$var$i18n = (0, $aXWIB.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("5qrxS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $7dyLS = parcelRequire("7dyLS");

var $1C4cT = parcelRequire("1C4cT");


var $3FTlm = parcelRequire("3FTlm");


var $d4Mwr = parcelRequire("d4Mwr");

const $a7827c25df0a1c01$var$messages = (0, $aXWIB.defineMessages)({
    create: {
        id: "link-create.jira-plugin-create-config",
        defaultMessage: "Create"
    }
});
const $a7827c25df0a1c01$export$c0007b48d375a9ff = {
    tabConfig: {
        tabKey: 'jira',
        tabTitle: 'Jira'
    },
    products: [
        'jira'
    ],
    scope: (0, $7dyLS.Scope).JiraIssueDashboardBoardProjectFilter
};
const $a7827c25df0a1c01$export$af1b31f68dc05ab3 = (formatMessage)=>({
        ...$a7827c25df0a1c01$export$c0007b48d375a9ff,
        action: {
            label: formatMessage($a7827c25df0a1c01$var$messages.create),
            callback: ()=>{
                console.log('Placeholder for Jira Create');
            }
        }
    });
const $a7827c25df0a1c01$export$3fc43c5f39c4a529 = {
    tabConfig: {
        tabKey: 'confluence',
        tabTitle: 'Confluence'
    },
    products: [
        'confluence'
    ],
    scope: (0, $7dyLS.Scope).ConfluenceContentType
};
const $a7827c25df0a1c01$export$547f1973f56da40b = {
    tabConfig: {
        tabKey: 'atlas',
        tabTitle: 'Atlas'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$32f102fef46346 = {
    tabConfig: {
        tabKey: 'home',
        tabTitle: 'Home'
    },
    products: [
        'townsquare'
    ],
    scope: (0, $7dyLS.Scope).TownsquareProject
};
const $a7827c25df0a1c01$export$b1b5e4959b6adcf2 = {
    tabConfig: {
        tabKey: 'loom',
        tabTitle: 'Loom'
    },
    products: [
        'loom'
    ],
    scope: (0, $7dyLS.Scope).Loom,
    disableActivityClient: true
};
const $a7827c25df0a1c01$var$currentProductToPluginMap = {
    jira: $a7827c25df0a1c01$export$c0007b48d375a9ff,
    confluence: $a7827c25df0a1c01$export$3fc43c5f39c4a529,
    atlas: $a7827c25df0a1c01$export$547f1973f56da40b,
    loom: $a7827c25df0a1c01$export$b1b5e4959b6adcf2,
    townsquare: $a7827c25df0a1c01$export$32f102fef46346
};
const $a7827c25df0a1c01$export$ede9abe489c9321b = (config)=>{
    const { cloudId: cloudId, activityClientEndpoint: activityClientEndpoint, aggregatorUrl: aggregatorUrl } = config ?? {};
    const { availableProducts: availableProducts, isLoading: isLoading } = (0, $d4Mwr.useAvailableProducts)(config?.cloudId);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    /**
   * Lower case possible name of product. Should be `confluence` or `jira`.
   * This typing is not ideal. An unknown current product will:
   * - in the case of no 1P tabs enabled, default to Scope.ConfluencePageBlog scope
   * - in the case of 1P tabs enabled, not ensure the first tab is the current product
   */ const currentProduct = config?.product?.toLowerCase();
    const createPluginConfig = (0, $42omo.useMemo)(()=>{
        return (config)=>({
                cloudId: cloudId,
                activityClientEndpoint: activityClientEndpoint,
                aggregatorUrl: aggregatorUrl,
                ...config
            });
    }, [
        cloudId,
        activityClientEndpoint,
        aggregatorUrl
    ]);
    const configMap = (0, $42omo.useMemo)(()=>{
        return {
            jira: createPluginConfig((0, $dh538.fg)('platform.linking-platform.link-picker.enable-jira-create') ? $a7827c25df0a1c01$export$af1b31f68dc05ab3(formatMessage) : $a7827c25df0a1c01$var$currentProductToPluginMap.jira),
            confluence: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.confluence),
            atlas: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.atlas),
            townsquare: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.townsquare),
            loom: createPluginConfig($a7827c25df0a1c01$var$currentProductToPluginMap.loom)
        };
    }, [
        createPluginConfig,
        formatMessage
    ]);
    return (0, $42omo.useMemo)(()=>{
        const plugins = [];
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomBetaEnabled = (0, $c6GJD.default).checkGate('confluence_loom_beta_enabled');
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isLoomM25Enabled = (0, $c6GJD.default).checkGate('confluence_frontend_loom_cross_sell');
        // Add plugin for current product as the first tab, if we have a supported tab for it
        // We are assuming that if a product is the current product and we have a supported tab, it's in available products
        // (eg. we assume if you're in Jira, Jira will be in available products)
        if (currentProduct && (0, $3FTlm.isSupportedCurrentProduct)(currentProduct)) plugins.push(configMap[currentProduct]);
        return {
            isLoading: isLoading,
            atlassianPluginsConfig: [
                ...plugins,
                ...(0, $3FTlm.supportedCurrentProducts)// Exclude the current product, we've already included it above if theres a matching config available
                .filter((product)=>currentProduct !== product)// Exclude 'Atlas' tab is there is already a 'Home' tab
                .filter((product)=>{
                    if (currentProduct === 'townsquare') return product !== 'atlas';
                    return !!product;
                })// Remove any products that did not appear in the list of availableProducts
                // Does not factor in the currentProduct, that will still be in the resulting array as it
                // has been included seperately above
                .filter((product)=>product === 'loom' && isLoomBetaEnabled || availableProducts.some((availableProduct)=>product === (0, $3FTlm.lookupCurrentProductByProduct)(availableProduct) && (product !== 'loom' || isLoomM25Enabled)))// Map product strings to their defined config in the config map
                .map((product)=>configMap[product])
            ]
        };
    }, [
        configMap,
        availableProducts,
        currentProduct,
        isLoading
    ]);
};
const $a7827c25df0a1c01$export$45a18a62e79260ff = (config)=>{
    const { atlassianPluginsConfig: atlassianPluginsConfig, isLoading: isLoading } = $a7827c25df0a1c01$export$ede9abe489c9321b(config);
    const plugins = (0, $1C4cT.useAtlassianPlugins)(atlassianPluginsConfig);
    return {
        plugins: plugins,
        isLoading: isLoading
    };
};
module.exports["useLinkPickerPlugins"] = $a7827c25df0a1c01$export$45a18a62e79260ff;

});

parcelRegister("1C4cT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8fW0f = parcelRequire("8fW0f");

const $1ff157185fb6e44c$export$679584c8d36ab911 = (configs)=>{
    const [atlassianPlugins] = (0, $42omo.useState)(()=>new WeakMap());
    return (0, $42omo.useMemo)(()=>configs.map((config)=>{
            const existingPlugin = atlassianPlugins.get(config);
            if (existingPlugin) return existingPlugin;
            // If we haven't already created a plugin for this config, create one now
            // and store it in the map.
            const newPlugin = new (0, $8fW0f.default)(config);
            atlassianPlugins.set(config, newPlugin);
            return newPlugin;
        }), [
        atlassianPlugins,
        configs
    ]);
};
module.exports["useAtlassianPlugins"] = $1ff157185fb6e44c$export$679584c8d36ab911;

});

parcelRegister("3FTlm", function(module, exports) {
/**
 * Product key returned by /available_sites data. We are only interested in
 * 'townsquare' (Atlas), 'confluence.ondemand' or 'jira-software.ondemand' currently.
 */ const $c011f3c2795ed007$export$2db74afa1ef496f1 = [
    'jira-core.ondemand',
    'jira-incident-manager.ondemand',
    'jira-product-discovery',
    'jira-servicedesk.ondemand',
    'jira-software.ondemand',
    'confluence.ondemand',
    'townsquare',
    'loom'
];
const $c011f3c2795ed007$export$15d6fc53154f51b3 = [
    'loom',
    'jira',
    'confluence',
    'atlas',
    'townsquare'
];
const $c011f3c2795ed007$var$suportedCurrentProductMap = {
    'jira-core.ondemand': 'jira',
    'jira-incident-manager.ondemand': 'jira',
    'jira-product-discovery': 'jira',
    'jira-servicedesk.ondemand': 'jira',
    'jira-software.ondemand': 'jira',
    'confluence.ondemand': 'confluence',
    townsquare: 'atlas',
    loom: 'loom'
};
function $c011f3c2795ed007$export$40cf7a2a01d13d9d(str) {
    const strings = $c011f3c2795ed007$export$15d6fc53154f51b3;
    return strings.includes(str);
}
function $c011f3c2795ed007$export$7e250790d0036a52(product) {
    // Product may not be in supportedProducts array, that's what this is checking
    if (!(product in $c011f3c2795ed007$var$suportedCurrentProductMap)) return undefined;
    return $c011f3c2795ed007$var$suportedCurrentProductMap[product];
}
module.exports["supportedCurrentProducts"] = $c011f3c2795ed007$export$15d6fc53154f51b3;
module.exports["isSupportedCurrentProduct"] = $c011f3c2795ed007$export$40cf7a2a01d13d9d;
module.exports["lookupCurrentProductByProduct"] = $c011f3c2795ed007$export$7e250790d0036a52;

});

parcelRegister("d4Mwr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kiOFr = parcelRequire("kiOFr");

const $30f10d0a027e62a0$export$5afbfe6edea8e998 = (cloudId)=>{
    const { data: data, loading: isLoading } = (0, $kiOFr.useAvailableSites)();
    return {
        availableProducts: (0, $42omo.useMemo)(()=>{
            if (!data.length) return [];
            if (cloudId) return data.find((site)=>site.cloudId === cloudId)?.products ?? [];
            // Get all the products from all sites and deduplicate
            return Array.from(data.reduce((prev, curr)=>{
                return new Set([
                    ...curr.products,
                    ...Array.from(prev)
                ]);
            }, new Set()));
        }, [
            data,
            cloudId
        ]),
        isLoading: isLoading
    };
};
module.exports["useAvailableProducts"] = $30f10d0a027e62a0$export$5afbfe6edea8e998;

});

parcelRegister("i7jPX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6421b29072e9fbe0$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6421b29072e9fbe0$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6421b29072e9fbe0$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6421b29072e9fbe0$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6421b29072e9fbe0$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
function $6421b29072e9fbe0$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ $42omo.createElement("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $gMc0m.default)([
            $6421b29072e9fbe0$var$styles.root,
            $6421b29072e9fbe0$var$sizeMap[size],
            isInset ? $6421b29072e9fbe0$var$styles.inset : $6421b29072e9fbe0$var$styles.nonInset,
            isInset && $6421b29072e9fbe0$var$insetSizeMap[size],
            $6421b29072e9fbe0$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6421b29072e9fbe0$var$styles.border
        ])
    }, children);
}

});

parcelRegister("9SMct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8jHAi = parcelRequire("8jHAi");


var $7CgcZ = parcelRequire("7CgcZ");

const $3c9171fc16956912$var$PageIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), 'blueBold');
$3c9171fc16956912$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $3c9171fc16956912$export$2e2bcd8739ae039 = $3c9171fc16956912$var$PageIconWithColor;
module.exports["default"] = $3c9171fc16956912$export$2e2bcd8739ae039;

});

parcelRegister("7CgcZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7642E = parcelRequire("7642E");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $ivUmx = parcelRequire("ivUmx");

/**
 * Maps IconTile appearance to the icon glyph color token to use when rendering
 * a standalone icon (without a tile background).
 */ const $6846287c8ee6bf50$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $6846287c8ee6bf50$export$3acc3fb10995f020 = (size)=>{
    if ((0, $dh538.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $5TXU5.SmartLinkSize).Small:
        case (0, $5TXU5.SmartLinkSize).Medium:
            return undefined;
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'small';
        default:
            // SmartLinkSize.Small, SmartLinkSize.Medium, and undefined all
            // previously mapped to size="16" which has been removed. Render
            // the icon directly (no tile) for these sizes.
            return undefined;
    }
};
const $6846287c8ee6bf50$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ((0, $ivUmx.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ObjectIcon, props);
    };
};
const $6846287c8ee6bf50$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = $6846287c8ee6bf50$export$3acc3fb10995f020(size);
        if (tileSize === undefined) {
            // size="16" has been removed — render the icon directly without a tile,
            // using the appearance-derived color so it still matches the intended style.
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                color: $6846287c8ee6bf50$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { shape: _shape, UNSAFE_circleReplacementComponent: _unsafe, ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7642E.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $6846287c8ee6bf50$export$3acc3fb10995f020;
module.exports["renderIconPerSize"] = $6846287c8ee6bf50$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $6846287c8ee6bf50$export$87c3646d0e299cfe;

});

parcelRegister("j6GAe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
}

});

parcelRegister("fAGae", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("7r4Rz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $6iY4P = parcelRequire("6iY4P");


var $j6GAe = parcelRequire("j6GAe");


var $7CgcZ = parcelRequire("7CgcZ");

const $a1b21c3b6fc75776$var$BlogIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $6iY4P.default), (0, $j6GAe.default));
$a1b21c3b6fc75776$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $a1b21c3b6fc75776$export$2e2bcd8739ae039 = $a1b21c3b6fc75776$var$BlogIconWithColor;
module.exports["default"] = $a1b21c3b6fc75776$export$2e2bcd8739ae039;

});

parcelRegister("GFtWS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
// This file is the FG-OFF fallback for platform_sl_icons_refactor.
// Delete this file when platform_sl_icons_refactor is cleaned up.

var $66dpz = parcelRequire("66dpz");


var $fAGae = parcelRequire("fAGae");


var $7CgcZ = parcelRequire("7CgcZ");

const $fc75dd15b55d0661$var$LiveDocumentIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $66dpz.default), (0, $fAGae.default));
$fc75dd15b55d0661$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $fc75dd15b55d0661$export$2e2bcd8739ae039 = $fc75dd15b55d0661$var$LiveDocumentIconWithColor;
module.exports["default"] = $fc75dd15b55d0661$export$2e2bcd8739ae039;

});

parcelRegister("2tvDK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25c067814582e1346f67a8106048fd7b>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $2ISy2 = parcelRequire("2ISy2");


var $fP78j = parcelRequire("fP78j");

function $ab5e2ffbeed9f2f4$export$2e2bcd8739ae039({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ISy2))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
}

});

parcelRegister("9Q0L0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4648df99867255b9e8ae22693a4d25a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $4SWbm = parcelRequire("4SWbm");


var $fP78j = parcelRequire("fP78j");

function $4cf8a3e1f7af7bd1$export$2e2bcd8739ae039({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4SWbm))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
}

});

parcelRegister("kMqyt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $cb2f9539166b293e$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30f3baace5bcd49b8a2c522228cf7a06>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $2qVkt = parcelRequire("2qVkt");


var $fP78j = parcelRequire("fP78j");

function $cb2f9539166b293e$export$2e2bcd8739ae039({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qVkt))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("lWQXA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d00f1f002e9877f9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::64afc1ac758289e96d875e903d67be0d>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $kR5QY = parcelRequire("kR5QY");


var $fP78j = parcelRequire("fP78j");

function $d00f1f002e9877f9$export$2e2bcd8739ae039({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kR5QY))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
}

});

parcelRegister("fX4W8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $042d51f21cf4898d$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2862d801ef69d165822b8118797782a>>
 * @codegenCommand yarn build-glyphs
 */ 
var $42omo = parcelRequire("42omo");


var $dmbve = parcelRequire("dmbve");


var $fP78j = parcelRequire("fP78j");

function $042d51f21cf4898d$export$2e2bcd8739ae039({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("2LWAa", function(module, exports) {
const $c909c594c41baf78$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};
module.exports["canShowAction"] = $c909c594c41baf78$export$2487b058456cca75;

});

parcelRegister("7hXqf", function(module, exports) {
/**
 * Options required to prioritise which icon to show
 */ function $776748d0c66c7fba$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}
module.exports["prioritiseIcon"] = $776748d0c66c7fba$export$65e47eb22a387a86;

});

parcelRegister("fHhRu", function(module, exports) {

var $15w8R = parcelRequire("15w8R");

const $0f61633c27d66d37$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $15w8R.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};
module.exports["extractIsSupportTheming"] = $0f61633c27d66d37$export$38d755f52cdf4acb;

});

parcelRegister("15w8R", function(module, exports) {
const $c903d02fdad660aa$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $c903d02fdad660aa$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $c903d02fdad660aa$export$84a73a0383f58180 = 'JiraTask';
const $c903d02fdad660aa$export$c6c83963a9378a67 = 'JiraSubTask';
const $c903d02fdad660aa$export$58af3c426c111a6d = 'JiraStory';
const $c903d02fdad660aa$export$ac9898a63417219e = 'JiraBug';
const $c903d02fdad660aa$export$54db5e3fb12e39cd = 'JiraEpic';
const $c903d02fdad660aa$export$2f54a5a217202c85 = 'JiraIncident';
const $c903d02fdad660aa$export$d097371052bfc411 = 'JiraServiceRequest';
const $c903d02fdad660aa$export$efd9452ad16c6676 = 'JiraChange';
const $c903d02fdad660aa$export$2e7e70abb5d81f67 = 'JiraProblem';
const $c903d02fdad660aa$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $c903d02fdad660aa$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider',
    'avpviz-object-provider'
];
module.exports["CONFLUENCE_GENERATOR_ID"] = $c903d02fdad660aa$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $c903d02fdad660aa$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $c903d02fdad660aa$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $c903d02fdad660aa$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $c903d02fdad660aa$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $c903d02fdad660aa$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $c903d02fdad660aa$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $c903d02fdad660aa$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $c903d02fdad660aa$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $c903d02fdad660aa$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $c903d02fdad660aa$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $c903d02fdad660aa$export$ce25cfc40b280dbc;
module.exports["PROVIDER_KEYS_WITH_THEMING"] = $c903d02fdad660aa$export$fe44ce30fd8d131b;

});

parcelRegister("cUjGA", function(module, exports) {
const $b09d72911e8b5283$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};
module.exports["extractIsTrusted"] = $b09d72911e8b5283$export$4f3ffbb500daac5a;

});

parcelRegister("8sXiv", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");

const $50b1c4035dc2416d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $a1WXB.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
module.exports["extractTaskType"] = $50b1c4035dc2416d$export$ed3fd59180514d27;

});

parcelRegister("uAXxz", function(module, exports) {
const $2e2993a3a04453b8$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
module.exports["extractorPriorityMap"] = $2e2993a3a04453b8$export$e0deaeb4a2dfe2b4;

});

parcelRegister("eB2Ls", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");


var $5TXU5 = parcelRequire("5TXU5");





var $226XV = parcelRequire("226XV");


var $ivUmx = parcelRequire("ivUmx");


var $2LWAa = parcelRequire("2LWAa");


var $fcTJU = parcelRequire("fcTJU");

const $dd9cc1ea5f7a02ad$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2LWAa.canShowAction)((0, $5TXU5.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $fcTJU.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $a1WXB.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $ivUmx.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5TXU5.ActionName).DownloadAction,
            definitionId: (0, $226XV.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $226XV.getExtensionKey)(response),
            id: id,
            resourceType: (0, $226XV.getResourceType)(response)
        };
    }
};
module.exports["extractInvokeDownloadAction"] = $dd9cc1ea5f7a02ad$export$ea97cd34c2ca86de;

});

parcelRegister("fcTJU", function(module, exports) {
const $bcab3e29f50fe6bc$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
module.exports["getActionsFromJsonLd"] = $bcab3e29f50fe6bc$export$8f031784a3a03b23;

});

parcelRegister("4gOU2", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");


var $7ee1w = parcelRequire("7ee1w");


var $1oCLl = parcelRequire("1oCLl");


var $5TXU5 = parcelRequire("5TXU5");





var $226XV = parcelRequire("226XV");


var $2LWAa = parcelRequire("2LWAa");


var $29GtD = parcelRequire("29GtD");


var $fHhRu = parcelRequire("fHhRu");


var $cUjGA = parcelRequire("cUjGA");


var $575f6 = parcelRequire("575f6");


var $eB2Ls = parcelRequire("eB2Ls");


var $dOvUN = parcelRequire("dOvUN");

const $0216c8d70d641474$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $a1WXB.extractSmartLinkAri)(response);
    const url = (0, $a1WXB.extractSmartLinkUrl)(response);
    const name = (0, $a1WXB.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $7ee1w.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $2LWAa.canShowAction)((0, $5TXU5.CardAction).PreviewAction, actionOptions)) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (0, $a1WXB.extractPreview)(data, 'web')?.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel) return;
    if (src) {
        const extensionKey = (0, $226XV.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $a1WXB.extractSmartLinkEmbed)(response)?.src : undefined
                            }
                        });
                        (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        await (0, $29GtD.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $eB2Ls.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $dOvUN.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $fHhRu.extractIsSupportTheming)(meta),
                            isTrusted: (0, $cUjGA.extractIsTrusted)(meta),
                            linkIcon: (0, $575f6.extractLinkIcon)(response),
                            providerName: (0, $a1WXB.extractSmartLinkProvider)(response)?.text,
                            onClose: onClose,
                            origin: origin,
                            src: (0, $a1WXB.extractSmartLinkEmbed)(response)?.src,
                            title: (0, $a1WXB.extractSmartLinkTitle)(response),
                            url: url,
                            size: actionOptions?.previewAction?.size,
                            isBlanketHidden: actionOptions?.previewAction?.hideBlanket,
                            ...(0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $5TXU5.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};
module.exports["extractInvokePreviewAction"] = $0216c8d70d641474$export$caf83f49e52ac0bb;

});

parcelRegister("7ee1w", function(module, exports) {
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $0342f45c1f755179$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $0342f45c1f755179$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $0342f45c1f755179$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $0342f45c1f755179$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $0342f45c1f755179$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $0342f45c1f755179$var$getUrlSearchParams(currentSearch);
            if (currentParams && $0342f45c1f755179$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $0342f45c1f755179$export$24def1b22639c691 = ()=>{
    return $0342f45c1f755179$export$9f140ed41af5108c() && $0342f45c1f755179$export$f274fcef361fe59d();
};
module.exports["isWithinPreviewPanelIFrame"] = $0342f45c1f755179$export$24def1b22639c691;

});

parcelRegister("29GtD", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $aXWIB = parcelRequire("aXWIB");

const $76698d8a364f0519$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $76698d8a364f0519$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $76698d8a364f0519$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($76698d8a364f0519$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $76698d8a364f0519$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("hfxZS"));
    (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal.default, {
        ...props,
        iframeName: $76698d8a364f0519$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}
module.exports["openEmbedModal"] = $76698d8a364f0519$export$7859f96cd8cff034;

});

parcelRegister("hfxZS", function(module, exports) {

let $c8ee3577e7eb6b3c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c8ee3577e7eb6b3c$var$load("gfGrm"),
    $c8ee3577e7eb6b3c$var$load("24u6w"),
    $c8ee3577e7eb6b3c$var$load("bFS2f"),
    $c8ee3577e7eb6b3c$var$load("gFEtJ"),
    $c8ee3577e7eb6b3c$var$load("gT8XU"),
    $c8ee3577e7eb6b3c$var$load("iivLa"),
    $c8ee3577e7eb6b3c$var$load("6wr18"),
    $c8ee3577e7eb6b3c$var$load("ffEVr"),
    $c8ee3577e7eb6b3c$var$load("dek7I"),
    $c8ee3577e7eb6b3c$var$load("Wowvf"),
    $c8ee3577e7eb6b3c$var$load("6iz6l"),
    $c8ee3577e7eb6b3c$var$load("4SCW2"),
    $c8ee3577e7eb6b3c$var$load("fdKpi"),
    $c8ee3577e7eb6b3c$var$load("hhss7"),
    $c8ee3577e7eb6b3c$var$load("kDLrp")
]).then(()=>parcelRequire('6as51'));

});

parcelRegister("575f6", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $2CpuW = parcelRequire("2CpuW");


var $kn2iQ = parcelRequire("kn2iQ");


var $kX2ZH = parcelRequire("kX2ZH");

const $48fd38a3919fb96d$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $2CpuW.default)(data, renderers);
    return {
        ...(0, $kn2iQ.default)(data),
        render: render
    };
};
const $48fd38a3919fb96d$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kX2ZH.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5TXU5.IconType).Forbidden
            };
        case (0, $5TXU5.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5TXU5.IconType).Error
            };
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5TXU5.IconType).Default
            };
    }
};
const $48fd38a3919fb96d$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        if ((0, $a1WXB.isEntityPresent)(response)) {
            const entityIcon = (0, $a1WXB.extractEntityIcon)(response);
            if (entityIcon) return entityIcon;
        }
    } else {
        if ((0, $a1WXB.isEntityPresent)(response)) return (0, $a1WXB.extractEntityIcon)(response);
    }
    return $48fd38a3919fb96d$export$43612bed147eae48(response, renderers);
};
module.exports["extractLinkIcon"] = $48fd38a3919fb96d$export$43612bed147eae48;
module.exports["extractErrorIcon"] = $48fd38a3919fb96d$export$bdd29be9b0395931;
module.exports["extractSmartLinkIcon"] = $48fd38a3919fb96d$export$35040aed9264b11c;

});

parcelRegister("2CpuW", function(module, exports) {
const $ecff103eb394f1ce$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $ecff103eb394f1ce$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $ecff103eb394f1ce$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $ecff103eb394f1ce$export$2e2bcd8739ae039 = $ecff103eb394f1ce$var$extractIconRenderer;
module.exports["default"] = $ecff103eb394f1ce$export$2e2bcd8739ae039;

});

parcelRegister("kn2iQ", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");


var $7hXqf = parcelRequire("7hXqf");


var $uAXxz = parcelRequire("uAXxz");


var $8sXiv = parcelRequire("8sXiv");


var $15w8R = parcelRequire("15w8R");


var $2OB54 = parcelRequire("2OB54");


var $f6wMd = parcelRequire("f6wMd");


var $8fQ4N = parcelRequire("8fQ4N");


var $kX2ZH = parcelRequire("kX2ZH");


var $dVnIN = parcelRequire("dVnIN");

const $db64d56f9a1152ff$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $8sXiv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $db64d56f9a1152ff$var$extractTaskNew = (data)=>{
    const taskTypeInfo = (0, $8sXiv.extractTaskType)(data) || {};
    const { id: id, icon: url, name: name } = taskTypeInfo;
    const taskType = id?.split('#').pop();
    const taskIconLabel = name?.trim() || 'Task';
    const taskIcon = url ? {
        label: taskIconLabel,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $db64d56f9a1152ff$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $uAXxz.extractorPriorityMap)[b] - (0, $uAXxz.extractorPriorityMap)[a])[0] : type;
};
const $db64d56f9a1152ff$var$isJiraProvider = (provider)=>provider === (0, $15w8R.JIRA_GENERATOR_ID);
function $db64d56f9a1152ff$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $f6wMd.default)(fileFormat);
    if ((0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const iconDescriptor = $db64d56f9a1152ff$var$typeToIconDescriptor({
            type: type,
            providerId: providerId,
            data: data
        });
        const documentTitle = (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? undefined : (0, $a1WXB.extractTitle)(data);
        const extractedDocumentTypeIcon = (0, $2OB54.default)(type, documentTitle, providerId);
        const documentTypeIcon = iconDescriptor || extractedDocumentTypeIcon;
        const urlIconNew = (0, $dVnIN.default)(data.icon, documentTypeIcon?.label);
        return (0, $7hXqf.prioritiseIcon)({
            fileFormatIcon: fileFormatIcon,
            documentTypeIcon: documentTypeIcon,
            urlIcon: urlIconNew,
            providerIcon: providerIcon
        });
    } else {
        const documentTypeIcon = $db64d56f9a1152ff$var$typeToIconDescriptor({
            type: type,
            label: label,
            providerId: providerId,
            data: data
        }) || (0, $2OB54.default)(type, label, providerId);
        return (0, $7hXqf.prioritiseIcon)({
            fileFormatIcon: fileFormatIcon,
            documentTypeIcon: documentTypeIcon,
            urlIcon: urlIcon,
            providerIcon: providerIcon
        });
    }
}
function $db64d56f9a1152ff$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    const descriptorLabel = (semantic)=>(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : label;
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $5TXU5.IconType).Task,
                label: descriptorLabel('goal')
            };
        case 'atlassian:Project':
            return {
                // FIXME: atlassian:Project seem to be returned for many things, including Confluence space or Trello board,
                // But `IconType.Project` actual value is `BitBucket:Project`!
                icon: (0, $5TXU5.IconType).Project,
                label: descriptorLabel('project')
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $5TXU5.IconType).Commit,
                label: descriptorLabel('commit')
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $5TXU5.IconType).PullRequest,
                label: descriptorLabel('pull request')
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $5TXU5.IconType).Branch,
                label: descriptorLabel('branch')
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $5TXU5.IconType).Repo,
                label: descriptorLabel('repository')
            };
        case 'atlassian:Task':
            if ((0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y')) {
                const taskIconDescriptor = {
                    icon: (0, $5TXU5.IconType).Task,
                    label: descriptorLabel('task')
                };
                if ($db64d56f9a1152ff$var$isJiraProvider(providerId)) {
                    const { taskType: taskType, taskIcon: taskIcon } = $db64d56f9a1152ff$var$extractTaskNew(data);
                    return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $8fQ4N.default)(taskType);
                }
                return taskIconDescriptor;
            } else {
                const taskLabel = label || 'Task';
                const taskIconDescriptor = {
                    icon: (0, $5TXU5.IconType).Task,
                    label: taskLabel
                };
                if ($db64d56f9a1152ff$var$isJiraProvider(providerId)) {
                    const { taskType: taskType, taskIcon: taskIcon } = $db64d56f9a1152ff$var$extractTask(data);
                    return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $8fQ4N.default)(taskType, taskLabel);
                }
                return taskIconDescriptor;
            }
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $db64d56f9a1152ff$var$extractJsonldDataIcon = (data)=>{
    if ((0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const type = $db64d56f9a1152ff$var$extractType(data);
        const providerIcon = (0, $kX2ZH.default)(data);
        return $db64d56f9a1152ff$var$chooseIcon({
            type: type,
            data: data,
            providerIcon: providerIcon
        });
    } else {
        const label = (0, $a1WXB.extractTitle)(data);
        const type = $db64d56f9a1152ff$var$extractType(data);
        const urlIcon = (0, $dVnIN.default)(data.icon, label);
        const providerIcon = (0, $kX2ZH.default)(data);
        return $db64d56f9a1152ff$var$chooseIcon({
            urlIcon: urlIcon,
            providerIcon: providerIcon,
            type: type,
            label: label,
            data: data
        });
    }
};
var $db64d56f9a1152ff$export$2e2bcd8739ae039 = $db64d56f9a1152ff$var$extractJsonldDataIcon;
module.exports["default"] = $db64d56f9a1152ff$export$2e2bcd8739ae039;

});

parcelRegister("2OB54", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");


var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");

/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $43d4ba8ed352f0e6$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    const getLabel = (hardcodedLabel)=>(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? hardcodedLabel : label;
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $5TXU5.IconType).Blog,
                label: getLabel('blog')
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $a1WXB.isConfluenceGenerator)(providerId)) return {
                icon: (0, $5TXU5.IconType).LiveDocument,
                label: getLabel('live document')
            };
            else return {
                icon: (0, $5TXU5.IconType).File,
                label: getLabel('file')
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $5TXU5.IconType).Document,
                label: getLabel('document')
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $5TXU5.IconType).Presentation,
                label: getLabel('presentation')
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $5TXU5.IconType).Spreadsheet,
                label: getLabel('spreadsheet')
            };
        case 'atlassian:Template':
            return {
                icon: (0, $5TXU5.IconType).Template,
                label: getLabel('template')
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $5TXU5.IconType).Document,
                label: getLabel('document')
            };
        default:
            return undefined;
    }
};
var $43d4ba8ed352f0e6$export$2e2bcd8739ae039 = $43d4ba8ed352f0e6$var$extractDocumentTypeIcon;
module.exports["default"] = $43d4ba8ed352f0e6$export$2e2bcd8739ae039;

});

parcelRegister("8fQ4N", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $5TXU5 = parcelRequire("5TXU5");

const $3057ac52417f53cb$var$extractJiraTaskIcon = (taskType, label)=>{
    const getLabel = (hardcodedLabel)=>(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? hardcodedLabel : label || 'Task';
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5TXU5.IconType).Bug,
                label: getLabel('Bug')
            };
        case 'JiraChange':
            return {
                icon: (0, $5TXU5.IconType).Change,
                label: getLabel('Change')
            };
        case 'JiraEpic':
            return {
                icon: (0, $5TXU5.IconType).Epic,
                label: getLabel('Epic')
            };
        case 'JiraIncident':
            return {
                icon: (0, $5TXU5.IconType).Incident,
                label: getLabel('Incident')
            };
        case 'JiraProblem':
            return {
                icon: (0, $5TXU5.IconType).Problem,
                label: getLabel('Problem')
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5TXU5.IconType).ServiceRequest,
                label: getLabel('Service request')
            };
        case 'JiraStory':
            return {
                icon: (0, $5TXU5.IconType).Story,
                label: getLabel('Story')
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5TXU5.IconType).SubTask,
                label: getLabel('Sub-task')
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5TXU5.IconType).Task,
                label: getLabel('Task')
            };
    }
};
var $3057ac52417f53cb$export$2e2bcd8739ae039 = $3057ac52417f53cb$var$extractJiraTaskIcon;
module.exports["default"] = $3057ac52417f53cb$export$2e2bcd8739ae039;

});

parcelRegister("kX2ZH", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");


var $5TXU5 = parcelRequire("5TXU5");


var $15w8R = parcelRequire("15w8R");


var $dVnIN = parcelRequire("dVnIN");

/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $65f5e55fe221e038$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $a1WXB.extractTitle)(data);
    if (provider === (0, $15w8R.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5TXU5.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $15w8R.JIRA_GENERATOR_ID)) return {
        icon: (0, $5TXU5.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $dVnIN.default)(icon, label);
};
var $65f5e55fe221e038$export$2e2bcd8739ae039 = $65f5e55fe221e038$var$extractProviderIcon;
const $65f5e55fe221e038$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $a1WXB.isEntityPresent)(response)) {
        const provider = (0, $a1WXB.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $15w8R.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5TXU5.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $15w8R.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5TXU5.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $a1WXB.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $65f5e55fe221e038$var$extractProviderIcon(response.data);
};
module.exports["default"] = $65f5e55fe221e038$export$2e2bcd8739ae039;
module.exports["extractSmartLinkProviderIcon"] = $65f5e55fe221e038$export$5def189f04eea025;

});

parcelRegister("dVnIN", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");

/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $1af37185996e64e9$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $a1WXB.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $1af37185996e64e9$export$2e2bcd8739ae039 = $1af37185996e64e9$var$extractUrlIcon;
module.exports["default"] = $1af37185996e64e9$export$2e2bcd8739ae039;

});

parcelRegister("dOvUN", function(module, exports) {

var $a1WXB = parcelRequire("a1WXB");


var $5TXU5 = parcelRequire("5TXU5");


var $226XV = parcelRequire("226XV");


var $ivUmx = parcelRequire("ivUmx");


var $2LWAa = parcelRequire("2LWAa");


var $fcTJU = parcelRequire("fcTJU");

const $7b2d7b35c23c90ae$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2LWAa.canShowAction)((0, $5TXU5.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $a1WXB.extractLink)(data);
    const viewActionExists = (0, $fcTJU.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $ivUmx.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $226XV.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $226XV.getExtensionKey)(response),
        id: id,
        resourceType: (0, $226XV.getResourceType)(response)
    };
};
module.exports["extractInvokeViewAction"] = $7b2d7b35c23c90ae$export$88c5813cfbbe4e4c;

});

parcelRegister("bUp2E", function(module, exports) {

var $caPHA = parcelRequire("caPHA");

const $4ebff2946cad2a83$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $4ebff2946cad2a83$var$TEAM_SUBJECT = 'teamProfileCard';
const $4ebff2946cad2a83$var$USER_SUBJECT = 'profilecard';
const $4ebff2946cad2a83$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */ const $4ebff2946cad2a83$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $caPHA.getPageTime)())
        }
    });
const $4ebff2946cad2a83$export$6f40cdf6d42c018d = (type)=>{
    switch(type){
        case 'user':
            return $4ebff2946cad2a83$var$USER_SUBJECT;
        case 'team':
            return $4ebff2946cad2a83$var$TEAM_SUBJECT;
        case 'agent':
            return $4ebff2946cad2a83$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $4ebff2946cad2a83$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $4ebff2946cad2a83$var$createEvent('ui', 'triggered', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $4ebff2946cad2a83$export$c9b0e37b229a297b = (action, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$TEAM_SUBJECT, 'request', attributes);
const $4ebff2946cad2a83$export$12dae48763368ac9 = (action, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$USER_SUBJECT, 'request', attributes);
const $4ebff2946cad2a83$export$41816a317479160b = (type, actionSubjectId, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'rendered', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), actionSubjectId, attributes);
const $4ebff2946cad2a83$export$fdcd134fbeb1f921 = (type, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), 'action', attributes);
const $4ebff2946cad2a83$export$93260987012593be = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$USER_SUBJECT, 'reportingLines', attributes);
const $4ebff2946cad2a83$export$79befd155063a6a7 = (type, attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$export$6f40cdf6d42c018d(type), 'moreActions', attributes);
const $4ebff2946cad2a83$export$2703289b35687fde = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'avatar', attributes);
const $4ebff2946cad2a83$export$b4411a7661cf2d3f = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $4ebff2946cad2a83$export$c86679da702d560e = (attributes)=>$4ebff2946cad2a83$var$createEvent('ui', 'clicked', $4ebff2946cad2a83$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $4ebff2946cad2a83$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$4ebff2946cad2a83$var$createEvent('operational', action, $4ebff2946cad2a83$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);
module.exports["PACKAGE_META_DATA"] = $4ebff2946cad2a83$export$849551cf61929d4f;
module.exports["getActionSubject"] = $4ebff2946cad2a83$export$6f40cdf6d42c018d;

});

parcelRegister("caPHA", function(module, exports) {
const $156cb4b98a287aa0$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $156cb4b98a287aa0$var$performanceAvailable = $156cb4b98a287aa0$var$isPerformanceAvailable();
const $156cb4b98a287aa0$var$initialPageTime = Date.now();
const $156cb4b98a287aa0$export$e9faea7c41053334 = ()=>{
    if ($156cb4b98a287aa0$var$performanceAvailable) return performance.now();
    return Date.now() - $156cb4b98a287aa0$var$initialPageTime;
};
module.exports["getPageTime"] = $156cb4b98a287aa0$export$e9faea7c41053334;

});

parcelRegister("3H8bj", function(module, exports) {
const $7dc5183756e8ff90$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $7dc5183756e8ff90$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($7dc5183756e8ff90$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $7dc5183756e8ff90$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $7dc5183756e8ff90$export$3761e66a04602cbd;

});

parcelRegister("fDXXi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::8fac3764027ac11183c7483636135d9a>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $3rIQe = parcelRequire("3rIQe");


var $KKFWL = parcelRequire("KKFWL");

const $e5e4133608950b34$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $KKFWL.default)(...params));
        event.fire((0, $3rIQe.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $e5e4133608950b34$export$5bf35293e545f20c;

});

parcelRegister("3rIQe", function(module, exports) {
const $10cdf05152c4d491$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $10cdf05152c4d491$export$3f072f06b90c3985;

});

parcelRegister("KKFWL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::d33f3d33520a5e35881ec61f3c089abb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ const $0ce3610ad559befd$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $0ce3610ad559befd$export$2e2bcd8739ae039 = $0ce3610ad559befd$var$createEventPayload;
module.exports["default"] = $0ce3610ad559befd$export$2e2bcd8739ae039;

});

parcelRegister("2qY37", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $118484dfd30546b5$var$messages = (0, $aXWIB.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $118484dfd30546b5$export$2e2bcd8739ae039 = $118484dfd30546b5$var$messages;
module.exports["default"] = $118484dfd30546b5$export$2e2bcd8739ae039;

});

parcelRegister("exN3e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $7yDmn = parcelRequire("7yDmn");


var $iXCQx = parcelRequire("iXCQx");


var $2qY37 = parcelRequire("2qY37");


var $aHGHx = parcelRequire("aHGHx");


var $bUp2E = parcelRequire("bUp2E");

const $bcf90d0eb3671370$var$ErrorMessage = (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $42omo.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $bUp2E.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aHGHx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorUserNotFound));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aHGHx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorGeneric), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorRetrySuggestion)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aHGHx.ErrorWrapper), {
        testId: "profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
        label: "icon error"
    }), errorContent(), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        onClick: reload
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $2qY37.default).errorTryAgain)));
};
var $bcf90d0eb3671370$export$2e2bcd8739ae039 = $bcf90d0eb3671370$var$ErrorMessage;
module.exports["default"] = $bcf90d0eb3671370$export$2e2bcd8739ae039;

});

parcelRegister("aHGHx", function(module, exports) {
/* Error.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");

const $5321d44dec43675e$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_19pku2gc",
    teamErrorText: "_syaz1rpy _19pku2gc"
};
const $5321d44dec43675e$export$bb27b7e39840238f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($5321d44dec43675e$var$styles.errorWrapper),
        ...props
    });
const $5321d44dec43675e$export$b065fd053267ec81 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $5321d44dec43675e$var$styles.errorTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text"
    }, props.children));
const $5321d44dec43675e$export$90d92ccfb27352c6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($5321d44dec43675e$var$styles.teamErrorText)
    }, props.children);
module.exports["ErrorWrapper"] = $5321d44dec43675e$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $5321d44dec43675e$export$b065fd053267ec81;
module.exports["TeamErrorText"] = $5321d44dec43675e$export$90d92ccfb27352c6;

});

parcelRegister("3nj6t", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $dWjpO = parcelRequire("dWjpO");


var $ay6Zz = parcelRequire("ay6Zz");


var $fDXXi = parcelRequire("fDXXi");


var $3H8bj = parcelRequire("3H8bj");


var $exN3e = parcelRequire("exN3e");


var $lFfRz = parcelRequire("lFfRz");


var $joVWg = parcelRequire("joVWg");

const $92606fc73eb2626b$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $42omo.useState)();
    // Initialize as true when fix is enabled since we fetch immediately on mount,
    // avoiding a brief error screen flash before the useEffect fires.
    const [isLoading, setIsLoading] = (0, $42omo.useState)((0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash'));
    const [error, setError] = (0, $42omo.useState)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const creatorUserId = (0, $42omo.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $3H8bj.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $ay6Zz.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $42omo.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = (0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash') ? creator_type === 'CUSTOMER' && creator ? (0, $3H8bj.getAAIDFromARI)(creator) : undefined : creatorUserId;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                if ((0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash')) profileHref = (0, $ay6Zz.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $dWjpO.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $dh538.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $42omo.useEffect)(()=>{
        if (!((0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash'))) return;
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $dh538.fg)('confluence_fix_agent_profile_card_flash')) return;
        fetchData();
    }, [
        fetchData
    ]);
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lFfRz.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $exN3e.default), {
        reload: ()=>{
            fetchData();
        },
        errorType: error || null,
        fireAnalytics: fireEvent
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $joVWg.AgentProfileCardLazy), {
        agent: agentData,
        isLoading: isLoading,
        hasError: !!error,
        onConversationStartersClick: props.onConversationStartersClick,
        onChatClick: props.onChatClick,
        addFlag: props.addFlag,
        resourceClient: props.resourceClient,
        cloudId: props.cloudId,
        onDeleteAgent: props.onDeleteAgent,
        hideMoreActions: props.hideMoreActions,
        hideAiDisclaimer: props.hideAiDisclaimer,
        hideConversationStarters: props.hideConversationStarters,
        hideAgentActions: props.hideAgentActions
    }));
};
module.exports["AgentProfileCardResourced"] = $92606fc73eb2626b$export$4b013ffffcb40af8;

});

parcelRegister("dWjpO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $cO1el = parcelRequire("cO1el");


var $2Nwuj = parcelRequire("2Nwuj");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $3gadb = parcelRequire("3gadb");


var $f3WwA = parcelRequire("f3WwA");


var $99GMb = parcelRequire("99GMb");


var $bOrYy = parcelRequire("bOrYy");


var $5sLX8 = parcelRequire("5sLX8");

const $c7d46d6df90d8d02$var$styles = {
    clickableItem: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    rovoIconWrapper: "_1e0c1txw",
    name: "_1bah1yb4 _4cvr1y6m",
    description: "_1mouze3t _1i4qfg65 _1nmz1hna",
    headingWrapper: "_kqswh2mm",
    hiddenIconWrapper: "_19pkv77o"
};
const $c7d46d6df90d8d02$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $dh538.fg)('rovo_agent_support_a2a_avatar') ? (0, $bOrYy.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $dh538.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $c7d46d6df90d8d02$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Nwes.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank"
            }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, $5sLX8.messages).agentDeactivated))
        });
        if (creator.type === 'REMOTE_A2A') return formatMessage((0, $5sLX8.messages).remoteAgentCreatedBy, {
            creatorNameWithLink: creator.name
        });
         // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $5sLX8.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    if ((0, $dh538.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c7d46d6df90d8d02$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $c7d46d6df90d8d02$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c7d46d6df90d8d02$var$styles.clickableItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c7d46d6df90d8d02$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $c7d46d6df90d8d02$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        xcss: $c7d46d6df90d8d02$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.075",
        xcss: $c7d46d6df90d8d02$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c7d46d6df90d8d02$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage((0, $5sLX8.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f3WwA.HiddenIcon), {
        label: formatMessage((0, $5sLX8.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99GMb.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $c7d46d6df90d8d02$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && (0, $dh538.fg)('jira_browse_agents_modal') && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $c7d46d6df90d8d02$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $c7d46d6df90d8d02$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $c7d46d6df90d8d02$export$e02348ba0b01a210;

});

parcelRegister("f3WwA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aRCWA = parcelRequire("aRCWA");

const $b7d9c8d9c2bd0031$export$bce21421c351deb1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRCWA))), props);
module.exports["HiddenIcon"] = $b7d9c8d9c2bd0031$export$bce21421c351deb1;

});

parcelRegister("99GMb", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $gI8uy = parcelRequire("gI8uy");


var $kfYj7 = parcelRequire("kfYj7");


var $fVUfS = parcelRequire("fVUfS");


var $7yZqb = parcelRequire("7yZqb");

const $1eedb87b7dc29dd4$var$styles = {
    pressableStarIcon: "_bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4t3i1tcg _1bsb1tcg",
    hidden: "_tzy4idpf"
};
const $1eedb87b7dc29dd4$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($1eedb87b7dc29dd4$var$styles.pressableStarIcon, !visible && $1eedb87b7dc29dd4$var$styles.hidden),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, isStarred || isHovered ? /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
        spacing: "spacious",
        label: formatMessage((0, $7yZqb.default).removeFromFavouritesLabel, {
            agentName: agentName
        }),
        color: "var(--ds-icon-accent-orange, #E06C00)"
    }) : /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
        spacing: "spacious",
        label: formatMessage((0, $7yZqb.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        color: "var(--ds-icon, #292A2E)"
    }));
};
module.exports["StarIconButton"] = $1eedb87b7dc29dd4$export$703abb8bd2abdfa5;

});

parcelRegister("7yZqb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $89ec1a82fbe0f7cb$var$message = (0, $aXWIB.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $89ec1a82fbe0f7cb$export$2e2bcd8739ae039 = $89ec1a82fbe0f7cb$var$message;
module.exports["default"] = $89ec1a82fbe0f7cb$export$2e2bcd8739ae039;

});

parcelRegister("bOrYy", function(module, exports) {
const $0745c744ad6a5c9d$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $0745c744ad6a5c9d$export$3055eac4de8cbd2b;

});

parcelRegister("5sLX8", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $f1c180459da2c1cd$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $f1c180459da2c1cd$export$defe85febe8b728c;

});

parcelRegister("lFfRz", function(module, exports) {
/* AgentProfileCardWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $50e0a701e5718424$var$styles = {
    wrapper: "_1bsb1gwv"
};
const $50e0a701e5718424$export$2c6604b50c274e6f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $50e0a701e5718424$var$styles.wrapper
    }, children);
};
module.exports["AgentProfileCardWrapper"] = $50e0a701e5718424$export$2c6604b50c274e6f;

});

parcelRegister("joVWg", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $2d361b33fb84f723$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3IpOU")));
module.exports["AgentProfileCardLazy"] = $2d361b33fb84f723$export$ed0ca9c1d49ea0bf;

});

parcelRegister("3IpOU", function(module, exports) {

let $2b49827ccb20778e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2b49827ccb20778e$var$load("498jr"),
    $2b49827ccb20778e$var$load("3Zwna"),
    $2b49827ccb20778e$var$load("6wr18"),
    $2b49827ccb20778e$var$load("drA4N"),
    $2b49827ccb20778e$var$load("kLPE1"),
    $2b49827ccb20778e$var$load("ffEVr"),
    $2b49827ccb20778e$var$load("7EorR"),
    $2b49827ccb20778e$var$load("jbM5v"),
    $2b49827ccb20778e$var$load("hhss7"),
    $2b49827ccb20778e$var$load("cGVng")
]).then(()=>parcelRequire('iydPT'));

});

parcelRegister("i8tPN", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $a3fRD = parcelRequire("a3fRD");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8940fb02b7c06f89$var$ErrorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$PrimaryText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_syazi7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazi7uo",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$SecondaryText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_syaz1rpy",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syaz1rpy",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$RedText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_syaz1tmw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syaz1tmw",
            __cmplp.className
        ])
    });
});
const $8940fb02b7c06f89$var$errorIconStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $8940fb02b7c06f89$export$500ff750b69ba110 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { primaryText: primaryText, secondaryText: secondaryText, isSpaceSelectionError: isSpaceSelectionError, isTagDisplayError: isTagDisplayError } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $8940fb02b7c06f89$var$errorIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)",
            spacing: "none"
        }));
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== isSpaceSelectionError || $[2] !== primaryText) {
        t2 = isSpaceSelectionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$RedText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), primaryText));
        $[1] = isSpaceSelectionError;
        $[2] = primaryText;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== isTagDisplayError || $[5] !== primaryText || $[6] !== secondaryText) {
        t3 = isTagDisplayError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$PrimaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), primaryText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$SecondaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryText)));
        $[4] = isTagDisplayError;
        $[5] = primaryText;
        $[6] = secondaryText;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$ErrorContainer, {
            "data-testid": "classification-level-error"
        }, t1, t2, t3);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ primaryText: primaryText, secondaryText: secondaryText, isSpaceSelectionError: isSpaceSelectionError, isTagDisplayError: isTagDisplayError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$ErrorContainer, {
        "data-testid": "classification-level-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $8940fb02b7c06f89$var$errorIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)",
        spacing: "none"
    })), isSpaceSelectionError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$RedText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), primaryText)), isTagDisplayError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$PrimaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), primaryText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8940fb02b7c06f89$var$SecondaryText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), secondaryText))));
module.exports["ClassificationLevelError"] = $8940fb02b7c06f89$export$500ff750b69ba110;

});

parcelRegister("2O7oS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $b3j2Y = parcelRequire("b3j2Y");


var $i8tPN = parcelRequire("i8tPN");


var $earLp = parcelRequire("earLp");


var $93WhG = parcelRequire("93WhG");

const $0a7aa4ef87c7240f$export$91f86b39c4eb641 = ({ contentLevelError: contentLevelError, spaceLevelError: spaceLevelError, primaryText: primaryText, secondaryText: secondaryText })=>{
    const { trackRenderTagError: trackRenderTagError } = (0, $earLp.useTrackClassificationAnalytics)();
    (0, $42omo.useEffect)(()=>{
        const errorMessage = [
            contentLevelError?.message,
            spaceLevelError?.message
        ].filter(Boolean).join(' | ') || 'Unknown error';
        trackRenderTagError(errorMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, contentLevelError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentLevelError
    }) : null, spaceLevelError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: spaceLevelError
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i8tPN.ClassificationLevelError), {
        primaryText: primaryText || (0, $93WhG.sharedMessages).fetchErrorTextPrimary,
        secondaryText: secondaryText || (0, $93WhG.sharedMessages).fetchErrorTextSecondary,
        isTagDisplayError: true
    }));
};
module.exports["ClassificationTagButtonError"] = $0a7aa4ef87c7240f$export$91f86b39c4eb641;

});

parcelRegister("5RPbY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1hM5R",
    name: "EditorAppearanceButtonNext",
    loader: async ()=>{
        const { EditorAppearanceButtonNext: EditorAppearanceButtonNext } = await (parcelRequire("hbcfL"));
        return EditorAppearanceButtonNext;
    }
});
module.exports["EditorAppearanceButtonNext"] = $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a;

});

parcelRegister("hbcfL", function(module, exports) {

let $c81cf802c96f79e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c81cf802c96f79e1$var$load("6wr18"),
    $c81cf802c96f79e1$var$load("dlm6q"),
    $c81cf802c96f79e1$var$load("ffEVr"),
    $c81cf802c96f79e1$var$load("7GtpA")
]).then(()=>parcelRequire('Vjn6T'));

});

parcelRegister("jPcvk", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7e7400ce50234362$export$a8e3305d336ef5aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K14-x",
    name: "EditorContentModeButton",
    loader: async ()=>{
        const { EditorContentModeButton: EditorContentModeButton } = await (parcelRequire("3rsLC"));
        return EditorContentModeButton;
    }
});
module.exports["EditorContentModeButton"] = $7e7400ce50234362$export$a8e3305d336ef5aa;

});

parcelRegister("3rsLC", function(module, exports) {

let $281a3540aa1c89c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $281a3540aa1c89c0$var$load("cC68k").then(()=>parcelRequire('iI06X'));

});

parcelRegister("5e34M", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0c67d43e155b2cd3$export$8ce5c583c1fa5a96 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rGXr0",
    name: "EmojiTitleButtonLoader",
    loader: async ()=>(await (parcelRequire("3QU6f"))).EmojiTitleButton
});
module.exports["EmojiTitleButtonLoader"] = $0c67d43e155b2cd3$export$8ce5c583c1fa5a96;

});

parcelRegister("3QU6f", function(module, exports) {

let $2ce1beb082792857$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2ce1beb082792857$var$load("kFiBp"),
    $2ce1beb082792857$var$load("6wr18"),
    $2ce1beb082792857$var$load("dlm6q"),
    $2ce1beb082792857$var$load("ffEVr"),
    $2ce1beb082792857$var$load("9Zd2C")
]).then(()=>parcelRequire('2FMo5'));

});


//# sourceMappingURL=SpaceOverviewSwitcher.8042e4b1.js.map
